
//===========================================
// THIS FILE IS AUTO-GENERATED FROM TEMPLATE. DO NOT EDIT IT DIRECTLY UNLESS YOU ALSO EDIT THE CORRESPONDING FILE IN packages/template
//===========================================
// THIS FILE IS AUTO-GENERATED BY THE `merge-quetzal-translations.ts` SCRIPT.
// DO NOT EDIT IT BY HAND.

import { typedEntries } from "@hexclave/shared/dist/utils/objects";


export const quetzalKeys = new Map(typedEntries({
  "-": "__stack-auto-translation-0",
  "A command line application is requesting access to your account. Click the button below to authorize it.": "__stack-auto-translation-1",
  "Account settings": "__stack-auto-translation-2",
  "Account Settings": "__stack-auto-translation-3",
  "Active plans": "__stack-auto-translation-4",
  "Active Sessions": "__stack-auto-translation-5",
  "Add": "__stack-auto-translation-6",
  "Add a payment method before switching plans.": "__stack-auto-translation-7",
  "Add an email": "__stack-auto-translation-8",
  "Add new passkey": "__stack-auto-translation-9",
  "Add your email address": "__stack-auto-translation-10",
  "Already have an account?": "__stack-auto-translation-11",
  "Amount": "__stack-auto-translation-12",
  "An unknown error occurred": "__stack-auto-translation-13",
  "API Key": "__stack-auto-translation-14",
  "API Keys": "__stack-auto-translation-15",
  "API keys grant programmatic access to your account.": "__stack-auto-translation-16",
  "API keys grant programmatic access to your team.": "__stack-auto-translation-17",
  "Are you sure you want to delete your account? This action is IRREVERSIBLE and will delete ALL associated data.": "__stack-auto-translation-18",
  "Are you sure you want to disable OTP sign-in? You will not be able to sign in with only emails anymore.": "__stack-auto-translation-19",
  "Are you sure you want to disable Passkey sign-in? You will not be able to sign in with your passkey anymore.": "__stack-auto-translation-20",
  "Are you sure you want to leave the team?": "__stack-auto-translation-21",
  "Authorization Failed": "__stack-auto-translation-22",
  "Authorize": "__stack-auto-translation-23",
  "Authorize CLI Application": "__stack-auto-translation-24",
  "Authorizing...": "__stack-auto-translation-25",
  "Cancel": "__stack-auto-translation-26",
  "Cancel subscription": "__stack-auto-translation-27",
  "Canceling will stop future renewals for this subscription.": "__stack-auto-translation-28",
  "change": "__stack-auto-translation-29",
  "Change plan": "__stack-auto-translation-30",
  "Change the display name of your team": "__stack-auto-translation-31",
  "Choose a plan": "__stack-auto-translation-32",
  "Choose which emails you want to receive": "__stack-auto-translation-33",
  "CLI Authorization Successful": "__stack-auto-translation-34",
  "click here": "__stack-auto-translation-35",
  "Click the button below to resend the verification link.": "__stack-auto-translation-36",
  "Close": "__stack-auto-translation-37",
  "Complete setup": "__stack-auto-translation-38",
  "Complete your account setup": "__stack-auto-translation-39",
  "Confirm": "__stack-auto-translation-40",
  "Continue": "__stack-auto-translation-41",
  "Copy it to a safe place. You will not be able to view it again.": "__stack-auto-translation-42",
  "Could not crop image.": "__stack-auto-translation-43",
  "Create": "__stack-auto-translation-44",
  "Create a new account": "__stack-auto-translation-45",
  "Create a team": "__stack-auto-translation-46",
  "Create a Team": "__stack-auto-translation-47",
  "Create API Key": "__stack-auto-translation-48",
  "Credits pack": "__stack-auto-translation-49",
  "Current Session": "__stack-auto-translation-50",
  "Current team": "__stack-auto-translation-51",
  "Danger zone": "__stack-auto-translation-52",
  "Date": "__stack-auto-translation-53",
  "Delete account": "__stack-auto-translation-54",
  "Delete Account": "__stack-auto-translation-55",
  "Delete Passkey": "__stack-auto-translation-56",
  "Description": "__stack-auto-translation-57",
  "Description is required": "__stack-auto-translation-58",
  "Disable": "__stack-auto-translation-59",
  "Disable MFA": "__stack-auto-translation-60",
  "Disable OTP": "__stack-auto-translation-61",
  "Display name": "__stack-auto-translation-62",
  "Do you want to sign in?": "__stack-auto-translation-63",
  "Do you want to verify your email?": "__stack-auto-translation-64",
  "Don't have an account?": "__stack-auto-translation-65",
  "Don't need to reset?": "__stack-auto-translation-66",
  "Draft": "__stack-auto-translation-67",
  "e.g. Development, Production, CI/CD": "__stack-auto-translation-68",
  "Email": "__stack-auto-translation-69",
  "Email & Password": "__stack-auto-translation-70",
  "Email already exists": "__stack-auto-translation-71",
  "Email is required": "__stack-auto-translation-72",
  "Email management is not available in demo mode.": "__stack-auto-translation-73",
  "Email sent!": "__stack-auto-translation-74",
  "Emails": "__stack-auto-translation-75",
  "Emails & Auth": "__stack-auto-translation-76",
  "Enable MFA": "__stack-auto-translation-77",
  "Enable OTP": "__stack-auto-translation-78",
  "Enable sign-in via magic link or OTP sent to your sign-in emails.": "__stack-auto-translation-79",
  "End your current session": "__stack-auto-translation-80",
  "Enter a display name for your new team": "__stack-auto-translation-81",
  "Enter email": "__stack-auto-translation-82",
  "Enter the code from your email": "__stack-auto-translation-83",
  "Enter the six-digit code from your authenticator app": "__stack-auto-translation-84",
  "Enter your email": "__stack-auto-translation-85",
  "Expired Magic Link": "__stack-auto-translation-86",
  "Expired Password Reset Link": "__stack-auto-translation-87",
  "Expired Team Invitation Link": "__stack-auto-translation-88",
  "Expired Verification Link": "__stack-auto-translation-89",
  "Expires": "__stack-auto-translation-90",
  "Expires In": "__stack-auto-translation-91",
  "Failed to authorize the CLI application:": "__stack-auto-translation-92",
  "Failed to connect account": "__stack-auto-translation-93",
  "Failed to reset password": "__stack-auto-translation-94",
  "Failed to reset password. Please request a new password reset link": "__stack-auto-translation-95",
  "Forgot password?": "__stack-auto-translation-96",
  "Go home": "__stack-auto-translation-97",
  "Go Home": "__stack-auto-translation-98",
  "Here is your API key.": "__stack-auto-translation-99",
  "I understand that I will not be able to view this key again.": "__stack-auto-translation-100",
  "If the user with this e-mail address exists, an e-mail was sent to your inbox. Make sure to check your spam folder.": "__stack-auto-translation-101",
  "If you are not redirected automatically, ": "__stack-auto-translation-102",
  "Ignore": "__stack-auto-translation-103",
  "Impersonation": "__stack-auto-translation-104",
  "Incorrect code. Please try again.": "__stack-auto-translation-105",
  "Incorrect password": "__stack-auto-translation-106",
  "Invalid code": "__stack-auto-translation-107",
  "Invalid image": "__stack-auto-translation-108",
  "Invalid Magic Link": "__stack-auto-translation-109",
  "Invalid Password Reset Link": "__stack-auto-translation-110",
  "Invalid Team Invitation Link": "__stack-auto-translation-111",
  "Invalid TOTP code": "__stack-auto-translation-112",
  "Invalid Verification Link": "__stack-auto-translation-113",
  "Invite a user to your team through email": "__stack-auto-translation-114",
  "Invite member": "__stack-auto-translation-115",
  "Invite User": "__stack-auto-translation-116",
  "Invoice": "__stack-auto-translation-117",
  "Invoices": "__stack-auto-translation-118",
  "IP Address": "__stack-auto-translation-119",
  "Join": "__stack-auto-translation-120",
  "Last used": "__stack-auto-translation-121",
  "Leave": "__stack-auto-translation-122",
  "Leave team": "__stack-auto-translation-123",
  "Leave Team": "__stack-auto-translation-124",
  "leave this team and remove your team profile": "__stack-auto-translation-125",
  "Location": "__stack-auto-translation-126",
  "Magic Link Already Used": "__stack-auto-translation-127",
  "Manage the default payment method used for subscriptions and invoices.": "__stack-auto-translation-128",
  "Members": "__stack-auto-translation-129",
  "MFA management is not available in demo mode.": "__stack-auto-translation-130",
  "Missing verification information": "__stack-auto-translation-131",
  "Multi-factor authentication": "__stack-auto-translation-132",
  "Multi-Factor Authentication": "__stack-auto-translation-133",
  "Multi-factor authentication is currently disabled.": "__stack-auto-translation-134",
  "Multi-factor authentication is currently enabled.": "__stack-auto-translation-135",
  "My Profile": "__stack-auto-translation-136",
  "Name": "__stack-auto-translation-137",
  "Never": "__stack-auto-translation-138",
  "New account registration is not allowed": "__stack-auto-translation-139",
  "New password": "__stack-auto-translation-140",
  "New Password": "__stack-auto-translation-141",
  "No active sessions found": "__stack-auto-translation-142",
  "No authentication method enabled.": "__stack-auto-translation-143",
  "No default payment method": "__stack-auto-translation-144",
  "No display name set": "__stack-auto-translation-145",
  "No other plans available for this subscription.": "__stack-auto-translation-146",
  "No outstanding invitations": "__stack-auto-translation-147",
  "No team": "__stack-auto-translation-148",
  "No teams yet": "__stack-auto-translation-149",
  "Not signed in": "__stack-auto-translation-150",
  "Notifications": "__stack-auto-translation-151",
  "OAuth provider access denied": "__stack-auto-translation-152",
  "Old password": "__stack-auto-translation-153",
  "One-Time Password": "__stack-auto-translation-154",
  "One-time purchase": "__stack-auto-translation-155",
  "Open": "__stack-auto-translation-156",
  "Or continue with": "__stack-auto-translation-157",
  "Other Session": "__stack-auto-translation-158",
  "Other teams": "__stack-auto-translation-159",
  "OTP management is not available in demo mode.": "__stack-auto-translation-160",
  "OTP sign-in": "__stack-auto-translation-161",
  "OTP sign-in is enabled and cannot be disabled as it is currently the only sign-in method": "__stack-auto-translation-162",
  "OTP/magic link sign-in is currently enabled.": "__stack-auto-translation-163",
  "Outstanding invitations": "__stack-auto-translation-164",
  "Overwrite your user display name in this team": "__stack-auto-translation-165",
  "Paid": "__stack-auto-translation-166",
  "Passkey": "__stack-auto-translation-167",
  "Passkey management is not available in demo mode.": "__stack-auto-translation-168",
  "Passkey registered": "__stack-auto-translation-169",
  "Passkey sign-in is enabled and cannot be disabled as it is currently the only sign-in method": "__stack-auto-translation-170",
  "Password": "__stack-auto-translation-171",
  "Password management is not available in demo mode.": "__stack-auto-translation-172",
  "Password reset successfully!": "__stack-auto-translation-173",
  "Passwords do not match": "__stack-auto-translation-174",
  "Payment method": "__stack-auto-translation-175",
  "Payments": "__stack-auto-translation-176",
  "Permanently remove your account and all associated data": "__stack-auto-translation-177",
  "Personal": "__stack-auto-translation-178",
  "Please add an email address to complete your account setup. We'll send you a verification email.": "__stack-auto-translation-179",
  "Please check if you have the correct link. If you continue to have issues, please contact support.": "__stack-auto-translation-180",
  "Please check your email inbox": "__stack-auto-translation-181",
  "Please complete your account setup before joining teams.": "__stack-auto-translation-182",
  "Please double check if you have the correct password reset link.": "__stack-auto-translation-183",
  "Please double check if you have the correct team invitation link.": "__stack-auto-translation-184",
  "Please enter a team name": "__stack-auto-translation-185",
  "Please enter a valid email": "__stack-auto-translation-186",
  "Please enter a valid email address": "__stack-auto-translation-187",
  "Please enter an email address": "__stack-auto-translation-188",
  "Please enter your email": "__stack-auto-translation-189",
  "Please enter your old password": "__stack-auto-translation-190",
  "Please enter your password": "__stack-auto-translation-191",
  "Please repeat your password": "__stack-auto-translation-192",
  "Please try again and if the problem persists, contact support.": "__stack-auto-translation-193",
  "Please verify your email address ": "__stack-auto-translation-194",
  "Please verify your email first": "__stack-auto-translation-195",
  "Primary": "__stack-auto-translation-196",
  "Pro": "__stack-auto-translation-197",
  "Profile image": "__stack-auto-translation-198",
  "Register a passkey": "__stack-auto-translation-199",
  "Remove": "__stack-auto-translation-200",
  "Renews on": "__stack-auto-translation-201",
  "Repeat new password": "__stack-auto-translation-202",
  "Repeat New Password": "__stack-auto-translation-203",
  "Repeat Password": "__stack-auto-translation-204",
  "Resend verification email": "__stack-auto-translation-205",
  "Reset Password": "__stack-auto-translation-206",
  "Reset Your Password": "__stack-auto-translation-207",
  "Review past invoices and receipts.": "__stack-auto-translation-208",
  "Revoke": "__stack-auto-translation-209",
  "Revoke All Other Sessions": "__stack-auto-translation-210",
  "Save": "__stack-auto-translation-211",
  "Scan this QR code with your authenticator app:": "__stack-auto-translation-212",
  "Secret API Key": "__stack-auto-translation-213",
  "Select a new plan from the same product line.": "__stack-auto-translation-214",
  "Send email": "__stack-auto-translation-215",
  "Send Email": "__stack-auto-translation-216",
  "Send verification email": "__stack-auto-translation-217",
  "Session": "__stack-auto-translation-218",
  "Set a password for your account": "__stack-auto-translation-219",
  "Set as primary": "__stack-auto-translation-220",
  "Set password": "__stack-auto-translation-221",
  "Set Password": "__stack-auto-translation-222",
  "Settings": "__stack-auto-translation-223",
  "Sign in": "__stack-auto-translation-224",
  "Sign In": "__stack-auto-translation-225",
  "Sign in again": "__stack-auto-translation-226",
  "Sign in or create an account to join the team.": "__stack-auto-translation-227",
  "Sign in to your account": "__stack-auto-translation-228",
  "Sign in with Passkey": "__stack-auto-translation-229",
  "Sign in with {provider}": "__stack-auto-translation-230",
  "Sign out": "__stack-auto-translation-231",
  "Sign up": "__stack-auto-translation-232",
  "Sign Up": "__stack-auto-translation-233",
  "Sign up for new users is not enabled at the moment.": "__stack-auto-translation-234",
  "Sign up with Passkey": "__stack-auto-translation-235",
  "Sign up with {provider}": "__stack-auto-translation-236",
  "Signed in successfully!": "__stack-auto-translation-237",
  "Signed in {time}": "__stack-auto-translation-238",
  "Something went wrong while processing the OAuth callback:": "__stack-auto-translation-239",
  "Status": "__stack-auto-translation-240",
  "Stop using for sign-in": "__stack-auto-translation-241",
  "Subscription": "__stack-auto-translation-242",
  "Switch plan": "__stack-auto-translation-243",
  "Team creation is disabled in demo mode": "__stack-auto-translation-244",
  "Team creation is not enabled": "__stack-auto-translation-245",
  "Team display name": "__stack-auto-translation-246",
  "Team invitation": "__stack-auto-translation-247",
  "Team profile image": "__stack-auto-translation-248",
  "Team user name": "__stack-auto-translation-249",
  "Teams": "__stack-auto-translation-250",
  "The CLI application has been authorized successfully. You can close this window and return to the command line.": "__stack-auto-translation-251",
  "The magic link has already been used. The link can only be used once. Please request a new magic link if you need to sign-in again.": "__stack-auto-translation-252",
  "The sign-in operation has been cancelled or denied. Please try again.": "__stack-auto-translation-253",
  "The user is already connected to another OAuth account. Did you maybe selected the wrong account on the OAuth provider page?": "__stack-auto-translation-254",
  "Then, enter your six-digit MFA code:": "__stack-auto-translation-255",
  "These are devices where you're currently logged in. You can revoke access to end a session.": "__stack-auto-translation-256",
  "This account is already connected to another user. Please connect a different account.": "__stack-auto-translation-257",
  "This email is already used for sign-in by another user.": "__stack-auto-translation-258",
  "This is a display name and is not used for authentication": "__stack-auto-translation-259",
  "This is most likely an error in Stack. Please report it.": "__stack-auto-translation-260",
  "This password reset link has already been used. If you need to reset your password again, please request a new password reset link from the login page.": "__stack-auto-translation-261",
  "This team invitation link has already been used.": "__stack-auto-translation-262",
  "To enable OTP sign-in, please add a verified sign-in email.": "__stack-auto-translation-263",
  "To enable Passkey sign-in, please add a verified sign-in email.": "__stack-auto-translation-264",
  "To set a password, please add a sign-in email.": "__stack-auto-translation-265",
  "Toggle theme": "__stack-auto-translation-266",
  "TOTP multi-factor authentication QR code": "__stack-auto-translation-267",
  "Try Again": "__stack-auto-translation-268",
  "Unavailable": "__stack-auto-translation-269",
  "Uncollectible": "__stack-auto-translation-270",
  "Unknown": "__stack-auto-translation-271",
  "Unverified": "__stack-auto-translation-272",
  "Update password": "__stack-auto-translation-273",
  "Update Password": "__stack-auto-translation-274",
  "Update payment method": "__stack-auto-translation-275",
  "Update your password": "__stack-auto-translation-276",
  "Upload an image for your team": "__stack-auto-translation-277",
  "Upload your own image as your avatar": "__stack-auto-translation-278",
  "Use for sign-in": "__stack-auto-translation-279",
  "Used for sign-in": "__stack-auto-translation-280",
  "Used Password Reset Link": "__stack-auto-translation-281",
  "Used Team Invitation Link": "__stack-auto-translation-282",
  "User": "__stack-auto-translation-283",
  "User name": "__stack-auto-translation-284",
  "Verification failed": "__stack-auto-translation-285",
  "Verified! Redirecting...": "__stack-auto-translation-286",
  "Verify": "__stack-auto-translation-287",
  "Verifying...": "__stack-auto-translation-288",
  "View": "__stack-auto-translation-289",
  "View your active plans and purchases.": "__stack-auto-translation-290",
  "Void": "__stack-auto-translation-291",
  "WARNING: Make sure you trust the command line application, as it will gain access to your account. If you did not initiate this request, you can close this page and ignore it. We will never send you this link via email or any other means.": "__stack-auto-translation-292",
  "You are already signed in": "__stack-auto-translation-293",
  "You are not currently signed in.": "__stack-auto-translation-294",
  "You can not remove your last sign-in email": "__stack-auto-translation-295",
  "You cannot revoke your current session": "__stack-auto-translation-296",
  "You email has been verified!": "__stack-auto-translation-297",
  "You have not yet completed your account setup. Please reach out to support if you believe this is an error.": "__stack-auto-translation-298",
  "Your Email": "__stack-auto-translation-299",
  "Your email verification link has expired. Please request a new verification link from your account settings.": "__stack-auto-translation-300",
  "Your magic link has expired. Please request a new magic link if you need to sign-in.": "__stack-auto-translation-301",
  "Your password has been reset. You can now sign in with your new password.": "__stack-auto-translation-302",
  "Your password reset link has expired. Please request a new password reset link from the login page.": "__stack-auto-translation-303",
  "Your team invitation link has expired. Please request a new team invitation link ": "__stack-auto-translation-304"
} as const));


export const quetzalLocales = new Map(typedEntries({
  "de-DE": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Eine Befehlszeilenanwendung fordert Zugriff auf Ihr Konto an. Klicken Sie unten auf die Schaltfläche, um sie zu autorisieren.",
    "__stack-auto-translation-10": "E-Mail-Adresse hinzufügen",
    "__stack-auto-translation-100": "Ich verstehe, dass ich diesen Schlüssel nicht erneut einsehen kann.",
    "__stack-auto-translation-101": "Wenn der Benutzer mit dieser E-Mail-Adresse existiert, wurde eine E-Mail an Ihren Posteingang gesendet. Überprüfen Sie auch Ihren Spam-Ordner.",
    "__stack-auto-translation-102": "Wenn Sie nicht automatisch weitergeleitet werden, ",
    "__stack-auto-translation-103": "Ignorieren",
    "__stack-auto-translation-104": "Identitätswechsel",
    "__stack-auto-translation-105": "Falscher Code. Bitte versuchen Sie es erneut.",
    "__stack-auto-translation-106": "Falsches Passwort",
    "__stack-auto-translation-107": "Ungültiger Code",
    "__stack-auto-translation-108": "Ungültiges Bild",
    "__stack-auto-translation-109": "Ungültiger Magic Link",
    "__stack-auto-translation-11": "Haben Sie bereits ein Konto?",
    "__stack-auto-translation-110": "Ungültiger Link zum Zurücksetzen des Passworts",
    "__stack-auto-translation-111": "Ungültiger Team-Einladungslink",
    "__stack-auto-translation-112": "Ungültiger TOTP-Code",
    "__stack-auto-translation-113": "Ungültiger Verifizierungslink",
    "__stack-auto-translation-114": "Laden Sie einen Benutzer per E-Mail in Ihr Team ein",
    "__stack-auto-translation-115": "Mitglied einladen",
    "__stack-auto-translation-116": "Benutzer einladen",
    "__stack-auto-translation-117": "Rechnung",
    "__stack-auto-translation-118": "Rechnungen",
    "__stack-auto-translation-119": "IP-Adresse",
    "__stack-auto-translation-12": "Betrag",
    "__stack-auto-translation-120": "Beitreten",
    "__stack-auto-translation-121": "Zuletzt verwendet",
    "__stack-auto-translation-122": "Verlassen",
    "__stack-auto-translation-123": "Team verlassen",
    "__stack-auto-translation-124": "Team verlassen",
    "__stack-auto-translation-125": "dieses Team verlassen und Ihr Teamprofil entfernen",
    "__stack-auto-translation-126": "Standort",
    "__stack-auto-translation-127": "Magic Link bereits verwendet",
    "__stack-auto-translation-128": "Verwalten Sie die Standard-Zahlungsmethode für Abonnements und Rechnungen.",
    "__stack-auto-translation-129": "Mitglieder",
    "__stack-auto-translation-13": "Ein unbekannter Fehler ist aufgetreten",
    "__stack-auto-translation-130": "MFA-Verwaltung ist im Demo-Modus nicht verfügbar.",
    "__stack-auto-translation-131": "Fehlende Verifizierungsinformationen",
    "__stack-auto-translation-132": "Mehr-Faktor-Authentifizierung",
    "__stack-auto-translation-133": "Mehr-Faktor-Authentifizierung",
    "__stack-auto-translation-134": "Mehr-Faktor-Authentifizierung ist derzeit deaktiviert.",
    "__stack-auto-translation-135": "Mehrfaktor-Authentifizierung ist derzeit aktiviert.",
    "__stack-auto-translation-136": "Mein Profil",
    "__stack-auto-translation-137": "Name",
    "__stack-auto-translation-138": "Nie",
    "__stack-auto-translation-139": "Neue Kontoregistrierung ist nicht erlaubt",
    "__stack-auto-translation-14": "API-Schlüssel",
    "__stack-auto-translation-140": "Neues Passwort",
    "__stack-auto-translation-141": "Neues Passwort",
    "__stack-auto-translation-142": "Keine aktiven Sitzungen gefunden",
    "__stack-auto-translation-143": "Keine Authentifizierungsmethode aktiviert.",
    "__stack-auto-translation-144": "Keine Standard-Zahlungsmethode",
    "__stack-auto-translation-145": "Kein Anzeigename festgelegt",
    "__stack-auto-translation-146": "Keine weiteren Pläne für dieses Abonnement verfügbar.",
    "__stack-auto-translation-147": "Keine ausstehenden Einladungen",
    "__stack-auto-translation-148": "Kein Team",
    "__stack-auto-translation-149": "Noch keine Teams",
    "__stack-auto-translation-15": "API-Schlüssel",
    "__stack-auto-translation-150": "Nicht angemeldet",
    "__stack-auto-translation-151": "Benachrichtigungen",
    "__stack-auto-translation-152": "OAuth-Anbieter-Zugriff verweigert",
    "__stack-auto-translation-153": "Altes Passwort",
    "__stack-auto-translation-154": "Einmalpasswort",
    "__stack-auto-translation-155": "Einmaliger Kauf",
    "__stack-auto-translation-156": "Offen",
    "__stack-auto-translation-157": "Oder fortfahren mit",
    "__stack-auto-translation-158": "Andere Sitzung",
    "__stack-auto-translation-159": "Andere Teams",
    "__stack-auto-translation-16": "API-Schlüssel gewähren programmatischen Zugriff auf Ihr Konto.",
    "__stack-auto-translation-160": "OTP-Verwaltung ist im Demo-Modus nicht verfügbar.",
    "__stack-auto-translation-161": "OTP-Anmeldung",
    "__stack-auto-translation-162": "OTP-Anmeldung ist aktiviert und kann nicht deaktiviert werden, da es derzeit die einzige Anmeldemethode ist",
    "__stack-auto-translation-163": "Die Anmeldung per OTP/magischem Link ist derzeit aktiviert.",
    "__stack-auto-translation-164": "Ausstehende Einladungen",
    "__stack-auto-translation-165": "Überschreiben Sie Ihren Anzeigenamen in diesem Team",
    "__stack-auto-translation-166": "Bezahlt",
    "__stack-auto-translation-167": "Passkey",
    "__stack-auto-translation-168": "Passkey-Verwaltung ist im Demo-Modus nicht verfügbar.",
    "__stack-auto-translation-169": "Passkey registriert",
    "__stack-auto-translation-17": "API-Schlüssel gewähren programmatischen Zugriff auf Ihr Team.",
    "__stack-auto-translation-170": "Passkey-Anmeldung ist aktiviert und kann nicht deaktiviert werden, da es derzeit die einzige Anmeldemethode ist",
    "__stack-auto-translation-171": "Passwort",
    "__stack-auto-translation-172": "Passwortverwaltung ist im Demo-Modus nicht verfügbar.",
    "__stack-auto-translation-173": "Passwort erfolgreich zurückgesetzt!",
    "__stack-auto-translation-174": "Passwörter stimmen nicht überein",
    "__stack-auto-translation-175": "Zahlungsmethode",
    "__stack-auto-translation-176": "Zahlungen",
    "__stack-auto-translation-177": "Löschen Sie Ihr Konto und alle zugehörigen Daten dauerhaft",
    "__stack-auto-translation-178": "Persönlich",
    "__stack-auto-translation-179": "Bitte fügen Sie eine E-Mail-Adresse hinzu, um Ihre Kontoeinrichtung abzuschließen. Wir senden Ihnen eine Bestätigungs-E-Mail.",
    "__stack-auto-translation-18": "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion ist UNWIDERRUFLICH und löscht ALLE zugehörigen Daten.",
    "__stack-auto-translation-180": "Bitte überprüfen Sie, ob Sie den richtigen Link haben. Bei anhaltenden Problemen kontaktieren Sie bitte den Support.",
    "__stack-auto-translation-181": "Bitte überprüfen Sie Ihren E-Mail-Posteingang",
    "__stack-auto-translation-182": "Bitte schließen Sie Ihre Kontoeinrichtung ab, bevor Sie Teams beitreten.",
    "__stack-auto-translation-183": "Bitte überprüfen Sie, ob Sie den richtigen Link zum Zurücksetzen des Passworts haben.",
    "__stack-auto-translation-184": "Bitte überprüfen Sie, ob Sie den korrekten Teameinladungslink haben.",
    "__stack-auto-translation-185": "Bitte geben Sie einen Teamnamen ein",
    "__stack-auto-translation-186": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "__stack-auto-translation-187": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "__stack-auto-translation-188": "Bitte geben Sie eine E-Mail-Adresse ein",
    "__stack-auto-translation-189": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "__stack-auto-translation-19": "Sind Sie sicher, dass Sie die OTP-Anmeldung deaktivieren möchten? Sie können sich dann nicht mehr nur mit E-Mails anmelden.",
    "__stack-auto-translation-190": "Bitte geben Sie Ihr altes Passwort ein",
    "__stack-auto-translation-191": "Bitte geben Sie Ihr Passwort ein",
    "__stack-auto-translation-192": "Bitte wiederholen Sie Ihr Passwort",
    "__stack-auto-translation-193": "Bitte versuchen Sie es erneut und kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
    "__stack-auto-translation-194": "Bitte bestätigen Sie Ihre E-Mail-Adresse ",
    "__stack-auto-translation-195": "Bitte verifizieren Sie zuerst Ihre E-Mail",
    "__stack-auto-translation-196": "Primär",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Profilbild",
    "__stack-auto-translation-199": "Passkey registrieren",
    "__stack-auto-translation-2": "Kontoeinstellungen",
    "__stack-auto-translation-20": "Möchten Sie die Passkey-Anmeldung wirklich deaktivieren? Sie können sich dann nicht mehr mit Ihrem Passkey anmelden.",
    "__stack-auto-translation-200": "Entfernen",
    "__stack-auto-translation-201": "Verlängert am",
    "__stack-auto-translation-202": "Neues Passwort wiederholen",
    "__stack-auto-translation-203": "Neues Passwort wiederholen",
    "__stack-auto-translation-204": "Passwort wiederholen",
    "__stack-auto-translation-205": "Verifizierungs-E-Mail erneut senden",
    "__stack-auto-translation-206": "Passwort zurücksetzen",
    "__stack-auto-translation-207": "Passwort zurücksetzen",
    "__stack-auto-translation-208": "Vergangene Rechnungen und Belege einsehen.",
    "__stack-auto-translation-209": "Widerrufen",
    "__stack-auto-translation-21": "Sind Sie sicher, dass Sie das Team verlassen möchten?",
    "__stack-auto-translation-210": "Alle anderen Sitzungen widerrufen",
    "__stack-auto-translation-211": "Speichern",
    "__stack-auto-translation-212": "Scannen Sie diesen QR-Code mit Ihrer Authentifizierungs-App:",
    "__stack-auto-translation-213": "Geheimer API-Schlüssel",
    "__stack-auto-translation-214": "Wählen Sie einen neuen Tarif aus derselben Produktlinie.",
    "__stack-auto-translation-215": "E-Mail senden",
    "__stack-auto-translation-216": "E-Mail senden",
    "__stack-auto-translation-217": "E-Mail-Verifizierung senden",
    "__stack-auto-translation-218": "Sitzung",
    "__stack-auto-translation-219": "Legen Sie ein Passwort für Ihr Konto fest",
    "__stack-auto-translation-22": "Autorisierung fehlgeschlagen",
    "__stack-auto-translation-220": "Als Primär festlegen",
    "__stack-auto-translation-221": "Passwort festlegen",
    "__stack-auto-translation-222": "Passwort festlegen",
    "__stack-auto-translation-223": "Einstellungen",
    "__stack-auto-translation-224": "Anmelden",
    "__stack-auto-translation-225": "Anmelden",
    "__stack-auto-translation-226": "Erneut anmelden",
    "__stack-auto-translation-227": "Melden Sie sich an oder erstellen Sie ein Konto, um dem Team beizutreten.",
    "__stack-auto-translation-228": "Melden Sie sich in Ihrem Konto an",
    "__stack-auto-translation-229": "Mit Passkey anmelden",
    "__stack-auto-translation-23": "Autorisieren",
    "__stack-auto-translation-230": "Mit {provider} anmelden",
    "__stack-auto-translation-231": "Abmelden",
    "__stack-auto-translation-232": "Registrieren",
    "__stack-auto-translation-233": "Registrieren",
    "__stack-auto-translation-234": "Die Registrierung für neue Benutzer ist derzeit nicht aktiviert.",
    "__stack-auto-translation-235": "Mit Passkey registrieren",
    "__stack-auto-translation-236": "Mit {provider} registrieren",
    "__stack-auto-translation-237": "Erfolgreich angemeldet!",
    "__stack-auto-translation-238": "Angemeldet {time}",
    "__stack-auto-translation-239": "Bei der Verarbeitung des OAuth-Callbacks ist etwas schiefgelaufen:",
    "__stack-auto-translation-24": "CLI-Anwendung autorisieren",
    "__stack-auto-translation-240": "Status",
    "__stack-auto-translation-241": "Nicht mehr zur Anmeldung verwenden",
    "__stack-auto-translation-242": "Abonnement",
    "__stack-auto-translation-243": "Plan wechseln",
    "__stack-auto-translation-244": "Team-Erstellung ist im Demo-Modus deaktiviert",
    "__stack-auto-translation-245": "Teamerstellung ist nicht aktiviert",
    "__stack-auto-translation-246": "Team-Anzeigename",
    "__stack-auto-translation-247": "Teameinladung",
    "__stack-auto-translation-248": "Teamprofilbild",
    "__stack-auto-translation-249": "Teamnutzername",
    "__stack-auto-translation-25": "Autorisierung...",
    "__stack-auto-translation-250": "Teams",
    "__stack-auto-translation-251": "Die CLI-Anwendung wurde erfolgreich autorisiert. Sie können dieses Fenster schließen und zur Befehlszeile zurückkehren.",
    "__stack-auto-translation-252": "Der magische Link wurde bereits verwendet. Der Link kann nur einmal benutzt werden. Bitte fordern Sie einen neuen magischen Link an, wenn Sie sich erneut anmelden müssen.",
    "__stack-auto-translation-253": "Der Anmeldevorgang wurde abgebrochen oder verweigert. Bitte versuchen Sie es erneut.",
    "__stack-auto-translation-254": "Der Benutzer ist bereits mit einem anderen OAuth-Konto verbunden. Haben Sie vielleicht das falsche Konto auf der Seite des OAuth-Anbieters ausgewählt?",
    "__stack-auto-translation-255": "Geben Sie dann Ihren sechsstelligen MFA-Code ein:",
    "__stack-auto-translation-256": "Dies sind Geräte, auf denen Sie derzeit angemeldet sind. Sie können den Zugriff widerrufen, um eine Sitzung zu beenden.",
    "__stack-auto-translation-257": "Dieses Konto ist bereits mit einem anderen Benutzer verbunden. Bitte verbinden Sie ein anderes Konto.",
    "__stack-auto-translation-258": "Diese E-Mail wird bereits von einem anderen Benutzer für die Anmeldung verwendet.",
    "__stack-auto-translation-259": "Dies ist ein Anzeigename und wird nicht für die Authentifizierung verwendet",
    "__stack-auto-translation-26": "Abbrechen",
    "__stack-auto-translation-260": "Dies ist höchstwahrscheinlich ein Fehler in Stack. Bitte melden Sie ihn.",
    "__stack-auto-translation-261": "Dieser Link zum Zurücksetzen des Passworts wurde bereits verwendet. Falls Sie Ihr Passwort erneut zurücksetzen müssen, fordern Sie bitte einen neuen Link auf der Anmeldeseite an.",
    "__stack-auto-translation-262": "Dieser Teameinladungslink wurde bereits verwendet.",
    "__stack-auto-translation-263": "Um die OTP-Anmeldung zu aktivieren, fügen Sie bitte eine verifizierte Anmelde-E-Mail hinzu.",
    "__stack-auto-translation-264": "Um die Passkey-Anmeldung zu aktivieren, fügen Sie bitte eine verifizierte Anmelde-E-Mail hinzu.",
    "__stack-auto-translation-265": "Um ein Passwort festzulegen, fügen Sie bitte eine Anmelde-E-Mail hinzu.",
    "__stack-auto-translation-266": "Theme umschalten",
    "__stack-auto-translation-267": "TOTP-Mehrfaktor-Authentifizierungs-QR-Code",
    "__stack-auto-translation-268": "Erneut versuchen",
    "__stack-auto-translation-269": "Nicht verfügbar",
    "__stack-auto-translation-27": "Abo kündigen",
    "__stack-auto-translation-270": "Uneinbringlich",
    "__stack-auto-translation-271": "Unbekannt",
    "__stack-auto-translation-272": "Nicht verifiziert",
    "__stack-auto-translation-273": "Passwort aktualisieren",
    "__stack-auto-translation-274": "Passwort aktualisieren",
    "__stack-auto-translation-275": "Zahlungsmethode ändern",
    "__stack-auto-translation-276": "Aktualisieren Sie Ihr Passwort",
    "__stack-auto-translation-277": "Laden Sie ein Bild für Ihr Team hoch",
    "__stack-auto-translation-278": "Laden Sie Ihr eigenes Bild als Avatar hoch",
    "__stack-auto-translation-279": "Für die Anmeldung verwenden",
    "__stack-auto-translation-28": "Durch das Kündigen werden zukünftige Verlängerungen für dieses Abonnement gestoppt.",
    "__stack-auto-translation-280": "Für die Anmeldung verwendet",
    "__stack-auto-translation-281": "Verwendeter Link zum Zurücksetzen des Passworts",
    "__stack-auto-translation-282": "Verwendeter Team-Einladungslink",
    "__stack-auto-translation-283": "Benutzer",
    "__stack-auto-translation-284": "Benutzername",
    "__stack-auto-translation-285": "Verifizierung fehlgeschlagen",
    "__stack-auto-translation-286": "Verifiziert! Weiterleitung...",
    "__stack-auto-translation-287": "Bestätigen",
    "__stack-auto-translation-288": "Bestätigung...",
    "__stack-auto-translation-289": "Ansehen",
    "__stack-auto-translation-29": "ändern",
    "__stack-auto-translation-290": "Aktive Tarife und Käufe anzeigen.",
    "__stack-auto-translation-291": "Storniert",
    "__stack-auto-translation-292": "WARNUNG: Stellen Sie sicher, dass Sie der Kommandozeilenanwendung vertrauen, da sie Zugriff auf Ihr Konto erhalten wird. Falls Sie diese Anfrage nicht initiiert haben, können Sie diese Seite schließen und ignorieren. Wir werden Ihnen diesen Link niemals per E-Mail oder auf anderem Wege zusenden.",
    "__stack-auto-translation-293": "Sie sind bereits angemeldet",
    "__stack-auto-translation-294": "Sie sind derzeit nicht angemeldet.",
    "__stack-auto-translation-295": "Sie können Ihre letzte Anmelde-E-Mail nicht entfernen",
    "__stack-auto-translation-296": "Sie können Ihre aktuelle Sitzung nicht widerrufen",
    "__stack-auto-translation-297": "Ihre E-Mail wurde verifiziert!",
    "__stack-auto-translation-298": "Sie haben Ihre Kontoeinrichtung noch nicht abgeschlossen. Bitte wenden Sie sich an den Support, wenn Sie glauben, dass dies ein Fehler ist.",
    "__stack-auto-translation-299": "Ihre E-Mail-Adresse",
    "__stack-auto-translation-3": "Kontoeinstellungen",
    "__stack-auto-translation-30": "Tarif ändern",
    "__stack-auto-translation-300": "Ihr E-Mail-Bestätigungslink ist abgelaufen. Bitte fordern Sie in Ihren Kontoeinstellungen einen neuen Bestätigungslink an.",
    "__stack-auto-translation-301": "Ihr Magic Link ist abgelaufen. Bitte fordern Sie einen neuen Magic Link an, wenn Sie sich anmelden müssen.",
    "__stack-auto-translation-302": "Ihr Passwort wurde zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    "__stack-auto-translation-303": "Ihr Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte fordern Sie einen neuen Link zum Zurücksetzen des Passworts von der Anmeldeseite an.",
    "__stack-auto-translation-304": "Ihr Team-Einladungslink ist abgelaufen. Bitte fordern Sie einen neuen an",
    "__stack-auto-translation-31": "Ändern Sie den Anzeigenamen Ihres Teams",
    "__stack-auto-translation-32": "Plan wählen",
    "__stack-auto-translation-33": "Wählen Sie aus, welche E-Mails Sie erhalten möchten",
    "__stack-auto-translation-34": "CLI-Autorisierung erfolgreich",
    "__stack-auto-translation-35": "hier klicken",
    "__stack-auto-translation-36": "Klicken Sie auf die Schaltfläche unten, um den Verifizierungslink erneut zu senden.",
    "__stack-auto-translation-37": "Schließen",
    "__stack-auto-translation-38": "Einrichtung abschließen",
    "__stack-auto-translation-39": "Kontoeinrichtung abschließen",
    "__stack-auto-translation-4": "Aktive Tarife",
    "__stack-auto-translation-40": "Bestätigen",
    "__stack-auto-translation-41": "Weiter",
    "__stack-auto-translation-42": "Kopieren Sie es an einen sicheren Ort. Sie können es später nicht mehr einsehen.",
    "__stack-auto-translation-43": "Bild konnte nicht zugeschnitten werden.",
    "__stack-auto-translation-44": "Erstellen",
    "__stack-auto-translation-45": "Ein neues Konto erstellen",
    "__stack-auto-translation-46": "Team erstellen",
    "__stack-auto-translation-47": "Team erstellen",
    "__stack-auto-translation-48": "API-Schlüssel erstellen",
    "__stack-auto-translation-49": "Guthaben-Paket",
    "__stack-auto-translation-5": "Aktive Sitzungen",
    "__stack-auto-translation-50": "Aktuelle Sitzung",
    "__stack-auto-translation-51": "Aktuelles Team",
    "__stack-auto-translation-52": "Gefahrenzone",
    "__stack-auto-translation-53": "Datum",
    "__stack-auto-translation-54": "Konto löschen",
    "__stack-auto-translation-55": "Konto löschen",
    "__stack-auto-translation-56": "Passkey löschen",
    "__stack-auto-translation-57": "Beschreibung",
    "__stack-auto-translation-58": "Beschreibung ist erforderlich",
    "__stack-auto-translation-59": "Deaktivieren",
    "__stack-auto-translation-6": "Hinzufügen",
    "__stack-auto-translation-60": "MFA deaktivieren",
    "__stack-auto-translation-61": "OTP deaktivieren",
    "__stack-auto-translation-62": "Anzeigename",
    "__stack-auto-translation-63": "Möchten Sie sich anmelden?",
    "__stack-auto-translation-64": "Möchten Sie Ihre E-Mail-Adresse bestätigen?",
    "__stack-auto-translation-65": "Noch kein Konto?",
    "__stack-auto-translation-66": "Kein Zurücksetzen nötig?",
    "__stack-auto-translation-67": "Entwurf",
    "__stack-auto-translation-68": "z.B. Entwicklung, Produktion, CI/CD",
    "__stack-auto-translation-69": "E-Mail",
    "__stack-auto-translation-7": "Fügen Sie eine Zahlungsmethode hinzu, bevor Sie den Plan wechseln.",
    "__stack-auto-translation-70": "E-Mail & Passwort",
    "__stack-auto-translation-71": "E-Mail existiert bereits",
    "__stack-auto-translation-72": "E-Mail ist erforderlich",
    "__stack-auto-translation-73": "E-Mail-Verwaltung ist im Demo-Modus nicht verfügbar.",
    "__stack-auto-translation-74": "E-Mail gesendet!",
    "__stack-auto-translation-75": "E-Mails",
    "__stack-auto-translation-76": "E-Mails & Authentifizierung",
    "__stack-auto-translation-77": "MFA aktivieren",
    "__stack-auto-translation-78": "OTP aktivieren",
    "__stack-auto-translation-79": "Aktivieren Sie die Anmeldung über einen magischen Link oder OTP, die an Ihre Anmelde-E-Mails gesendet werden.",
    "__stack-auto-translation-8": "E-Mail hinzufügen",
    "__stack-auto-translation-80": "Beenden Sie Ihre aktuelle Sitzung",
    "__stack-auto-translation-81": "Geben Sie einen Anzeigenamen für Ihr neues Team ein",
    "__stack-auto-translation-82": "E-Mail eingeben",
    "__stack-auto-translation-83": "Geben Sie den Code aus Ihrer E-Mail ein",
    "__stack-auto-translation-84": "Geben Sie den sechsstelligen Code aus Ihrer Authenticator-App ein",
    "__stack-auto-translation-85": "E-Mail eingeben",
    "__stack-auto-translation-86": "Abgelaufener Magic Link",
    "__stack-auto-translation-87": "Abgelaufener Link zum Zurücksetzen des Passworts",
    "__stack-auto-translation-88": "Abgelaufener Team-Einladungslink",
    "__stack-auto-translation-89": "Abgelaufener Verifizierungslink",
    "__stack-auto-translation-9": "Neue Passkey hinzufügen",
    "__stack-auto-translation-90": "Läuft ab",
    "__stack-auto-translation-91": "Läuft ab in",
    "__stack-auto-translation-92": "Fehler bei der Autorisierung der CLI-Anwendung:",
    "__stack-auto-translation-93": "Verbindung des Kontos fehlgeschlagen",
    "__stack-auto-translation-94": "Passwort konnte nicht zurückgesetzt werden",
    "__stack-auto-translation-95": "Passwort konnte nicht zurückgesetzt werden. Bitte fordern Sie einen neuen Link zum Zurücksetzen des Passworts an",
    "__stack-auto-translation-96": "Passwort vergessen?",
    "__stack-auto-translation-97": "Zur Startseite",
    "__stack-auto-translation-98": "Zur Startseite",
    "__stack-auto-translation-99": "Hier ist dein API-Schlüssel."
  } as const)),
  "en-US": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "A command line application is requesting access to your account. Click the button below to authorize it.",
    "__stack-auto-translation-10": "Add your email address",
    "__stack-auto-translation-100": "I understand that I will not be able to view this key again.",
    "__stack-auto-translation-101": "If the user with this e-mail address exists, an e-mail was sent to your inbox. Make sure to check your spam folder.",
    "__stack-auto-translation-102": "If you are not redirected automatically, ",
    "__stack-auto-translation-103": "Ignore",
    "__stack-auto-translation-104": "Impersonation",
    "__stack-auto-translation-105": "Incorrect code. Please try again.",
    "__stack-auto-translation-106": "Incorrect password",
    "__stack-auto-translation-107": "Invalid code",
    "__stack-auto-translation-108": "Invalid image",
    "__stack-auto-translation-109": "Invalid Magic Link",
    "__stack-auto-translation-11": "Already have an account?",
    "__stack-auto-translation-110": "Invalid Password Reset Link",
    "__stack-auto-translation-111": "Invalid Team Invitation Link",
    "__stack-auto-translation-112": "Invalid TOTP code",
    "__stack-auto-translation-113": "Invalid Verification Link",
    "__stack-auto-translation-114": "Invite a user to your team through email",
    "__stack-auto-translation-115": "Invite member",
    "__stack-auto-translation-116": "Invite User",
    "__stack-auto-translation-117": "Invoice",
    "__stack-auto-translation-118": "Invoices",
    "__stack-auto-translation-119": "IP Address",
    "__stack-auto-translation-12": "Amount",
    "__stack-auto-translation-120": "Join",
    "__stack-auto-translation-121": "Last used",
    "__stack-auto-translation-122": "Leave",
    "__stack-auto-translation-123": "Leave team",
    "__stack-auto-translation-124": "Leave Team",
    "__stack-auto-translation-125": "leave this team and remove your team profile",
    "__stack-auto-translation-126": "Location",
    "__stack-auto-translation-127": "Magic Link Already Used",
    "__stack-auto-translation-128": "Manage the default payment method used for subscriptions and invoices.",
    "__stack-auto-translation-129": "Members",
    "__stack-auto-translation-13": "An unknown error occurred",
    "__stack-auto-translation-130": "MFA management is not available in demo mode.",
    "__stack-auto-translation-131": "Missing verification information",
    "__stack-auto-translation-132": "Multi-factor authentication",
    "__stack-auto-translation-133": "Multi-Factor Authentication",
    "__stack-auto-translation-134": "Multi-factor authentication is currently disabled.",
    "__stack-auto-translation-135": "Multi-factor authentication is currently enabled.",
    "__stack-auto-translation-136": "My Profile",
    "__stack-auto-translation-137": "Name",
    "__stack-auto-translation-138": "Never",
    "__stack-auto-translation-139": "New account registration is not allowed",
    "__stack-auto-translation-14": "API Key",
    "__stack-auto-translation-140": "New password",
    "__stack-auto-translation-141": "New Password",
    "__stack-auto-translation-142": "No active sessions found",
    "__stack-auto-translation-143": "No authentication method enabled.",
    "__stack-auto-translation-144": "No default payment method",
    "__stack-auto-translation-145": "No display name set",
    "__stack-auto-translation-146": "No other plans available for this subscription.",
    "__stack-auto-translation-147": "No outstanding invitations",
    "__stack-auto-translation-148": "No team",
    "__stack-auto-translation-149": "No teams yet",
    "__stack-auto-translation-15": "API Keys",
    "__stack-auto-translation-150": "Not signed in",
    "__stack-auto-translation-151": "Notifications",
    "__stack-auto-translation-152": "OAuth provider access denied",
    "__stack-auto-translation-153": "Old password",
    "__stack-auto-translation-154": "One-Time Password",
    "__stack-auto-translation-155": "One-time purchase",
    "__stack-auto-translation-156": "Open",
    "__stack-auto-translation-157": "Or continue with",
    "__stack-auto-translation-158": "Other Session",
    "__stack-auto-translation-159": "Other teams",
    "__stack-auto-translation-16": "API keys grant programmatic access to your account.",
    "__stack-auto-translation-160": "OTP management is not available in demo mode.",
    "__stack-auto-translation-161": "OTP sign-in",
    "__stack-auto-translation-162": "OTP sign-in is enabled and cannot be disabled as it is currently the only sign-in method",
    "__stack-auto-translation-163": "OTP/magic link sign-in is currently enabled.",
    "__stack-auto-translation-164": "Outstanding invitations",
    "__stack-auto-translation-165": "Overwrite your user display name in this team",
    "__stack-auto-translation-166": "Paid",
    "__stack-auto-translation-167": "Passkey",
    "__stack-auto-translation-168": "Passkey management is not available in demo mode.",
    "__stack-auto-translation-169": "Passkey registered",
    "__stack-auto-translation-17": "API keys grant programmatic access to your team.",
    "__stack-auto-translation-170": "Passkey sign-in is enabled and cannot be disabled as it is currently the only sign-in method",
    "__stack-auto-translation-171": "Password",
    "__stack-auto-translation-172": "Password management is not available in demo mode.",
    "__stack-auto-translation-173": "Password reset successfully!",
    "__stack-auto-translation-174": "Passwords do not match",
    "__stack-auto-translation-175": "Payment method",
    "__stack-auto-translation-176": "Payments",
    "__stack-auto-translation-177": "Permanently remove your account and all associated data",
    "__stack-auto-translation-178": "Personal",
    "__stack-auto-translation-179": "Please add an email address to complete your account setup. We'll send you a verification email.",
    "__stack-auto-translation-18": "Are you sure you want to delete your account? This action is IRREVERSIBLE and will delete ALL associated data.",
    "__stack-auto-translation-180": "Please check if you have the correct link. If you continue to have issues, please contact support.",
    "__stack-auto-translation-181": "Please check your email inbox",
    "__stack-auto-translation-182": "Please complete your account setup before joining teams.",
    "__stack-auto-translation-183": "Please double check if you have the correct password reset link.",
    "__stack-auto-translation-184": "Please double check if you have the correct team invitation link.",
    "__stack-auto-translation-185": "Please enter a team name",
    "__stack-auto-translation-186": "Please enter a valid email",
    "__stack-auto-translation-187": "Please enter a valid email address",
    "__stack-auto-translation-188": "Please enter an email address",
    "__stack-auto-translation-189": "Please enter your email",
    "__stack-auto-translation-19": "Are you sure you want to disable OTP sign-in? You will not be able to sign in with only emails anymore.",
    "__stack-auto-translation-190": "Please enter your old password",
    "__stack-auto-translation-191": "Please enter your password",
    "__stack-auto-translation-192": "Please repeat your password",
    "__stack-auto-translation-193": "Please try again and if the problem persists, contact support.",
    "__stack-auto-translation-194": "Please verify your email address ",
    "__stack-auto-translation-195": "Please verify your email first",
    "__stack-auto-translation-196": "Primary",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Profile image",
    "__stack-auto-translation-199": "Register a passkey",
    "__stack-auto-translation-2": "Account settings",
    "__stack-auto-translation-20": "Are you sure you want to disable Passkey sign-in? You will not be able to sign in with your passkey anymore.",
    "__stack-auto-translation-200": "Remove",
    "__stack-auto-translation-201": "Renews on",
    "__stack-auto-translation-202": "Repeat new password",
    "__stack-auto-translation-203": "Repeat New Password",
    "__stack-auto-translation-204": "Repeat Password",
    "__stack-auto-translation-205": "Resend verification email",
    "__stack-auto-translation-206": "Reset Password",
    "__stack-auto-translation-207": "Reset Your Password",
    "__stack-auto-translation-208": "Review past invoices and receipts.",
    "__stack-auto-translation-209": "Revoke",
    "__stack-auto-translation-21": "Are you sure you want to leave the team?",
    "__stack-auto-translation-210": "Revoke All Other Sessions",
    "__stack-auto-translation-211": "Save",
    "__stack-auto-translation-212": "Scan this QR code with your authenticator app:",
    "__stack-auto-translation-213": "Secret API Key",
    "__stack-auto-translation-214": "Select a new plan from the same product line.",
    "__stack-auto-translation-215": "Send email",
    "__stack-auto-translation-216": "Send Email",
    "__stack-auto-translation-217": "Send verification email",
    "__stack-auto-translation-218": "Session",
    "__stack-auto-translation-219": "Set a password for your account",
    "__stack-auto-translation-22": "Authorization Failed",
    "__stack-auto-translation-220": "Set as primary",
    "__stack-auto-translation-221": "Set password",
    "__stack-auto-translation-222": "Set Password",
    "__stack-auto-translation-223": "Settings",
    "__stack-auto-translation-224": "Sign in",
    "__stack-auto-translation-225": "Sign In",
    "__stack-auto-translation-226": "Sign in again",
    "__stack-auto-translation-227": "Sign in or create an account to join the team.",
    "__stack-auto-translation-228": "Sign in to your account",
    "__stack-auto-translation-229": "Sign in with Passkey",
    "__stack-auto-translation-23": "Authorize",
    "__stack-auto-translation-230": "Sign in with {provider}",
    "__stack-auto-translation-231": "Sign out",
    "__stack-auto-translation-232": "Sign up",
    "__stack-auto-translation-233": "Sign Up",
    "__stack-auto-translation-234": "Sign up for new users is not enabled at the moment.",
    "__stack-auto-translation-235": "Sign up with Passkey",
    "__stack-auto-translation-236": "Sign up with {provider}",
    "__stack-auto-translation-237": "Signed in successfully!",
    "__stack-auto-translation-238": "Signed in {time}",
    "__stack-auto-translation-239": "Something went wrong while processing the OAuth callback:",
    "__stack-auto-translation-24": "Authorize CLI Application",
    "__stack-auto-translation-240": "Status",
    "__stack-auto-translation-241": "Stop using for sign-in",
    "__stack-auto-translation-242": "Subscription",
    "__stack-auto-translation-243": "Switch plan",
    "__stack-auto-translation-244": "Team creation is disabled in demo mode",
    "__stack-auto-translation-245": "Team creation is not enabled",
    "__stack-auto-translation-246": "Team display name",
    "__stack-auto-translation-247": "Team invitation",
    "__stack-auto-translation-248": "Team profile image",
    "__stack-auto-translation-249": "Team user name",
    "__stack-auto-translation-25": "Authorizing...",
    "__stack-auto-translation-250": "Teams",
    "__stack-auto-translation-251": "The CLI application has been authorized successfully. You can close this window and return to the command line.",
    "__stack-auto-translation-252": "The magic link has already been used. The link can only be used once. Please request a new magic link if you need to sign-in again.",
    "__stack-auto-translation-253": "The sign-in operation has been cancelled or denied. Please try again.",
    "__stack-auto-translation-254": "The user is already connected to another OAuth account. Did you maybe selected the wrong account on the OAuth provider page?",
    "__stack-auto-translation-255": "Then, enter your six-digit MFA code:",
    "__stack-auto-translation-256": "These are devices where you're currently logged in. You can revoke access to end a session.",
    "__stack-auto-translation-257": "This account is already connected to another user. Please connect a different account.",
    "__stack-auto-translation-258": "This email is already used for sign-in by another user.",
    "__stack-auto-translation-259": "This is a display name and is not used for authentication",
    "__stack-auto-translation-26": "Cancel",
    "__stack-auto-translation-260": "This is most likely an error in Stack. Please report it.",
    "__stack-auto-translation-261": "This password reset link has already been used. If you need to reset your password again, please request a new password reset link from the login page.",
    "__stack-auto-translation-262": "This team invitation link has already been used.",
    "__stack-auto-translation-263": "To enable OTP sign-in, please add a verified sign-in email.",
    "__stack-auto-translation-264": "To enable Passkey sign-in, please add a verified sign-in email.",
    "__stack-auto-translation-265": "To set a password, please add a sign-in email.",
    "__stack-auto-translation-266": "Toggle theme",
    "__stack-auto-translation-267": "TOTP multi-factor authentication QR code",
    "__stack-auto-translation-268": "Try Again",
    "__stack-auto-translation-269": "Unavailable",
    "__stack-auto-translation-27": "Cancel subscription",
    "__stack-auto-translation-270": "Uncollectible",
    "__stack-auto-translation-271": "Unknown",
    "__stack-auto-translation-272": "Unverified",
    "__stack-auto-translation-273": "Update password",
    "__stack-auto-translation-274": "Update Password",
    "__stack-auto-translation-275": "Update payment method",
    "__stack-auto-translation-276": "Update your password",
    "__stack-auto-translation-277": "Upload an image for your team",
    "__stack-auto-translation-278": "Upload your own image as your avatar",
    "__stack-auto-translation-279": "Use for sign-in",
    "__stack-auto-translation-28": "Canceling will stop future renewals for this subscription.",
    "__stack-auto-translation-280": "Used for sign-in",
    "__stack-auto-translation-281": "Used Password Reset Link",
    "__stack-auto-translation-282": "Used Team Invitation Link",
    "__stack-auto-translation-283": "User",
    "__stack-auto-translation-284": "User name",
    "__stack-auto-translation-285": "Verification failed",
    "__stack-auto-translation-286": "Verified! Redirecting...",
    "__stack-auto-translation-287": "Verify",
    "__stack-auto-translation-288": "Verifying...",
    "__stack-auto-translation-289": "View",
    "__stack-auto-translation-29": "change",
    "__stack-auto-translation-290": "View your active plans and purchases.",
    "__stack-auto-translation-291": "Void",
    "__stack-auto-translation-292": "WARNING: Make sure you trust the command line application, as it will gain access to your account. If you did not initiate this request, you can close this page and ignore it. We will never send you this link via email or any other means.",
    "__stack-auto-translation-293": "You are already signed in",
    "__stack-auto-translation-294": "You are not currently signed in.",
    "__stack-auto-translation-295": "You can not remove your last sign-in email",
    "__stack-auto-translation-296": "You cannot revoke your current session",
    "__stack-auto-translation-297": "You email has been verified!",
    "__stack-auto-translation-298": "You have not yet completed your account setup. Please reach out to support if you believe this is an error.",
    "__stack-auto-translation-299": "Your Email",
    "__stack-auto-translation-3": "Account Settings",
    "__stack-auto-translation-30": "Change plan",
    "__stack-auto-translation-300": "Your email verification link has expired. Please request a new verification link from your account settings.",
    "__stack-auto-translation-301": "Your magic link has expired. Please request a new magic link if you need to sign-in.",
    "__stack-auto-translation-302": "Your password has been reset. You can now sign in with your new password.",
    "__stack-auto-translation-303": "Your password reset link has expired. Please request a new password reset link from the login page.",
    "__stack-auto-translation-304": "Your team invitation link has expired. Please request a new team invitation link ",
    "__stack-auto-translation-31": "Change the display name of your team",
    "__stack-auto-translation-32": "Choose a plan",
    "__stack-auto-translation-33": "Choose which emails you want to receive",
    "__stack-auto-translation-34": "CLI Authorization Successful",
    "__stack-auto-translation-35": "click here",
    "__stack-auto-translation-36": "Click the button below to resend the verification link.",
    "__stack-auto-translation-37": "Close",
    "__stack-auto-translation-38": "Complete setup",
    "__stack-auto-translation-39": "Complete your account setup",
    "__stack-auto-translation-4": "Active plans",
    "__stack-auto-translation-40": "Confirm",
    "__stack-auto-translation-41": "Continue",
    "__stack-auto-translation-42": "Copy it to a safe place. You will not be able to view it again.",
    "__stack-auto-translation-43": "Could not crop image.",
    "__stack-auto-translation-44": "Create",
    "__stack-auto-translation-45": "Create a new account",
    "__stack-auto-translation-46": "Create a team",
    "__stack-auto-translation-47": "Create a Team",
    "__stack-auto-translation-48": "Create API Key",
    "__stack-auto-translation-49": "Credits pack",
    "__stack-auto-translation-5": "Active Sessions",
    "__stack-auto-translation-50": "Current Session",
    "__stack-auto-translation-51": "Current team",
    "__stack-auto-translation-52": "Danger zone",
    "__stack-auto-translation-53": "Date",
    "__stack-auto-translation-54": "Delete account",
    "__stack-auto-translation-55": "Delete Account",
    "__stack-auto-translation-56": "Delete Passkey",
    "__stack-auto-translation-57": "Description",
    "__stack-auto-translation-58": "Description is required",
    "__stack-auto-translation-59": "Disable",
    "__stack-auto-translation-6": "Add",
    "__stack-auto-translation-60": "Disable MFA",
    "__stack-auto-translation-61": "Disable OTP",
    "__stack-auto-translation-62": "Display name",
    "__stack-auto-translation-63": "Do you want to sign in?",
    "__stack-auto-translation-64": "Do you want to verify your email?",
    "__stack-auto-translation-65": "Don't have an account?",
    "__stack-auto-translation-66": "Don't need to reset?",
    "__stack-auto-translation-67": "Draft",
    "__stack-auto-translation-68": "e.g. Development, Production, CI/CD",
    "__stack-auto-translation-69": "Email",
    "__stack-auto-translation-7": "Add a payment method before switching plans.",
    "__stack-auto-translation-70": "Email & Password",
    "__stack-auto-translation-71": "Email already exists",
    "__stack-auto-translation-72": "Email is required",
    "__stack-auto-translation-73": "Email management is not available in demo mode.",
    "__stack-auto-translation-74": "Email sent!",
    "__stack-auto-translation-75": "Emails",
    "__stack-auto-translation-76": "Emails & Auth",
    "__stack-auto-translation-77": "Enable MFA",
    "__stack-auto-translation-78": "Enable OTP",
    "__stack-auto-translation-79": "Enable sign-in via magic link or OTP sent to your sign-in emails.",
    "__stack-auto-translation-8": "Add an email",
    "__stack-auto-translation-80": "End your current session",
    "__stack-auto-translation-81": "Enter a display name for your new team",
    "__stack-auto-translation-82": "Enter email",
    "__stack-auto-translation-83": "Enter the code from your email",
    "__stack-auto-translation-84": "Enter the six-digit code from your authenticator app",
    "__stack-auto-translation-85": "Enter your email",
    "__stack-auto-translation-86": "Expired Magic Link",
    "__stack-auto-translation-87": "Expired Password Reset Link",
    "__stack-auto-translation-88": "Expired Team Invitation Link",
    "__stack-auto-translation-89": "Expired Verification Link",
    "__stack-auto-translation-9": "Add new passkey",
    "__stack-auto-translation-90": "Expires",
    "__stack-auto-translation-91": "Expires In",
    "__stack-auto-translation-92": "Failed to authorize the CLI application:",
    "__stack-auto-translation-93": "Failed to connect account",
    "__stack-auto-translation-94": "Failed to reset password",
    "__stack-auto-translation-95": "Failed to reset password. Please request a new password reset link",
    "__stack-auto-translation-96": "Forgot password?",
    "__stack-auto-translation-97": "Go home",
    "__stack-auto-translation-98": "Go Home",
    "__stack-auto-translation-99": "Here is your API key."
  } as const)),
  "es-419": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Una aplicación de línea de comandos está solicitando acceso a tu cuenta. Haz clic en el botón de abajo para autorizarla.",
    "__stack-auto-translation-10": "Agrega tu correo electrónico",
    "__stack-auto-translation-100": "Entiendo que no podré ver esta clave nuevamente.",
    "__stack-auto-translation-101": "Si el usuario con esta dirección de correo existe, se envió un email a su bandeja de entrada. Asegúrese de revisar su carpeta de spam.",
    "__stack-auto-translation-102": "Si no se le redirige automáticamente, ",
    "__stack-auto-translation-103": "Ignorar",
    "__stack-auto-translation-104": "Suplantación",
    "__stack-auto-translation-105": "Código incorrecto. Inténtelo de nuevo.",
    "__stack-auto-translation-106": "Contraseña incorrecta",
    "__stack-auto-translation-107": "Código no válido",
    "__stack-auto-translation-108": "Imagen no válida",
    "__stack-auto-translation-109": "Enlace mágico no válido",
    "__stack-auto-translation-11": "¿Ya tienes una cuenta?",
    "__stack-auto-translation-110": "Enlace de restablecimiento de contraseña no válido",
    "__stack-auto-translation-111": "Enlace de invitación de equipo inválido",
    "__stack-auto-translation-112": "Código TOTP inválido",
    "__stack-auto-translation-113": "Enlace de verificación inválido",
    "__stack-auto-translation-114": "Invita a un usuario a tu equipo por correo electrónico",
    "__stack-auto-translation-115": "Invitar miembro",
    "__stack-auto-translation-116": "Invitar Usuario",
    "__stack-auto-translation-117": "Factura",
    "__stack-auto-translation-118": "Facturas",
    "__stack-auto-translation-119": "Dirección IP",
    "__stack-auto-translation-12": "Monto",
    "__stack-auto-translation-120": "Unirse",
    "__stack-auto-translation-121": "Último uso",
    "__stack-auto-translation-122": "Salir",
    "__stack-auto-translation-123": "Abandonar equipo",
    "__stack-auto-translation-124": "Salir del equipo",
    "__stack-auto-translation-125": "abandona este equipo y elimina tu perfil de equipo",
    "__stack-auto-translation-126": "Ubicación",
    "__stack-auto-translation-127": "Enlace Mágico Ya Utilizado",
    "__stack-auto-translation-128": "Administra el método de pago predeterminado para suscripciones y facturas.",
    "__stack-auto-translation-129": "Miembros",
    "__stack-auto-translation-13": "Se produjo un error desconocido",
    "__stack-auto-translation-130": "La administración de MFA no está disponible en modo demo.",
    "__stack-auto-translation-131": "Información de verificación faltante",
    "__stack-auto-translation-132": "Autenticación de múltiples factores",
    "__stack-auto-translation-133": "Autenticación de múltiples factores",
    "__stack-auto-translation-134": "La autenticación de múltiples factores está actualmente desactivada.",
    "__stack-auto-translation-135": "La autenticación de múltiples factores está actualmente habilitada.",
    "__stack-auto-translation-136": "Mi perfil",
    "__stack-auto-translation-137": "Nombre",
    "__stack-auto-translation-138": "Nunca",
    "__stack-auto-translation-139": "No se permite el registro de nuevas cuentas",
    "__stack-auto-translation-14": "Clave API",
    "__stack-auto-translation-140": "Nueva contraseña",
    "__stack-auto-translation-141": "Nueva Contraseña",
    "__stack-auto-translation-142": "No se encontraron sesiones activas",
    "__stack-auto-translation-143": "Ningún método de autenticación habilitado.",
    "__stack-auto-translation-144": "Sin método de pago predeterminado",
    "__stack-auto-translation-145": "Nombre para mostrar no establecido",
    "__stack-auto-translation-146": "No hay otros planes disponibles para esta suscripción.",
    "__stack-auto-translation-147": "No hay invitaciones pendientes",
    "__stack-auto-translation-148": "Sin equipo",
    "__stack-auto-translation-149": "Sin equipos aún",
    "__stack-auto-translation-15": "Claves API",
    "__stack-auto-translation-150": "No ha iniciado sesión",
    "__stack-auto-translation-151": "Notificaciones",
    "__stack-auto-translation-152": "Acceso denegado por el proveedor de OAuth",
    "__stack-auto-translation-153": "Contraseña anterior",
    "__stack-auto-translation-154": "Contraseña de un solo uso",
    "__stack-auto-translation-155": "Compra única",
    "__stack-auto-translation-156": "Pendiente",
    "__stack-auto-translation-157": "O continuar con",
    "__stack-auto-translation-158": "Otra Sesión",
    "__stack-auto-translation-159": "Otros equipos",
    "__stack-auto-translation-16": "Las claves API otorgan acceso programático a tu cuenta.",
    "__stack-auto-translation-160": "La gestión de OTP no está disponible en modo demo.",
    "__stack-auto-translation-161": "Inicio de sesión con OTP",
    "__stack-auto-translation-162": "El inicio de sesión con OTP está activado y no se puede deshabilitar ya que actualmente es el único método de inicio de sesión",
    "__stack-auto-translation-163": "El inicio de sesión por OTP/enlace mágico está actualmente activado.",
    "__stack-auto-translation-164": "Invitaciones pendientes",
    "__stack-auto-translation-165": "Sobrescribe tu nombre de usuario para mostrar en este equipo",
    "__stack-auto-translation-166": "Pagado",
    "__stack-auto-translation-167": "Clave de acceso",
    "__stack-auto-translation-168": "La gestión de claves de acceso no está disponible en modo demo.",
    "__stack-auto-translation-169": "Clave de acceso registrada",
    "__stack-auto-translation-17": "Las claves API otorgan acceso programático a tu equipo.",
    "__stack-auto-translation-170": "El inicio de sesión con clave de acceso está activado y no se puede desactivar ya que es el único método de inicio de sesión actual",
    "__stack-auto-translation-171": "Contraseña",
    "__stack-auto-translation-172": "La administración de contraseñas no está disponible en modo demo.",
    "__stack-auto-translation-173": "¡Contraseña restablecida con éxito!",
    "__stack-auto-translation-174": "Las contraseñas no coinciden",
    "__stack-auto-translation-175": "Método de pago",
    "__stack-auto-translation-176": "Pagos",
    "__stack-auto-translation-177": "Elimina permanentemente tu cuenta y todos los datos asociados",
    "__stack-auto-translation-178": "Personal",
    "__stack-auto-translation-179": "Por favor agrega una dirección de correo electrónico para completar la configuración de tu cuenta. Te enviaremos un correo de verificación.",
    "__stack-auto-translation-18": "¿Está seguro de que desea eliminar su cuenta? Esta acción es IRREVERSIBLE y eliminará TODOS los datos asociados.",
    "__stack-auto-translation-180": "Por favor, verifique si tiene el enlace correcto. Si continúa teniendo problemas, comuníquese con soporte.",
    "__stack-auto-translation-181": "Por favor revisa tu bandeja de entrada",
    "__stack-auto-translation-182": "Por favor completa la configuración de tu cuenta antes de unirte a equipos.",
    "__stack-auto-translation-183": "Por favor, verifica que tengas el enlace correcto para restablecer la contraseña.",
    "__stack-auto-translation-184": "Por favor, verifique si tiene el enlace de invitación al equipo correcto.",
    "__stack-auto-translation-185": "Por favor, ingrese un nombre de equipo",
    "__stack-auto-translation-186": "Por favor, ingrese un correo electrónico válido",
    "__stack-auto-translation-187": "Por favor, ingrese una dirección de correo electrónico válida",
    "__stack-auto-translation-188": "Por favor, ingrese una dirección de correo electrónico",
    "__stack-auto-translation-189": "Por favor ingrese su correo electrónico",
    "__stack-auto-translation-19": "¿Está seguro de que desea deshabilitar el inicio de sesión con OTP? Ya no podrá iniciar sesión solo con correos electrónicos.",
    "__stack-auto-translation-190": "Por favor, ingrese su contraseña anterior",
    "__stack-auto-translation-191": "Por favor ingrese su contraseña",
    "__stack-auto-translation-192": "Por favor repita su contraseña",
    "__stack-auto-translation-193": "Inténtelo de nuevo y si el problema persiste, comuníquese con soporte.",
    "__stack-auto-translation-194": "Por favor verifica tu dirección de correo electrónico ",
    "__stack-auto-translation-195": "Por favor, verifique su correo electrónico primero",
    "__stack-auto-translation-196": "Principal",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Imagen de perfil",
    "__stack-auto-translation-199": "Registrar una clave de acceso",
    "__stack-auto-translation-2": "Configuración de cuenta",
    "__stack-auto-translation-20": "¿Estás seguro de que quieres deshabilitar el inicio de sesión con clave de acceso? Ya no podrás iniciar sesión con tu clave de acceso.",
    "__stack-auto-translation-200": "Eliminar",
    "__stack-auto-translation-201": "Se renueva el",
    "__stack-auto-translation-202": "Repetir nueva contraseña",
    "__stack-auto-translation-203": "Repetir Nueva Contraseña",
    "__stack-auto-translation-204": "Repetir contraseña",
    "__stack-auto-translation-205": "Reenviar correo de verificación",
    "__stack-auto-translation-206": "Restablecer Contraseña",
    "__stack-auto-translation-207": "Restablecer su contraseña",
    "__stack-auto-translation-208": "Revisa facturas y recibos anteriores.",
    "__stack-auto-translation-209": "Revocar",
    "__stack-auto-translation-21": "¿Estás seguro de que quieres abandonar el equipo?",
    "__stack-auto-translation-210": "Revocar todas las otras sesiones",
    "__stack-auto-translation-211": "Guardar",
    "__stack-auto-translation-212": "Escanea este código QR con tu aplicación de autenticación:",
    "__stack-auto-translation-213": "Clave API secreta",
    "__stack-auto-translation-214": "Selecciona un nuevo plan de la misma línea de productos.",
    "__stack-auto-translation-215": "Enviar correo",
    "__stack-auto-translation-216": "Enviar Correo",
    "__stack-auto-translation-217": "Enviar correo de verificación",
    "__stack-auto-translation-218": "Sesión",
    "__stack-auto-translation-219": "Establezca una contraseña para su cuenta",
    "__stack-auto-translation-22": "Autorización Fallida",
    "__stack-auto-translation-220": "Establecer como principal",
    "__stack-auto-translation-221": "Establecer contraseña",
    "__stack-auto-translation-222": "Establecer Contraseña",
    "__stack-auto-translation-223": "Configuración",
    "__stack-auto-translation-224": "Iniciar sesión",
    "__stack-auto-translation-225": "Iniciar sesión",
    "__stack-auto-translation-226": "Iniciar sesión de nuevo",
    "__stack-auto-translation-227": "Inicie sesión o cree una cuenta para unirse al equipo.",
    "__stack-auto-translation-228": "Inicia sesión en tu cuenta",
    "__stack-auto-translation-229": "Iniciar sesión con clave de acceso",
    "__stack-auto-translation-23": "Autorizar",
    "__stack-auto-translation-230": "Iniciar sesión con {provider}",
    "__stack-auto-translation-231": "Cerrar sesión",
    "__stack-auto-translation-232": "Registrarse",
    "__stack-auto-translation-233": "Registrarse",
    "__stack-auto-translation-234": "En este momento no está habilitado el registro para nuevos usuarios.",
    "__stack-auto-translation-235": "Registrarse con clave de acceso",
    "__stack-auto-translation-236": "Registrarse con {provider}",
    "__stack-auto-translation-237": "¡Sesión iniciada con éxito!",
    "__stack-auto-translation-238": "Iniciado sesión {time}",
    "__stack-auto-translation-239": "Algo salió mal al procesar la devolución de llamada de OAuth:",
    "__stack-auto-translation-24": "Autorizar Aplicación CLI",
    "__stack-auto-translation-240": "Estado",
    "__stack-auto-translation-241": "Dejar de usar para iniciar sesión",
    "__stack-auto-translation-242": "Suscripción",
    "__stack-auto-translation-243": "Cambiar plan",
    "__stack-auto-translation-244": "La creación de equipos está deshabilitada en modo demo",
    "__stack-auto-translation-245": "La creación de equipos no está habilitada",
    "__stack-auto-translation-246": "Nombre de visualización del equipo",
    "__stack-auto-translation-247": "Invitación al equipo",
    "__stack-auto-translation-248": "Imagen de perfil del equipo",
    "__stack-auto-translation-249": "Nombre de usuario del equipo",
    "__stack-auto-translation-25": "Autorizando...",
    "__stack-auto-translation-250": "Equipos",
    "__stack-auto-translation-251": "La aplicación CLI ha sido autorizada exitosamente. Puedes cerrar esta ventana y regresar a la línea de comandos.",
    "__stack-auto-translation-252": "El enlace mágico ya ha sido utilizado. El enlace solo puede usarse una vez. Por favor, solicita un nuevo enlace mágico si necesitas iniciar sesión nuevamente.",
    "__stack-auto-translation-253": "La operación de inicio de sesión ha sido cancelada o denegada. Por favor, inténtelo de nuevo.",
    "__stack-auto-translation-254": "El usuario ya está conectado a otra cuenta de OAuth. ¿Quizás seleccionaste la cuenta incorrecta en la página del proveedor de OAuth?",
    "__stack-auto-translation-255": "Luego, ingrese su código MFA de seis dígitos:",
    "__stack-auto-translation-256": "Estos son los dispositivos donde has iniciado sesión actualmente. Puedes revocar el acceso para finalizar una sesión.",
    "__stack-auto-translation-257": "Esta cuenta ya está conectada a otro usuario. Por favor, conecta una cuenta diferente.",
    "__stack-auto-translation-258": "Este correo electrónico ya está siendo usado para iniciar sesión por otro usuario.",
    "__stack-auto-translation-259": "Este es un nombre para mostrar y no se usa para autenticación",
    "__stack-auto-translation-26": "Cancelar",
    "__stack-auto-translation-260": "Es muy probable que esto sea un error en Stack. Por favor, repórtelo.",
    "__stack-auto-translation-261": "Este enlace para restablecer la contraseña ya ha sido utilizado. Si necesita restablecer su contraseña nuevamente, solicite un nuevo enlace desde la página de inicio de sesión.",
    "__stack-auto-translation-262": "Este enlace de invitación al equipo ya ha sido utilizado.",
    "__stack-auto-translation-263": "Para activar el inicio de sesión con OTP, agregue un correo electrónico de inicio de sesión verificado.",
    "__stack-auto-translation-264": "Para activar el inicio de sesión con clave de acceso, agregue un correo electrónico de inicio de sesión verificado.",
    "__stack-auto-translation-265": "Para establecer una contraseña, agregue un correo electrónico de inicio de sesión.",
    "__stack-auto-translation-266": "Cambiar tema",
    "__stack-auto-translation-267": "Código QR de autenticación multifactor TOTP",
    "__stack-auto-translation-268": "Intentar de nuevo",
    "__stack-auto-translation-269": "No disponible",
    "__stack-auto-translation-27": "Cancelar suscripción",
    "__stack-auto-translation-270": "Incobrable",
    "__stack-auto-translation-271": "Desconocido",
    "__stack-auto-translation-272": "No verificado",
    "__stack-auto-translation-273": "Actualizar contraseña",
    "__stack-auto-translation-274": "Actualizar Contraseña",
    "__stack-auto-translation-275": "Actualizar método de pago",
    "__stack-auto-translation-276": "Actualiza tu contraseña",
    "__stack-auto-translation-277": "Sube una imagen para tu equipo",
    "__stack-auto-translation-278": "Sube tu propia imagen como tu avatar",
    "__stack-auto-translation-279": "Usar para iniciar sesión",
    "__stack-auto-translation-28": "Cancelar detendrá las renovaciones futuras de esta suscripción.",
    "__stack-auto-translation-280": "Usado para iniciar sesión",
    "__stack-auto-translation-281": "Enlace de Restablecimiento de Contraseña Usado",
    "__stack-auto-translation-282": "Enlace de Invitación Utilizado",
    "__stack-auto-translation-283": "Usuario",
    "__stack-auto-translation-284": "Nombre de usuario",
    "__stack-auto-translation-285": "La verificación falló",
    "__stack-auto-translation-286": "¡Verificado! Redirigiendo...",
    "__stack-auto-translation-287": "Verificar",
    "__stack-auto-translation-288": "Verificando...",
    "__stack-auto-translation-289": "Ver",
    "__stack-auto-translation-29": "cambiar",
    "__stack-auto-translation-290": "Ver tus planes activos y compras.",
    "__stack-auto-translation-291": "Anulada",
    "__stack-auto-translation-292": "ADVERTENCIA: Asegúrese de confiar en la aplicación de línea de comandos, ya que obtendrá acceso a su cuenta. Si no inició esta solicitud, puede cerrar esta página e ignorarla. Nunca le enviaremos este enlace por correo electrónico ni por ningún otro medio.",
    "__stack-auto-translation-293": "Ya has iniciado sesión",
    "__stack-auto-translation-294": "No estás conectado actualmente.",
    "__stack-auto-translation-295": "No puedes eliminar tu último correo electrónico de inicio de sesión",
    "__stack-auto-translation-296": "No puedes revocar tu sesión actual",
    "__stack-auto-translation-297": "¡Tu correo electrónico ha sido verificado!",
    "__stack-auto-translation-298": "Aún no has completado la configuración de tu cuenta. Por favor contacta a soporte si crees que esto es un error.",
    "__stack-auto-translation-299": "Tu correo electrónico",
    "__stack-auto-translation-3": "Configuración de cuenta",
    "__stack-auto-translation-30": "Cambiar plan",
    "__stack-auto-translation-300": "Su enlace de verificación de correo electrónico ha expirado. Por favor, solicite un nuevo enlace de verificación desde la configuración de su cuenta.",
    "__stack-auto-translation-301": "Su enlace mágico ha expirado. Por favor, solicite un nuevo enlace mágico si necesita iniciar sesión.",
    "__stack-auto-translation-302": "Tu contraseña ha sido restablecida. Ahora puedes iniciar sesión con tu nueva contraseña.",
    "__stack-auto-translation-303": "Su enlace para restablecer la contraseña ha expirado. Por favor, solicite un nuevo enlace desde la página de inicio de sesión.",
    "__stack-auto-translation-304": "Su enlace de invitación al equipo ha expirado. Por favor, solicite un nuevo enlace de invitación al equipo",
    "__stack-auto-translation-31": "Cambiar el nombre visible de tu equipo",
    "__stack-auto-translation-32": "Elegir un plan",
    "__stack-auto-translation-33": "Elige qué correos electrónicos quieres recibir",
    "__stack-auto-translation-34": "Autorización de CLI exitosa",
    "__stack-auto-translation-35": "haga clic aquí",
    "__stack-auto-translation-36": "Haz clic en el botón de abajo para reenviar el enlace de verificación.",
    "__stack-auto-translation-37": "Cerrar",
    "__stack-auto-translation-38": "Completar configuración",
    "__stack-auto-translation-39": "Completa la configuración de tu cuenta",
    "__stack-auto-translation-4": "Planes activos",
    "__stack-auto-translation-40": "Confirmar",
    "__stack-auto-translation-41": "Continuar",
    "__stack-auto-translation-42": "Cópiala en un lugar seguro. No podrás verla de nuevo.",
    "__stack-auto-translation-43": "No se pudo recortar la imagen.",
    "__stack-auto-translation-44": "Crear",
    "__stack-auto-translation-45": "Crear una cuenta nueva",
    "__stack-auto-translation-46": "Crear un equipo",
    "__stack-auto-translation-47": "Crear un equipo",
    "__stack-auto-translation-48": "Crear Clave API",
    "__stack-auto-translation-49": "Paquete de créditos",
    "__stack-auto-translation-5": "Sesiones Activas",
    "__stack-auto-translation-50": "Sesión actual",
    "__stack-auto-translation-51": "Equipo actual",
    "__stack-auto-translation-52": "Zona de peligro",
    "__stack-auto-translation-53": "Fecha",
    "__stack-auto-translation-54": "Eliminar cuenta",
    "__stack-auto-translation-55": "Eliminar cuenta",
    "__stack-auto-translation-56": "Eliminar clave de acceso",
    "__stack-auto-translation-57": "Descripción",
    "__stack-auto-translation-58": "Se requiere una descripción",
    "__stack-auto-translation-59": "Deshabilitar",
    "__stack-auto-translation-6": "Agregar",
    "__stack-auto-translation-60": "Deshabilitar MFA",
    "__stack-auto-translation-61": "Deshabilitar OTP",
    "__stack-auto-translation-62": "Nombre para mostrar",
    "__stack-auto-translation-63": "¿Desea iniciar sesión?",
    "__stack-auto-translation-64": "¿Quieres verificar tu correo electrónico?",
    "__stack-auto-translation-65": "¿No tienes una cuenta?",
    "__stack-auto-translation-66": "¿No necesitas restablecer?",
    "__stack-auto-translation-67": "Borrador",
    "__stack-auto-translation-68": "p. ej. Desarrollo, Producción, CI/CD",
    "__stack-auto-translation-69": "Correo electrónico",
    "__stack-auto-translation-7": "Agrega un método de pago antes de cambiar de plan.",
    "__stack-auto-translation-70": "Correo y contraseña",
    "__stack-auto-translation-71": "El correo electrónico ya existe",
    "__stack-auto-translation-72": "El correo electrónico es obligatorio",
    "__stack-auto-translation-73": "La administración de correo electrónico no está disponible en modo demo.",
    "__stack-auto-translation-74": "¡Correo enviado!",
    "__stack-auto-translation-75": "Correos electrónicos",
    "__stack-auto-translation-76": "Correos electrónicos y autenticación",
    "__stack-auto-translation-77": "Activar MFA",
    "__stack-auto-translation-78": "Activar OTP",
    "__stack-auto-translation-79": "Activar inicio de sesión mediante enlace mágico o OTP enviado a sus correos electrónicos de inicio de sesión.",
    "__stack-auto-translation-8": "Agregar un correo electrónico",
    "__stack-auto-translation-80": "Finalizar su sesión actual",
    "__stack-auto-translation-81": "Ingrese un nombre para mostrar para su nuevo equipo",
    "__stack-auto-translation-82": "Ingrese correo electrónico",
    "__stack-auto-translation-83": "Ingrese el código de su correo electrónico",
    "__stack-auto-translation-84": "Ingresa el código de seis dígitos de tu aplicación de autenticación",
    "__stack-auto-translation-85": "Ingresa tu correo electrónico",
    "__stack-auto-translation-86": "Enlace mágico caducado",
    "__stack-auto-translation-87": "Enlace de Restablecimiento de Contraseña Expirado",
    "__stack-auto-translation-88": "Enlace de invitación al equipo caducado",
    "__stack-auto-translation-89": "Enlace de verificación caducado",
    "__stack-auto-translation-9": "Agregar nueva clave de acceso",
    "__stack-auto-translation-90": "Vence",
    "__stack-auto-translation-91": "Vence en",
    "__stack-auto-translation-92": "No se pudo autorizar la aplicación CLI:",
    "__stack-auto-translation-93": "Error al conectar la cuenta",
    "__stack-auto-translation-94": "Fallo al restablecer contraseña",
    "__stack-auto-translation-95": "No se pudo restablecer la contraseña. Solicite un nuevo enlace de restablecimiento",
    "__stack-auto-translation-96": "¿Olvidaste tu contraseña?",
    "__stack-auto-translation-97": "Ir a inicio",
    "__stack-auto-translation-98": "Ir a inicio",
    "__stack-auto-translation-99": "Aquí está tu clave API."
  } as const)),
  "es-ES": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Una aplicación de línea de comandos está solicitando acceso a tu cuenta. Haz clic en el botón de abajo para autorizarla.",
    "__stack-auto-translation-10": "Añade tu dirección de correo electrónico",
    "__stack-auto-translation-100": "Entiendo que no podré ver esta clave de nuevo.",
    "__stack-auto-translation-101": "Si el usuario con esta dirección de correo existe, se ha enviado un correo a su bandeja de entrada. Asegúrese de revisar su carpeta de spam.",
    "__stack-auto-translation-102": "Si no es redirigido automáticamente, ",
    "__stack-auto-translation-103": "Ignorar",
    "__stack-auto-translation-104": "Suplantación",
    "__stack-auto-translation-105": "Código incorrecto. Por favor, inténtelo de nuevo.",
    "__stack-auto-translation-106": "Contraseña incorrecta",
    "__stack-auto-translation-107": "Código no válido",
    "__stack-auto-translation-108": "Imagen no válida",
    "__stack-auto-translation-109": "Enlace Mágico No Válido",
    "__stack-auto-translation-11": "¿Ya tienes una cuenta?",
    "__stack-auto-translation-110": "Enlace de restablecimiento de contraseña no válido",
    "__stack-auto-translation-111": "Enlace de invitación al equipo no válido",
    "__stack-auto-translation-112": "Código TOTP no válido",
    "__stack-auto-translation-113": "Enlace de verificación no válido",
    "__stack-auto-translation-114": "Invita a un usuario a tu equipo por correo electrónico",
    "__stack-auto-translation-115": "Invitar miembro",
    "__stack-auto-translation-116": "Invitar usuario",
    "__stack-auto-translation-117": "Factura",
    "__stack-auto-translation-118": "Facturas",
    "__stack-auto-translation-119": "Dirección IP",
    "__stack-auto-translation-12": "Importe",
    "__stack-auto-translation-120": "Unirse",
    "__stack-auto-translation-121": "Último uso",
    "__stack-auto-translation-122": "Salir",
    "__stack-auto-translation-123": "Abandonar equipo",
    "__stack-auto-translation-124": "Abandonar equipo",
    "__stack-auto-translation-125": "abandonar este equipo y eliminar tu perfil de equipo",
    "__stack-auto-translation-126": "Ubicación",
    "__stack-auto-translation-127": "Enlace mágico ya utilizado",
    "__stack-auto-translation-128": "Gestiona el método de pago predeterminado para suscripciones y facturas.",
    "__stack-auto-translation-129": "Miembros",
    "__stack-auto-translation-13": "Se produjo un error desconocido",
    "__stack-auto-translation-130": "La gestión de MFA no está disponible en modo demo.",
    "__stack-auto-translation-131": "Falta información de verificación",
    "__stack-auto-translation-132": "Autenticación de múltiples factores",
    "__stack-auto-translation-133": "Autenticación de múltiples factores",
    "__stack-auto-translation-134": "La autenticación de múltiples factores está actualmente desactivada.",
    "__stack-auto-translation-135": "La autenticación de múltiples factores está actualmente habilitada.",
    "__stack-auto-translation-136": "Mi perfil",
    "__stack-auto-translation-137": "Nombre",
    "__stack-auto-translation-138": "Nunca",
    "__stack-auto-translation-139": "No se permite el registro de nuevas cuentas",
    "__stack-auto-translation-14": "Clave API",
    "__stack-auto-translation-140": "Nueva contraseña",
    "__stack-auto-translation-141": "Nueva contraseña",
    "__stack-auto-translation-142": "No se encontraron sesiones activas",
    "__stack-auto-translation-143": "Ningún método de autenticación habilitado.",
    "__stack-auto-translation-144": "Sin método de pago predeterminado",
    "__stack-auto-translation-145": "Nombre visible no establecido",
    "__stack-auto-translation-146": "No hay otros planes disponibles para esta suscripción.",
    "__stack-auto-translation-147": "No hay invitaciones pendientes",
    "__stack-auto-translation-148": "Sin equipo",
    "__stack-auto-translation-149": "Sin equipos aún",
    "__stack-auto-translation-15": "Claves API",
    "__stack-auto-translation-150": "No has iniciado sesión",
    "__stack-auto-translation-151": "Notificaciones",
    "__stack-auto-translation-152": "Acceso denegado al proveedor de OAuth",
    "__stack-auto-translation-153": "Contraseña anterior",
    "__stack-auto-translation-154": "Contraseña de un solo uso",
    "__stack-auto-translation-155": "Compra única",
    "__stack-auto-translation-156": "Abierta",
    "__stack-auto-translation-157": "O continuar con",
    "__stack-auto-translation-158": "Otra sesión",
    "__stack-auto-translation-159": "Otros equipos",
    "__stack-auto-translation-16": "Las claves API otorgan acceso programático a tu cuenta.",
    "__stack-auto-translation-160": "La gestión de OTP no está disponible en modo demostración.",
    "__stack-auto-translation-161": "Inicio de sesión por OTP",
    "__stack-auto-translation-162": "El inicio de sesión por OTP está habilitado y no se puede deshabilitar ya que actualmente es el único método de inicio de sesión",
    "__stack-auto-translation-163": "El inicio de sesión por OTP/enlace mágico está actualmente habilitado.",
    "__stack-auto-translation-164": "Invitaciones pendientes",
    "__stack-auto-translation-165": "Sobrescribe tu nombre para mostrar en este equipo",
    "__stack-auto-translation-166": "Pagado",
    "__stack-auto-translation-167": "Clave de acceso",
    "__stack-auto-translation-168": "La gestión de claves de acceso no está disponible en modo demo.",
    "__stack-auto-translation-169": "Clave de acceso registrada",
    "__stack-auto-translation-17": "Las claves API otorgan acceso programático a tu equipo.",
    "__stack-auto-translation-170": "El inicio de sesión con clave de acceso está habilitado y no se puede deshabilitar ya que es el único método de inicio de sesión actual",
    "__stack-auto-translation-171": "Contraseña",
    "__stack-auto-translation-172": "La gestión de contraseñas no está disponible en modo demo.",
    "__stack-auto-translation-173": "¡Contraseña restablecida correctamente!",
    "__stack-auto-translation-174": "Las contraseñas no coinciden",
    "__stack-auto-translation-175": "Método de pago",
    "__stack-auto-translation-176": "Pagos",
    "__stack-auto-translation-177": "Eliminar permanentemente tu cuenta y todos los datos asociados",
    "__stack-auto-translation-178": "Personal",
    "__stack-auto-translation-179": "Por favor, añade una dirección de correo electrónico para completar la configuración de tu cuenta. Te enviaremos un email de verificación.",
    "__stack-auto-translation-18": "¿Estás seguro de que quieres eliminar tu cuenta? Esta acción es IRREVERSIBLE y eliminará TODOS los datos asociados.",
    "__stack-auto-translation-180": "Por favor, verifique si tiene el enlace correcto. Si continúa teniendo problemas, contacte con soporte.",
    "__stack-auto-translation-181": "Por favor, revisa tu bandeja de entrada",
    "__stack-auto-translation-182": "Por favor, completa la configuración de tu cuenta antes de unirte a equipos.",
    "__stack-auto-translation-183": "Por favor, verifique si tiene el enlace correcto para restablecer la contraseña.",
    "__stack-auto-translation-184": "Por favor, comprueba si tienes el enlace de invitación al equipo correcto.",
    "__stack-auto-translation-185": "Introduce un nombre de equipo",
    "__stack-auto-translation-186": "Por favor, introduce un email válido",
    "__stack-auto-translation-187": "Por favor, introduzca una dirección de correo electrónico válida",
    "__stack-auto-translation-188": "Por favor, introduzca una dirección de email",
    "__stack-auto-translation-189": "Introduzca su correo electrónico",
    "__stack-auto-translation-19": "¿Está seguro de que desea deshabilitar el inicio de sesión por OTP? Ya no podrá iniciar sesión solo con correos electrónicos.",
    "__stack-auto-translation-190": "Por favor, introduce tu contraseña antigua",
    "__stack-auto-translation-191": "Por favor, ingrese su contraseña",
    "__stack-auto-translation-192": "Por favor, repita su contraseña",
    "__stack-auto-translation-193": "Inténtelo de nuevo y, si el problema persiste, contacte con soporte.",
    "__stack-auto-translation-194": "Por favor, verifica tu dirección de email ",
    "__stack-auto-translation-195": "Por favor, verifica tu email primero",
    "__stack-auto-translation-196": "Principal",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Imagen de perfil",
    "__stack-auto-translation-199": "Registrar una clave de acceso",
    "__stack-auto-translation-2": "Configuración de la cuenta",
    "__stack-auto-translation-20": "¿Está seguro de que desea deshabilitar el inicio de sesión con clave de acceso? Ya no podrá iniciar sesión con su clave de acceso.",
    "__stack-auto-translation-200": "Eliminar",
    "__stack-auto-translation-201": "Se renueva el",
    "__stack-auto-translation-202": "Repita la nueva contraseña",
    "__stack-auto-translation-203": "Repita la nueva contraseña",
    "__stack-auto-translation-204": "Repetir Contraseña",
    "__stack-auto-translation-205": "Reenviar correo de verificación",
    "__stack-auto-translation-206": "Restablecer Contraseña",
    "__stack-auto-translation-207": "Restablecer tu contraseña",
    "__stack-auto-translation-208": "Revisa facturas y recibos anteriores.",
    "__stack-auto-translation-209": "Revocar",
    "__stack-auto-translation-21": "¿Está seguro de que desea abandonar el equipo?",
    "__stack-auto-translation-210": "Revocar todas las demás sesiones",
    "__stack-auto-translation-211": "Guardar",
    "__stack-auto-translation-212": "Escanea este código QR con tu aplicación de autenticación:",
    "__stack-auto-translation-213": "Clave API secreta",
    "__stack-auto-translation-214": "Selecciona un nuevo plan de la misma línea de productos.",
    "__stack-auto-translation-215": "Enviar correo",
    "__stack-auto-translation-216": "Enviar correo",
    "__stack-auto-translation-217": "Enviar correo de verificación",
    "__stack-auto-translation-218": "Sesión",
    "__stack-auto-translation-219": "Establece una contraseña para tu cuenta",
    "__stack-auto-translation-22": "Autorización fallida",
    "__stack-auto-translation-220": "Establecer como principal",
    "__stack-auto-translation-221": "Establecer contraseña",
    "__stack-auto-translation-222": "Establecer contraseña",
    "__stack-auto-translation-223": "Configuración",
    "__stack-auto-translation-224": "Iniciar sesión",
    "__stack-auto-translation-225": "Iniciar sesión",
    "__stack-auto-translation-226": "Iniciar sesión de nuevo",
    "__stack-auto-translation-227": "Inicia sesión o crea una cuenta para unirte al equipo.",
    "__stack-auto-translation-228": "Iniciar sesión en tu cuenta",
    "__stack-auto-translation-229": "Iniciar sesión con Clave de acceso",
    "__stack-auto-translation-23": "Autorizar",
    "__stack-auto-translation-230": "Iniciar sesión con {provider}",
    "__stack-auto-translation-231": "Cerrar sesión",
    "__stack-auto-translation-232": "Registrarse",
    "__stack-auto-translation-233": "Registrarse",
    "__stack-auto-translation-234": "El registro de nuevos usuarios no está habilitado en este momento.",
    "__stack-auto-translation-235": "Registrarse con Clave de acceso",
    "__stack-auto-translation-236": "Registrarse con {provider}",
    "__stack-auto-translation-237": "¡Sesión iniciada con éxito!",
    "__stack-auto-translation-238": "Iniciado sesión {time}",
    "__stack-auto-translation-239": "Algo salió mal al procesar la devolución de llamada de OAuth:",
    "__stack-auto-translation-24": "Autorizar aplicación CLI",
    "__stack-auto-translation-240": "Estado",
    "__stack-auto-translation-241": "Dejar de usar para iniciar sesión",
    "__stack-auto-translation-242": "Suscripción",
    "__stack-auto-translation-243": "Cambiar plan",
    "__stack-auto-translation-244": "La creación de equipos está deshabilitada en modo demo",
    "__stack-auto-translation-245": "La creación de equipos no está habilitada",
    "__stack-auto-translation-246": "Nombre visible del equipo",
    "__stack-auto-translation-247": "Invitación al equipo",
    "__stack-auto-translation-248": "Imagen de perfil del equipo",
    "__stack-auto-translation-249": "Nombre de usuario del equipo",
    "__stack-auto-translation-25": "Autorizando...",
    "__stack-auto-translation-250": "Equipos",
    "__stack-auto-translation-251": "La aplicación CLI se ha autorizado correctamente. Puedes cerrar esta ventana y volver a la línea de comandos.",
    "__stack-auto-translation-252": "El enlace mágico ya ha sido utilizado. El enlace solo se puede usar una vez. Por favor, solicita un nuevo enlace mágico si necesitas iniciar sesión de nuevo.",
    "__stack-auto-translation-253": "La operación de inicio de sesión ha sido cancelada o denegada. Por favor, inténtelo de nuevo.",
    "__stack-auto-translation-254": "El usuario ya está conectado a otra cuenta OAuth. ¿Quizás seleccionó la cuenta equivocada en la página del proveedor OAuth?",
    "__stack-auto-translation-255": "Luego, ingrese su código MFA de seis dígitos:",
    "__stack-auto-translation-256": "Estos son los dispositivos donde has iniciado sesión actualmente. Puedes revocar el acceso para finalizar una sesión.",
    "__stack-auto-translation-257": "Esta cuenta ya está conectada a otro usuario. Por favor, conecta una cuenta diferente.",
    "__stack-auto-translation-258": "Este email ya está siendo usado para iniciar sesión por otro usuario.",
    "__stack-auto-translation-259": "Este es un nombre visible y no se utiliza para la autenticación",
    "__stack-auto-translation-26": "Cancelar",
    "__stack-auto-translation-260": "Es probable que sea un error en Stack. Por favor, repórtelo.",
    "__stack-auto-translation-261": "Este enlace para restablecer la contraseña ya ha sido utilizado. Si necesita restablecer su contraseña de nuevo, solicite un nuevo enlace desde la página de inicio de sesión.",
    "__stack-auto-translation-262": "Este enlace de invitación al equipo ya ha sido utilizado.",
    "__stack-auto-translation-263": "Para habilitar el inicio de sesión por OTP, añada un email de inicio de sesión verificado.",
    "__stack-auto-translation-264": "Para habilitar el inicio de sesión con clave de acceso, añada un email de inicio de sesión verificado.",
    "__stack-auto-translation-265": "Para establecer una contraseña, añade un email de inicio de sesión.",
    "__stack-auto-translation-266": "Cambiar tema",
    "__stack-auto-translation-267": "Código QR de autenticación multifactor TOTP",
    "__stack-auto-translation-268": "Intentar de nuevo",
    "__stack-auto-translation-269": "No disponible",
    "__stack-auto-translation-27": "Cancelar suscripción",
    "__stack-auto-translation-270": "Incobrable",
    "__stack-auto-translation-271": "Desconocido",
    "__stack-auto-translation-272": "Sin verificar",
    "__stack-auto-translation-273": "Actualizar contraseña",
    "__stack-auto-translation-274": "Actualizar Contraseña",
    "__stack-auto-translation-275": "Actualizar método de pago",
    "__stack-auto-translation-276": "Actualiza tu contraseña",
    "__stack-auto-translation-277": "Sube una imagen para tu equipo",
    "__stack-auto-translation-278": "Sube tu propia imagen como avatar",
    "__stack-auto-translation-279": "Usar para iniciar sesión",
    "__stack-auto-translation-28": "Cancelar detendrá las renovaciones futuras de esta suscripción.",
    "__stack-auto-translation-280": "Usado para iniciar sesión",
    "__stack-auto-translation-281": "Enlace de restablecimiento de contraseña utilizado",
    "__stack-auto-translation-282": "Enlace de invitación al equipo utilizado",
    "__stack-auto-translation-283": "Usuario",
    "__stack-auto-translation-284": "Nombre de usuario",
    "__stack-auto-translation-285": "Verificación fallida",
    "__stack-auto-translation-286": "¡Verificado! Redirigiendo...",
    "__stack-auto-translation-287": "Verificar",
    "__stack-auto-translation-288": "Verificando...",
    "__stack-auto-translation-289": "Ver",
    "__stack-auto-translation-29": "cambiar",
    "__stack-auto-translation-290": "Ver tus planes activos y compras.",
    "__stack-auto-translation-291": "Anulada",
    "__stack-auto-translation-292": "ADVERTENCIA: Asegúrate de confiar en la aplicación de línea de comandos, ya que obtendrá acceso a tu cuenta. Si no iniciaste esta solicitud, puedes cerrar esta página e ignorarla. Nunca te enviaremos este enlace por correo electrónico ni por ningún otro medio.",
    "__stack-auto-translation-293": "Ya has iniciado sesión",
    "__stack-auto-translation-294": "No está registrado actualmente.",
    "__stack-auto-translation-295": "No puedes eliminar tu último email de inicio de sesión",
    "__stack-auto-translation-296": "No puedes revocar tu sesión actual",
    "__stack-auto-translation-297": "¡Tu email ha sido verificado!",
    "__stack-auto-translation-298": "Aún no has completado la configuración de tu cuenta. Por favor, contacta con soporte si crees que esto es un error.",
    "__stack-auto-translation-299": "Tu correo electrónico",
    "__stack-auto-translation-3": "Configuración de la cuenta",
    "__stack-auto-translation-30": "Cambiar plan",
    "__stack-auto-translation-300": "Su enlace de verificación de correo electrónico ha caducado. Por favor, solicite un nuevo enlace de verificación desde la configuración de su cuenta.",
    "__stack-auto-translation-301": "Su enlace mágico ha caducado. Por favor, solicite un nuevo enlace mágico si necesita iniciar sesión.",
    "__stack-auto-translation-302": "Tu contraseña ha sido restablecida. Ahora puedes iniciar sesión con tu nueva contraseña.",
    "__stack-auto-translation-303": "Tu enlace para restablecer la contraseña ha caducado. Solicita un nuevo enlace desde la página de inicio de sesión.",
    "__stack-auto-translation-304": "Tu enlace de invitación al equipo ha caducado. Por favor, solicita un nuevo enlace de invitación",
    "__stack-auto-translation-31": "Cambiar el nombre visible de tu equipo",
    "__stack-auto-translation-32": "Elegir un plan",
    "__stack-auto-translation-33": "Elige qué correos electrónicos quieres recibir",
    "__stack-auto-translation-34": "Autorización de CLI exitosa",
    "__stack-auto-translation-35": "haga clic aquí",
    "__stack-auto-translation-36": "Haz clic en el botón de abajo para reenviar el enlace de verificación.",
    "__stack-auto-translation-37": "Cerrar",
    "__stack-auto-translation-38": "Completar configuración",
    "__stack-auto-translation-39": "Completa la configuración de tu cuenta",
    "__stack-auto-translation-4": "Planes activos",
    "__stack-auto-translation-40": "Confirmar",
    "__stack-auto-translation-41": "Continuar",
    "__stack-auto-translation-42": "Cópiala en un lugar seguro. No podrás verla de nuevo.",
    "__stack-auto-translation-43": "No se pudo recortar la imagen.",
    "__stack-auto-translation-44": "Crear",
    "__stack-auto-translation-45": "Crear una nueva cuenta",
    "__stack-auto-translation-46": "Crear un equipo",
    "__stack-auto-translation-47": "Crear un equipo",
    "__stack-auto-translation-48": "Crear clave API",
    "__stack-auto-translation-49": "Paquete de créditos",
    "__stack-auto-translation-5": "Sesiones activas",
    "__stack-auto-translation-50": "Sesión actual",
    "__stack-auto-translation-51": "Equipo actual",
    "__stack-auto-translation-52": "Zona de peligro",
    "__stack-auto-translation-53": "Fecha",
    "__stack-auto-translation-54": "Eliminar cuenta",
    "__stack-auto-translation-55": "Eliminar cuenta",
    "__stack-auto-translation-56": "Eliminar clave de acceso",
    "__stack-auto-translation-57": "Descripción",
    "__stack-auto-translation-58": "La descripción es obligatoria",
    "__stack-auto-translation-59": "Deshabilitar",
    "__stack-auto-translation-6": "Añadir",
    "__stack-auto-translation-60": "Deshabilitar MFA",
    "__stack-auto-translation-61": "Deshabilitar OTP",
    "__stack-auto-translation-62": "Nombre visible",
    "__stack-auto-translation-63": "¿Quieres iniciar sesión?",
    "__stack-auto-translation-64": "¿Quieres verificar tu email?",
    "__stack-auto-translation-65": "¿No tienes una cuenta?",
    "__stack-auto-translation-66": "¿No necesitas restablecer?",
    "__stack-auto-translation-67": "Borrador",
    "__stack-auto-translation-68": "p. ej. Desarrollo, Producción, CI/CD",
    "__stack-auto-translation-69": "Correo electrónico",
    "__stack-auto-translation-7": "Añade un método de pago antes de cambiar de plan.",
    "__stack-auto-translation-70": "Correo y contraseña",
    "__stack-auto-translation-71": "El correo electrónico ya existe",
    "__stack-auto-translation-72": "El correo electrónico es obligatorio",
    "__stack-auto-translation-73": "La gestión de correo electrónico no está disponible en modo demo.",
    "__stack-auto-translation-74": "¡Correo enviado!",
    "__stack-auto-translation-75": "Correos electrónicos",
    "__stack-auto-translation-76": "Correos electrónicos y autenticación",
    "__stack-auto-translation-77": "Habilitar MFA",
    "__stack-auto-translation-78": "Habilitar OTP",
    "__stack-auto-translation-79": "Habilitar el inicio de sesión mediante enlace mágico o OTP enviado a tus correos electrónicos de inicio de sesión.",
    "__stack-auto-translation-8": "Añadir un email",
    "__stack-auto-translation-80": "Finalizar su sesión actual",
    "__stack-auto-translation-81": "Introduce un nombre visible para tu nuevo equipo",
    "__stack-auto-translation-82": "Introducir email",
    "__stack-auto-translation-83": "Introduzca el código de su correo electrónico",
    "__stack-auto-translation-84": "Introduzca el código de seis dígitos de su aplicación de autenticación",
    "__stack-auto-translation-85": "Introduce tu email",
    "__stack-auto-translation-86": "Enlace mágico caducado",
    "__stack-auto-translation-87": "Enlace de restablecimiento de contraseña caducado",
    "__stack-auto-translation-88": "Enlace de invitación al equipo caducado",
    "__stack-auto-translation-89": "Enlace de verificación caducado",
    "__stack-auto-translation-9": "Añadir nueva clave de acceso",
    "__stack-auto-translation-90": "Caduca",
    "__stack-auto-translation-91": "Caduca en",
    "__stack-auto-translation-92": "Error al autorizar la aplicación de CLI:",
    "__stack-auto-translation-93": "Error al conectar la cuenta",
    "__stack-auto-translation-94": "Error al restablecer la contraseña",
    "__stack-auto-translation-95": "Error al restablecer la contraseña. Solicite un nuevo enlace de restablecimiento",
    "__stack-auto-translation-96": "¿Olvidaste tu contraseña?",
    "__stack-auto-translation-97": "Ir a inicio",
    "__stack-auto-translation-98": "Ir a inicio",
    "__stack-auto-translation-99": "Aquí está tu clave API."
  } as const)),
  "fr-CA": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Une application en ligne de commande demande l'accès à votre compte. Cliquez sur le bouton ci-dessous pour l'autoriser.",
    "__stack-auto-translation-10": "Ajoutez votre adresse courriel",
    "__stack-auto-translation-100": "Je comprends que je ne pourrai plus voir cette clé à nouveau.",
    "__stack-auto-translation-101": "Si l'utilisateur avec cette adresse courriel existe, un courriel a été envoyé à votre boîte de réception. Assurez-vous de vérifier votre dossier de courrier indésirable.",
    "__stack-auto-translation-102": "Si vous n'êtes pas redirigé automatiquement, ",
    "__stack-auto-translation-103": "Ignorer",
    "__stack-auto-translation-104": "Usurpation d'identité",
    "__stack-auto-translation-105": "Code incorrect. Veuillez réessayer.",
    "__stack-auto-translation-106": "Mot de passe incorrect",
    "__stack-auto-translation-107": "Code invalide",
    "__stack-auto-translation-108": "Image non valide",
    "__stack-auto-translation-109": "Lien magique invalide",
    "__stack-auto-translation-11": "Vous avez déjà un compte?",
    "__stack-auto-translation-110": "Lien de réinitialisation du mot de passe invalide",
    "__stack-auto-translation-111": "Lien d'invitation d'équipe invalide",
    "__stack-auto-translation-112": "Code TOTP non valide",
    "__stack-auto-translation-113": "Lien de vérification invalide",
    "__stack-auto-translation-114": "Invitez un utilisateur à votre équipe par courriel",
    "__stack-auto-translation-115": "Inviter un membre",
    "__stack-auto-translation-116": "Inviter l'utilisateur",
    "__stack-auto-translation-117": "Facture",
    "__stack-auto-translation-118": "Factures",
    "__stack-auto-translation-119": "Adresse IP",
    "__stack-auto-translation-12": "Montant",
    "__stack-auto-translation-120": "Joindre",
    "__stack-auto-translation-121": "Dernière utilisation",
    "__stack-auto-translation-122": "Quitter",
    "__stack-auto-translation-123": "Quitter l'équipe",
    "__stack-auto-translation-124": "Quitter l'équipe",
    "__stack-auto-translation-125": "quitter cette équipe et supprimer votre profil d'équipe",
    "__stack-auto-translation-126": "Emplacement",
    "__stack-auto-translation-127": "Lien magique déjà utilisé",
    "__stack-auto-translation-128": "Gérer le mode de paiement par défaut utilisé pour les abonnements et les factures.",
    "__stack-auto-translation-129": "Membres",
    "__stack-auto-translation-13": "Une erreur inconnue s'est produite",
    "__stack-auto-translation-130": "La gestion de l'AMF n'est pas disponible en mode démo.",
    "__stack-auto-translation-131": "Informations de vérification manquantes",
    "__stack-auto-translation-132": "Authentification à plusieurs facteurs",
    "__stack-auto-translation-133": "Authentification à plusieurs facteurs",
    "__stack-auto-translation-134": "L'authentification à plusieurs facteurs est actuellement désactivée.",
    "__stack-auto-translation-135": "L'authentification à plusieurs facteurs est actuellement activée.",
    "__stack-auto-translation-136": "Mon profil",
    "__stack-auto-translation-137": "Nom",
    "__stack-auto-translation-138": "Jamais",
    "__stack-auto-translation-139": "L'inscription de nouveaux comptes n'est pas autorisée",
    "__stack-auto-translation-14": "Clé API",
    "__stack-auto-translation-140": "Nouveau mot de passe",
    "__stack-auto-translation-141": "Nouveau mot de passe",
    "__stack-auto-translation-142": "Aucune session active trouvée",
    "__stack-auto-translation-143": "Aucune méthode d'authentification activée.",
    "__stack-auto-translation-144": "Aucun mode de paiement par défaut",
    "__stack-auto-translation-145": "Aucun nom d'affichage défini",
    "__stack-auto-translation-146": "Aucun autre forfait disponible pour cet abonnement.",
    "__stack-auto-translation-147": "Aucune invitation en attente",
    "__stack-auto-translation-148": "Aucune équipe",
    "__stack-auto-translation-149": "Aucune équipe pour l'instant",
    "__stack-auto-translation-15": "Clés d'API",
    "__stack-auto-translation-150": "Non connecté",
    "__stack-auto-translation-151": "Notifications",
    "__stack-auto-translation-152": "Accès au fournisseur OAuth refusé",
    "__stack-auto-translation-153": "Ancien mot de passe",
    "__stack-auto-translation-154": "Mot de passe à usage unique",
    "__stack-auto-translation-155": "Achat unique",
    "__stack-auto-translation-156": "Ouverte",
    "__stack-auto-translation-157": "Ou continuer avec",
    "__stack-auto-translation-158": "Autre session",
    "__stack-auto-translation-159": "Autres équipes",
    "__stack-auto-translation-16": "Les clés d'API permettent un accès programmatique à votre compte.",
    "__stack-auto-translation-160": "La gestion de l'OTP n'est pas disponible en mode démo.",
    "__stack-auto-translation-161": "Connexion par OTP",
    "__stack-auto-translation-162": "La connexion par OTP est activée et ne peut pas être désactivée car c'est actuellement la seule méthode de connexion",
    "__stack-auto-translation-163": "La connexion par OTP/lien magique est actuellement activée.",
    "__stack-auto-translation-164": "Invitations en attente",
    "__stack-auto-translation-165": "Remplacez votre nom d'affichage d'utilisateur dans cette équipe",
    "__stack-auto-translation-166": "Payé",
    "__stack-auto-translation-167": "Clé d'accès",
    "__stack-auto-translation-168": "La gestion des clés d'accès n'est pas disponible en mode démo.",
    "__stack-auto-translation-169": "Clé d'accès enregistrée",
    "__stack-auto-translation-17": "Les clés d'API permettent un accès programmatique à votre équipe.",
    "__stack-auto-translation-170": "La connexion par clé d'accès est activée et ne peut être désactivée car c'est actuellement la seule méthode de connexion",
    "__stack-auto-translation-171": "Mot de passe",
    "__stack-auto-translation-172": "La gestion des mots de passe n'est pas disponible en mode démo.",
    "__stack-auto-translation-173": "Réinitialisation du mot de passe réussie !",
    "__stack-auto-translation-174": "Les mots de passe ne correspondent pas",
    "__stack-auto-translation-175": "Mode de paiement",
    "__stack-auto-translation-176": "Paiements",
    "__stack-auto-translation-177": "Supprimer définitivement votre compte et toutes les données associées",
    "__stack-auto-translation-178": "Personnel",
    "__stack-auto-translation-179": "Veuillez ajouter une adresse courriel pour terminer la configuration de votre compte. Nous vous enverrons un courriel de vérification.",
    "__stack-auto-translation-18": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est IRRÉVERSIBLE et supprimera TOUTES les données associées.",
    "__stack-auto-translation-180": "Veuillez vérifier si vous avez le bon lien. Si les problèmes persistent, contactez le support.",
    "__stack-auto-translation-181": "Veuillez vérifier votre boîte de réception",
    "__stack-auto-translation-182": "Veuillez compléter la configuration de votre compte avant de joindre des équipes.",
    "__stack-auto-translation-183": "Veuillez vérifier si vous avez le bon lien de réinitialisation du mot de passe.",
    "__stack-auto-translation-184": "Veuillez vérifier si vous avez le bon lien d'invitation d'équipe.",
    "__stack-auto-translation-185": "Veuillez saisir un nom d'équipe",
    "__stack-auto-translation-186": "Veuillez saisir une adresse courriel valide",
    "__stack-auto-translation-187": "Veuillez saisir une adresse courriel valide",
    "__stack-auto-translation-188": "Veuillez saisir une adresse courriel",
    "__stack-auto-translation-189": "Veuillez saisir votre courriel",
    "__stack-auto-translation-19": "Êtes-vous sûr de vouloir désactiver la connexion par OTP ? Vous ne pourrez plus vous connecter uniquement avec des courriels.",
    "__stack-auto-translation-190": "Veuillez entrer votre ancien mot de passe",
    "__stack-auto-translation-191": "Veuillez entrer votre mot de passe",
    "__stack-auto-translation-192": "Veuillez répéter votre mot de passe",
    "__stack-auto-translation-193": "Veuillez réessayer et si le problème persiste, contactez le support.",
    "__stack-auto-translation-194": "Veuillez vérifier votre adresse courriel ",
    "__stack-auto-translation-195": "Veuillez d'abord vérifier votre courriel",
    "__stack-auto-translation-196": "Principal",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Image de profil",
    "__stack-auto-translation-199": "Enregistrer une clé d'accès",
    "__stack-auto-translation-2": "Paramètres du compte",
    "__stack-auto-translation-20": "Êtes-vous sûr de vouloir désactiver la connexion par clé d'accès ? Vous ne pourrez plus vous connecter avec votre clé d'accès.",
    "__stack-auto-translation-200": "Supprimer",
    "__stack-auto-translation-201": "Renouvellement le",
    "__stack-auto-translation-202": "Répétez le nouveau mot de passe",
    "__stack-auto-translation-203": "Répétez le nouveau mot de passe",
    "__stack-auto-translation-204": "Répéter le mot de passe",
    "__stack-auto-translation-205": "Renvoyer le courriel de vérification",
    "__stack-auto-translation-206": "Réinitialiser le mot de passe",
    "__stack-auto-translation-207": "Réinitialisez votre mot de passe",
    "__stack-auto-translation-208": "Consultez les factures et reçus antérieurs.",
    "__stack-auto-translation-209": "Révoquer",
    "__stack-auto-translation-21": "Êtes-vous sûr de vouloir quitter l'équipe?",
    "__stack-auto-translation-210": "Révoquer toutes les autres sessions",
    "__stack-auto-translation-211": "Enregistrer",
    "__stack-auto-translation-212": "Scannez ce code QR avec votre application d'authentification :",
    "__stack-auto-translation-213": "Clé API secrète",
    "__stack-auto-translation-214": "Sélectionnez un nouveau plan de la même gamme de produits.",
    "__stack-auto-translation-215": "Envoyer le courriel",
    "__stack-auto-translation-216": "Envoyer le courriel",
    "__stack-auto-translation-217": "Envoyer un courriel de vérification",
    "__stack-auto-translation-218": "Session",
    "__stack-auto-translation-219": "Définir un mot de passe pour votre compte",
    "__stack-auto-translation-22": "Échec de l'autorisation",
    "__stack-auto-translation-220": "Définir comme principal",
    "__stack-auto-translation-221": "Définir le mot de passe",
    "__stack-auto-translation-222": "Définir le mot de passe",
    "__stack-auto-translation-223": "Paramètres",
    "__stack-auto-translation-224": "Connexion",
    "__stack-auto-translation-225": "Se connecter",
    "__stack-auto-translation-226": "Se connecter à nouveau",
    "__stack-auto-translation-227": "Connectez-vous ou créez un compte pour rejoindre l'équipe.",
    "__stack-auto-translation-228": "Connectez-vous à votre compte",
    "__stack-auto-translation-229": "Se connecter avec clé d'accès",
    "__stack-auto-translation-23": "Autoriser",
    "__stack-auto-translation-230": "Se connecter avec {provider}",
    "__stack-auto-translation-231": "Se déconnecter",
    "__stack-auto-translation-232": "S'inscrire",
    "__stack-auto-translation-233": "S'inscrire",
    "__stack-auto-translation-234": "L'inscription de nouveaux utilisateurs n'est pas activée pour le moment.",
    "__stack-auto-translation-235": "S'inscrire avec Clé d'accès",
    "__stack-auto-translation-236": "S'inscrire avec {provider}",
    "__stack-auto-translation-237": "Connexion réussie !",
    "__stack-auto-translation-238": "Connecté(e) le {time}",
    "__stack-auto-translation-239": "Une erreur s'est produite lors du traitement du rappel OAuth :",
    "__stack-auto-translation-24": "Autoriser l'application CLI",
    "__stack-auto-translation-240": "État",
    "__stack-auto-translation-241": "Cesser d'utiliser pour la connexion",
    "__stack-auto-translation-242": "Abonnement",
    "__stack-auto-translation-243": "Changer de forfait",
    "__stack-auto-translation-244": "La création d'équipe est désactivée en mode démo",
    "__stack-auto-translation-245": "La création d'équipe n'est pas activée",
    "__stack-auto-translation-246": "Nom d'affichage de l'équipe",
    "__stack-auto-translation-247": "Invitation d'équipe",
    "__stack-auto-translation-248": "Image de profil d'équipe",
    "__stack-auto-translation-249": "Nom d'utilisateur d'équipe",
    "__stack-auto-translation-25": "Autorisation en cours...",
    "__stack-auto-translation-250": "Équipes",
    "__stack-auto-translation-251": "L'application CLI a été autorisée avec succès. Vous pouvez fermer cette fenêtre et retourner à la ligne de commande.",
    "__stack-auto-translation-252": "Le lien magique a déjà été utilisé. Le lien ne peut être utilisé qu'une seule fois. Veuillez demander un nouveau lien magique si vous devez vous reconnecter.",
    "__stack-auto-translation-253": "L'opération de connexion a été annulée ou refusée. Veuillez réessayer.",
    "__stack-auto-translation-254": "L'utilisateur est déjà connecté à un autre compte OAuth. Avez-vous peut-être sélectionné le mauvais compte sur la page du fournisseur OAuth ?",
    "__stack-auto-translation-255": "Ensuite, saisissez votre code MFA à six chiffres :",
    "__stack-auto-translation-256": "Voici les appareils sur lesquels vous êtes actuellement connecté. Vous pouvez révoquer l'accès pour mettre fin à une session.",
    "__stack-auto-translation-257": "Ce compte est déjà associé à un autre utilisateur. Veuillez connecter un compte différent.",
    "__stack-auto-translation-258": "Ce courriel est déjà utilisé pour la connexion par un autre utilisateur.",
    "__stack-auto-translation-259": "Il s'agit d'un nom d'affichage et n'est pas utilisé pour l'authentification",
    "__stack-auto-translation-26": "Annuler",
    "__stack-auto-translation-260": "Il s'agit probablement d'une erreur dans Stack. Veuillez la signaler.",
    "__stack-auto-translation-261": "Ce lien de réinitialisation de mot de passe a déjà été utilisé. Si vous devez à nouveau réinitialiser votre mot de passe, veuillez demander un nouveau lien depuis la page de connexion.",
    "__stack-auto-translation-262": "Ce lien d'invitation d'équipe a déjà été utilisé.",
    "__stack-auto-translation-263": "Pour activer la connexion par OTP, veuillez ajouter un courriel de connexion vérifié.",
    "__stack-auto-translation-264": "Pour activer la connexion par clé d'accès, veuillez ajouter un courriel de connexion vérifié.",
    "__stack-auto-translation-265": "Pour définir un mot de passe, veuillez ajouter un courriel de connexion.",
    "__stack-auto-translation-266": "Changer de thème",
    "__stack-auto-translation-267": "Code QR d'authentification à plusieurs facteurs TOTP",
    "__stack-auto-translation-268": "Réessayer",
    "__stack-auto-translation-269": "Non disponible",
    "__stack-auto-translation-27": "Annuler l'abonnement",
    "__stack-auto-translation-270": "Irrécouvrable",
    "__stack-auto-translation-271": "Inconnu",
    "__stack-auto-translation-272": "Non vérifié",
    "__stack-auto-translation-273": "Mettre à jour le mot de passe",
    "__stack-auto-translation-274": "Mettre à jour le mot de passe",
    "__stack-auto-translation-275": "Modifier le mode de paiement",
    "__stack-auto-translation-276": "Mettre à jour votre mot de passe",
    "__stack-auto-translation-277": "Téléversez une image pour votre équipe",
    "__stack-auto-translation-278": "Téléversez votre propre image comme avatar",
    "__stack-auto-translation-279": "Utiliser pour la connexion",
    "__stack-auto-translation-28": "L'annulation arrêtera les renouvellements futurs de cet abonnement.",
    "__stack-auto-translation-280": "Utilisé pour la connexion",
    "__stack-auto-translation-281": "Lien de réinitialisation de mot de passe utilisé",
    "__stack-auto-translation-282": "Lien d'invitation d'équipe utilisé",
    "__stack-auto-translation-283": "Utilisateur",
    "__stack-auto-translation-284": "Nom d'utilisateur",
    "__stack-auto-translation-285": "Échec de la vérification",
    "__stack-auto-translation-286": "Vérifié! Redirection en cours...",
    "__stack-auto-translation-287": "Vérifier",
    "__stack-auto-translation-288": "Vérification...",
    "__stack-auto-translation-289": "Voir",
    "__stack-auto-translation-29": "modifier",
    "__stack-auto-translation-290": "Consultez vos forfaits actifs et vos achats.",
    "__stack-auto-translation-291": "Annulée",
    "__stack-auto-translation-292": "AVERTISSEMENT : Assurez-vous de faire confiance à l'application en ligne de commande, car elle aura accès à votre compte. Si vous n'avez pas initié cette demande, vous pouvez fermer cette page et l'ignorer. Nous ne vous enverrons jamais ce lien par courriel ou par tout autre moyen.",
    "__stack-auto-translation-293": "Vous êtes déjà connecté",
    "__stack-auto-translation-294": "Vous n'êtes pas connecté actuellement.",
    "__stack-auto-translation-295": "Vous ne pouvez pas supprimer votre dernier courriel de connexion",
    "__stack-auto-translation-296": "Vous ne pouvez pas révoquer votre session actuelle",
    "__stack-auto-translation-297": "Votre courriel a été vérifié !",
    "__stack-auto-translation-298": "Vous n'avez pas encore complété la configuration de votre compte. Veuillez contacter le support si vous pensez qu'il s'agit d'une erreur.",
    "__stack-auto-translation-299": "Votre courriel",
    "__stack-auto-translation-3": "Paramètres du compte",
    "__stack-auto-translation-30": "Changer de forfait",
    "__stack-auto-translation-300": "Votre lien de vérification de courriel a expiré. Veuillez demander un nouveau lien de vérification dans les paramètres de votre compte.",
    "__stack-auto-translation-301": "Votre lien magique a expiré. Veuillez demander un nouveau lien magique si vous avez besoin de vous connecter.",
    "__stack-auto-translation-302": "Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "__stack-auto-translation-303": "Votre lien de réinitialisation du mot de passe a expiré. Veuillez demander un nouveau lien à partir de la page de connexion.",
    "__stack-auto-translation-304": "Votre lien d'invitation d'équipe a expiré. Veuillez demander un nouveau lien d'invitation",
    "__stack-auto-translation-31": "Modifier le nom d'affichage de votre équipe",
    "__stack-auto-translation-32": "Choisir un forfait",
    "__stack-auto-translation-33": "Choisissez quels courriels vous souhaitez recevoir",
    "__stack-auto-translation-34": "Autorisation CLI réussie",
    "__stack-auto-translation-35": "cliquez ici",
    "__stack-auto-translation-36": "Cliquez sur le bouton ci-dessous pour renvoyer le lien de vérification.",
    "__stack-auto-translation-37": "Fermer",
    "__stack-auto-translation-38": "Terminer la configuration",
    "__stack-auto-translation-39": "Complétez la configuration de votre compte",
    "__stack-auto-translation-4": "Forfaits actifs",
    "__stack-auto-translation-40": "Confirmer",
    "__stack-auto-translation-41": "Continuer",
    "__stack-auto-translation-42": "Copiez-le dans un endroit sûr. Vous ne pourrez plus le consulter.",
    "__stack-auto-translation-43": "Impossible de recadrer l'image.",
    "__stack-auto-translation-44": "Créer",
    "__stack-auto-translation-45": "Créer un nouveau compte",
    "__stack-auto-translation-46": "Créer une équipe",
    "__stack-auto-translation-47": "Créer une équipe",
    "__stack-auto-translation-48": "Créer une clé API",
    "__stack-auto-translation-49": "Forfait de crédits",
    "__stack-auto-translation-5": "Sessions actives",
    "__stack-auto-translation-50": "Session actuelle",
    "__stack-auto-translation-51": "Équipe actuelle",
    "__stack-auto-translation-52": "Zone dangereuse",
    "__stack-auto-translation-53": "Date",
    "__stack-auto-translation-54": "Supprimer le compte",
    "__stack-auto-translation-55": "Supprimer le compte",
    "__stack-auto-translation-56": "Supprimer la clé d'accès",
    "__stack-auto-translation-57": "Description",
    "__stack-auto-translation-58": "La description est requise",
    "__stack-auto-translation-59": "Désactiver",
    "__stack-auto-translation-6": "Ajouter",
    "__stack-auto-translation-60": "Désactiver l'AMF",
    "__stack-auto-translation-61": "Désactiver OTP",
    "__stack-auto-translation-62": "Nom d'affichage",
    "__stack-auto-translation-63": "Voulez-vous vous connecter ?",
    "__stack-auto-translation-64": "Voulez-vous vérifier votre courriel ?",
    "__stack-auto-translation-65": "Vous n'avez pas de compte ?",
    "__stack-auto-translation-66": "Pas besoin de réinitialiser ?",
    "__stack-auto-translation-67": "Brouillon",
    "__stack-auto-translation-68": "p. ex. Développement, Production, CI/CD",
    "__stack-auto-translation-69": "Courriel",
    "__stack-auto-translation-7": "Ajoutez un mode de paiement avant de changer de forfait.",
    "__stack-auto-translation-70": "Courriel et mot de passe",
    "__stack-auto-translation-71": "Le courriel existe déjà",
    "__stack-auto-translation-72": "Le courriel est requis",
    "__stack-auto-translation-73": "La gestion des courriels n'est pas disponible en mode démo.",
    "__stack-auto-translation-74": "Courriel envoyé !",
    "__stack-auto-translation-75": "Courriels",
    "__stack-auto-translation-76": "Courriels et authentification",
    "__stack-auto-translation-77": "Activer l'AMF",
    "__stack-auto-translation-78": "Activer l'OTP",
    "__stack-auto-translation-79": "Activer la connexion par lien magique ou OTP envoyé à vos courriels de connexion.",
    "__stack-auto-translation-8": "Ajouter un courriel",
    "__stack-auto-translation-80": "Terminez votre session actuelle",
    "__stack-auto-translation-81": "Entrez un nom d'affichage pour votre nouvelle équipe",
    "__stack-auto-translation-82": "Saisir le courriel",
    "__stack-auto-translation-83": "Entrez le code reçu par courriel",
    "__stack-auto-translation-84": "Entrez le code à six chiffres de votre application d'authentification",
    "__stack-auto-translation-85": "Entrez votre courriel",
    "__stack-auto-translation-86": "Lien magique expiré",
    "__stack-auto-translation-87": "Lien de réinitialisation de mot de passe expiré",
    "__stack-auto-translation-88": "Lien d'invitation d'équipe expiré",
    "__stack-auto-translation-89": "Lien de vérification expiré",
    "__stack-auto-translation-9": "Ajouter une nouvelle clé d'accès",
    "__stack-auto-translation-90": "Expire",
    "__stack-auto-translation-91": "Expire dans",
    "__stack-auto-translation-92": "Échec de l'autorisation de l'application CLI :",
    "__stack-auto-translation-93": "Échec de connexion du compte",
    "__stack-auto-translation-94": "Échec de la réinitialisation du mot de passe",
    "__stack-auto-translation-95": "Échec de la réinitialisation du mot de passe. Veuillez demander un nouveau lien de réinitialisation",
    "__stack-auto-translation-96": "Mot de passe oublié ?",
    "__stack-auto-translation-97": "Accueil",
    "__stack-auto-translation-98": "Accueil",
    "__stack-auto-translation-99": "Voici votre clé API."
  } as const)),
  "fr-FR": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Une application en ligne de commande demande l'accès à votre compte. Cliquez sur le bouton ci-dessous pour l'autoriser.",
    "__stack-auto-translation-10": "Ajoutez votre adresse e-mail",
    "__stack-auto-translation-100": "Je comprends que je ne pourrai plus consulter cette clé.",
    "__stack-auto-translation-101": "Si l'utilisateur avec cette adresse e-mail existe, un e-mail a été envoyé dans votre boîte de réception. Assurez-vous de vérifier votre dossier de courrier indésirable.",
    "__stack-auto-translation-102": "Si vous n'êtes pas redirigé automatiquement, ",
    "__stack-auto-translation-103": "Ignorer",
    "__stack-auto-translation-104": "Usurpation",
    "__stack-auto-translation-105": "Code incorrect. Veuillez réessayer.",
    "__stack-auto-translation-106": "Mot de passe incorrect",
    "__stack-auto-translation-107": "Code invalide",
    "__stack-auto-translation-108": "Image invalide",
    "__stack-auto-translation-109": "Lien magique invalide",
    "__stack-auto-translation-11": "Vous avez déjà un compte ?",
    "__stack-auto-translation-110": "Lien de réinitialisation de mot de passe non valide",
    "__stack-auto-translation-111": "Lien d'invitation d'équipe non valide",
    "__stack-auto-translation-112": "Code TOTP invalide",
    "__stack-auto-translation-113": "Lien de vérification invalide",
    "__stack-auto-translation-114": "Invitez un utilisateur à rejoindre votre équipe par e-mail",
    "__stack-auto-translation-115": "Inviter un membre",
    "__stack-auto-translation-116": "Inviter l'utilisateur",
    "__stack-auto-translation-117": "Facture",
    "__stack-auto-translation-118": "Factures",
    "__stack-auto-translation-119": "Adresse IP",
    "__stack-auto-translation-12": "Montant",
    "__stack-auto-translation-120": "Rejoindre",
    "__stack-auto-translation-121": "Dernière utilisation",
    "__stack-auto-translation-122": "Quitter",
    "__stack-auto-translation-123": "Quitter l'équipe",
    "__stack-auto-translation-124": "Quitter l'équipe",
    "__stack-auto-translation-125": "quitter cette équipe et supprimer votre profil d'équipe",
    "__stack-auto-translation-126": "Localisation",
    "__stack-auto-translation-127": "Lien magique déjà utilisé",
    "__stack-auto-translation-128": "Gérer le mode de paiement par défaut utilisé pour les abonnements et les factures.",
    "__stack-auto-translation-129": "Membres",
    "__stack-auto-translation-13": "Une erreur inconnue s'est produite",
    "__stack-auto-translation-130": "La gestion MFA n'est pas disponible en mode démo.",
    "__stack-auto-translation-131": "Informations de vérification manquantes",
    "__stack-auto-translation-132": "Authentification à plusieurs facteurs",
    "__stack-auto-translation-133": "Authentification à plusieurs facteurs",
    "__stack-auto-translation-134": "L'authentification à plusieurs facteurs est actuellement désactivée.",
    "__stack-auto-translation-135": "L'authentification à plusieurs facteurs est actuellement activée.",
    "__stack-auto-translation-136": "Mon profil",
    "__stack-auto-translation-137": "Nom",
    "__stack-auto-translation-138": "Jamais",
    "__stack-auto-translation-139": "L'inscription de nouveaux comptes n'est pas autorisée",
    "__stack-auto-translation-14": "Clé API",
    "__stack-auto-translation-140": "Nouveau mot de passe",
    "__stack-auto-translation-141": "Nouveau mot de passe",
    "__stack-auto-translation-142": "Aucune session active trouvée",
    "__stack-auto-translation-143": "Aucune méthode d'authentification activée.",
    "__stack-auto-translation-144": "Aucun moyen de paiement par défaut",
    "__stack-auto-translation-145": "Aucun nom d'affichage défini",
    "__stack-auto-translation-146": "Aucun autre plan disponible pour cet abonnement.",
    "__stack-auto-translation-147": "Aucune invitation en attente",
    "__stack-auto-translation-148": "Aucune équipe",
    "__stack-auto-translation-149": "Aucune équipe pour l'instant",
    "__stack-auto-translation-15": "Clés API",
    "__stack-auto-translation-150": "Non connecté",
    "__stack-auto-translation-151": "Notifications",
    "__stack-auto-translation-152": "Accès refusé par le fournisseur OAuth",
    "__stack-auto-translation-153": "Ancien mot de passe",
    "__stack-auto-translation-154": "Mot de passe à usage unique",
    "__stack-auto-translation-155": "Achat unique",
    "__stack-auto-translation-156": "Ouvert",
    "__stack-auto-translation-157": "Ou continuer avec",
    "__stack-auto-translation-158": "Autre session",
    "__stack-auto-translation-159": "Autres équipes",
    "__stack-auto-translation-16": "Les clés API permettent un accès programmatique à votre compte.",
    "__stack-auto-translation-160": "La gestion des OTP n'est pas disponible en mode démo.",
    "__stack-auto-translation-161": "Connexion OTP",
    "__stack-auto-translation-162": "La connexion OTP est activée et ne peut pas être désactivée car c'est actuellement la seule méthode de connexion",
    "__stack-auto-translation-163": "La connexion par OTP/lien magique est actuellement activée.",
    "__stack-auto-translation-164": "Invitations en attente",
    "__stack-auto-translation-165": "Remplacez votre nom d'affichage dans cette équipe",
    "__stack-auto-translation-166": "Payée",
    "__stack-auto-translation-167": "Clé d'accès",
    "__stack-auto-translation-168": "La gestion des clés d'accès n'est pas disponible en mode démo.",
    "__stack-auto-translation-169": "Clé d'accès enregistrée",
    "__stack-auto-translation-17": "Les clés API permettent un accès programmatique à votre équipe.",
    "__stack-auto-translation-170": "La connexion par clé d'accès est activée et ne peut pas être désactivée car c'est actuellement la seule méthode de connexion",
    "__stack-auto-translation-171": "Mot de passe",
    "__stack-auto-translation-172": "La gestion des mots de passe n'est pas disponible en mode démo.",
    "__stack-auto-translation-173": "Réinitialisation du mot de passe réussie !",
    "__stack-auto-translation-174": "Les mots de passe ne correspondent pas",
    "__stack-auto-translation-175": "Moyen de paiement",
    "__stack-auto-translation-176": "Paiements",
    "__stack-auto-translation-177": "Supprimez définitivement votre compte et toutes les données associées",
    "__stack-auto-translation-178": "Personnel",
    "__stack-auto-translation-179": "Veuillez ajouter une adresse e-mail pour finaliser la configuration de votre compte. Nous vous enverrons un e-mail de vérification.",
    "__stack-auto-translation-18": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est IRRÉVERSIBLE et supprimera TOUTES les données associées.",
    "__stack-auto-translation-180": "Veuillez vérifier si vous avez le bon lien. Si vous continuez à rencontrer des problèmes, veuillez contacter le support.",
    "__stack-auto-translation-181": "Veuillez vérifier votre boîte de réception",
    "__stack-auto-translation-182": "Veuillez finaliser la configuration de votre compte avant de rejoindre des équipes.",
    "__stack-auto-translation-183": "Veuillez vérifier si vous avez le bon lien de réinitialisation de mot de passe.",
    "__stack-auto-translation-184": "Veuillez vérifier que vous disposez du bon lien d'invitation d'équipe.",
    "__stack-auto-translation-185": "Veuillez saisir un nom d'équipe",
    "__stack-auto-translation-186": "Veuillez saisir une adresse e-mail valide",
    "__stack-auto-translation-187": "Veuillez saisir une adresse e-mail valide",
    "__stack-auto-translation-188": "Veuillez saisir une adresse e-mail",
    "__stack-auto-translation-189": "Veuillez saisir votre adresse e-mail",
    "__stack-auto-translation-19": "Êtes-vous sûr de vouloir désactiver la connexion OTP ? Vous ne pourrez plus vous connecter uniquement avec des e-mails.",
    "__stack-auto-translation-190": "Veuillez saisir votre ancien mot de passe",
    "__stack-auto-translation-191": "Veuillez saisir votre mot de passe",
    "__stack-auto-translation-192": "Veuillez répéter votre mot de passe",
    "__stack-auto-translation-193": "Veuillez réessayer et si le problème persiste, contactez le support.",
    "__stack-auto-translation-194": "Veuillez vérifier votre adresse e-mail ",
    "__stack-auto-translation-195": "Veuillez d'abord vérifier votre adresse e-mail",
    "__stack-auto-translation-196": "Principal",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Image de profil",
    "__stack-auto-translation-199": "Enregistrer une clé d'accès",
    "__stack-auto-translation-2": "Paramètres du compte",
    "__stack-auto-translation-20": "Êtes-vous sûr de vouloir désactiver la connexion par clé d'accès ? Vous ne pourrez plus vous connecter avec votre clé d'accès.",
    "__stack-auto-translation-200": "Supprimer",
    "__stack-auto-translation-201": "Renouvellement le",
    "__stack-auto-translation-202": "Répéter le nouveau mot de passe",
    "__stack-auto-translation-203": "Répéter le nouveau mot de passe",
    "__stack-auto-translation-204": "Répéter le mot de passe",
    "__stack-auto-translation-205": "Renvoyer l'e-mail de vérification",
    "__stack-auto-translation-206": "Réinitialiser le mot de passe",
    "__stack-auto-translation-207": "Réinitialisez votre mot de passe",
    "__stack-auto-translation-208": "Consultez les factures et reçus passés.",
    "__stack-auto-translation-209": "Révoquer",
    "__stack-auto-translation-21": "Êtes-vous sûr de vouloir quitter l'équipe ?",
    "__stack-auto-translation-210": "Révoquer toutes les autres sessions",
    "__stack-auto-translation-211": "Enregistrer",
    "__stack-auto-translation-212": "Scannez ce code QR avec votre application d'authentification :",
    "__stack-auto-translation-213": "Clé API secrète",
    "__stack-auto-translation-214": "Sélectionnez un nouveau plan dans la même gamme de produits.",
    "__stack-auto-translation-215": "Envoyer l'e-mail",
    "__stack-auto-translation-216": "Envoyer l'e-mail",
    "__stack-auto-translation-217": "Envoyer un e-mail de vérification",
    "__stack-auto-translation-218": "Session",
    "__stack-auto-translation-219": "Définissez un mot de passe pour votre compte",
    "__stack-auto-translation-22": "Échec d'autorisation",
    "__stack-auto-translation-220": "Définir comme principal",
    "__stack-auto-translation-221": "Définir le mot de passe",
    "__stack-auto-translation-222": "Définir le mot de passe",
    "__stack-auto-translation-223": "Paramètres",
    "__stack-auto-translation-224": "Se connecter",
    "__stack-auto-translation-225": "Se connecter",
    "__stack-auto-translation-226": "Se connecter à nouveau",
    "__stack-auto-translation-227": "Connectez-vous ou créez un compte pour rejoindre l'équipe.",
    "__stack-auto-translation-228": "Connectez-vous à votre compte",
    "__stack-auto-translation-229": "Se connecter avec Passkey",
    "__stack-auto-translation-23": "Autoriser",
    "__stack-auto-translation-230": "Se connecter avec {provider}",
    "__stack-auto-translation-231": "Se déconnecter",
    "__stack-auto-translation-232": "S'inscrire",
    "__stack-auto-translation-233": "S'inscrire",
    "__stack-auto-translation-234": "L'inscription pour les nouveaux utilisateurs n'est pas activée pour le moment.",
    "__stack-auto-translation-235": "S'inscrire avec Clé d'accès",
    "__stack-auto-translation-236": "S'inscrire avec {provider}",
    "__stack-auto-translation-237": "Connexion réussie !",
    "__stack-auto-translation-238": "Connecté(e) {time}",
    "__stack-auto-translation-239": "Une erreur est survenue lors du traitement de la réponse OAuth :",
    "__stack-auto-translation-24": "Autoriser l'application CLI",
    "__stack-auto-translation-240": "Statut",
    "__stack-auto-translation-241": "Ne plus utiliser pour la connexion",
    "__stack-auto-translation-242": "Abonnement",
    "__stack-auto-translation-243": "Changer d'offre",
    "__stack-auto-translation-244": "La création d'équipes est désactivée en mode démo",
    "__stack-auto-translation-245": "La création d'équipe n'est pas activée",
    "__stack-auto-translation-246": "Nom d'affichage de l'équipe",
    "__stack-auto-translation-247": "Invitation d'équipe",
    "__stack-auto-translation-248": "Image de profil d'équipe",
    "__stack-auto-translation-249": "Nom d'utilisateur de l'équipe",
    "__stack-auto-translation-25": "Autorisation en cours...",
    "__stack-auto-translation-250": "Équipes",
    "__stack-auto-translation-251": "L'application CLI a été autorisée avec succès. Vous pouvez fermer cette fenêtre et retourner à la ligne de commande.",
    "__stack-auto-translation-252": "Le lien magique a déjà été utilisé. Le lien ne peut être utilisé qu'une seule fois. Veuillez demander un nouveau lien magique si vous devez vous reconnecter.",
    "__stack-auto-translation-253": "L'opération de connexion a été annulée ou refusée. Veuillez réessayer.",
    "__stack-auto-translation-254": "L'utilisateur est déjà connecté à un autre compte OAuth. Avez-vous peut-être sélectionné le mauvais compte sur la page du fournisseur OAuth ?",
    "__stack-auto-translation-255": "Ensuite, saisissez votre code MFA à six chiffres :",
    "__stack-auto-translation-256": "Ce sont les appareils sur lesquels vous êtes actuellement connecté. Vous pouvez révoquer l'accès pour mettre fin à une session.",
    "__stack-auto-translation-257": "Ce compte est déjà connecté à un autre utilisateur. Veuillez connecter un compte différent.",
    "__stack-auto-translation-258": "Cet e-mail est déjà utilisé pour la connexion par un autre utilisateur.",
    "__stack-auto-translation-259": "Il s'agit d'un nom d'affichage et n'est pas utilisé pour l'authentification",
    "__stack-auto-translation-26": "Annuler",
    "__stack-auto-translation-260": "Il s'agit probablement d'une erreur dans Stack. Veuillez la signaler.",
    "__stack-auto-translation-261": "Ce lien de réinitialisation de mot de passe a déjà été utilisé. Si vous devez à nouveau réinitialiser votre mot de passe, veuillez demander un nouveau lien de réinitialisation depuis la page de connexion.",
    "__stack-auto-translation-262": "Ce lien d'invitation d'équipe a déjà été utilisé.",
    "__stack-auto-translation-263": "Pour activer la connexion OTP, veuillez ajouter une adresse e-mail de connexion vérifiée.",
    "__stack-auto-translation-264": "Pour activer la connexion par clé d'accès, veuillez ajouter une adresse e-mail de connexion vérifiée.",
    "__stack-auto-translation-265": "Pour définir un mot de passe, veuillez ajouter une adresse e-mail de connexion.",
    "__stack-auto-translation-266": "Changer de thème",
    "__stack-auto-translation-267": "Code QR d'authentification à plusieurs facteurs TOTP",
    "__stack-auto-translation-268": "Réessayer",
    "__stack-auto-translation-269": "Indisponible",
    "__stack-auto-translation-27": "Annuler l'abonnement",
    "__stack-auto-translation-270": "Irrécouvrable",
    "__stack-auto-translation-271": "Inconnu",
    "__stack-auto-translation-272": "Non vérifié",
    "__stack-auto-translation-273": "Modifier le mot de passe",
    "__stack-auto-translation-274": "Modifier le mot de passe",
    "__stack-auto-translation-275": "Modifier le moyen de paiement",
    "__stack-auto-translation-276": "Mettez à jour votre mot de passe",
    "__stack-auto-translation-277": "Téléchargez une image pour votre équipe",
    "__stack-auto-translation-278": "Téléchargez votre propre image comme avatar",
    "__stack-auto-translation-279": "Utiliser pour la connexion",
    "__stack-auto-translation-28": "L'annulation arrêtera les renouvellements futurs de cet abonnement.",
    "__stack-auto-translation-280": "Utilisé pour la connexion",
    "__stack-auto-translation-281": "Lien de réinitialisation de mot de passe utilisé",
    "__stack-auto-translation-282": "Lien d'invitation d'équipe déjà utilisé",
    "__stack-auto-translation-283": "Utilisateur",
    "__stack-auto-translation-284": "Nom d'utilisateur",
    "__stack-auto-translation-285": "Échec de la vérification",
    "__stack-auto-translation-286": "Vérifié ! Redirection...",
    "__stack-auto-translation-287": "Vérifier",
    "__stack-auto-translation-288": "Vérification...",
    "__stack-auto-translation-289": "Voir",
    "__stack-auto-translation-29": "modifier",
    "__stack-auto-translation-290": "Consultez vos abonnements et achats actifs.",
    "__stack-auto-translation-291": "Annulée",
    "__stack-auto-translation-292": "AVERTISSEMENT : Assurez-vous de faire confiance à l'application en ligne de commande, car elle aura accès à votre compte. Si vous n'avez pas initié cette demande, vous pouvez fermer cette page et l'ignorer. Nous ne vous enverrons jamais ce lien par email ou par tout autre moyen.",
    "__stack-auto-translation-293": "Vous êtes déjà connecté",
    "__stack-auto-translation-294": "Vous n'êtes pas connecté actuellement.",
    "__stack-auto-translation-295": "Vous ne pouvez pas supprimer votre dernière adresse e-mail de connexion",
    "__stack-auto-translation-296": "Vous ne pouvez pas révoquer votre session actuelle",
    "__stack-auto-translation-297": "Votre email a été vérifié !",
    "__stack-auto-translation-298": "Vous n'avez pas encore terminé la configuration de votre compte. Veuillez contacter le support si vous pensez qu'il s'agit d'une erreur.",
    "__stack-auto-translation-299": "Votre e-mail",
    "__stack-auto-translation-3": "Paramètres du compte",
    "__stack-auto-translation-30": "Changer de forfait",
    "__stack-auto-translation-300": "Votre lien de vérification d'e-mail a expiré. Veuillez demander un nouveau lien de vérification dans les paramètres de votre compte.",
    "__stack-auto-translation-301": "Votre lien magique a expiré. Veuillez demander un nouveau lien magique si vous devez vous connecter.",
    "__stack-auto-translation-302": "Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "__stack-auto-translation-303": "Votre lien de réinitialisation du mot de passe a expiré. Veuillez demander un nouveau lien depuis la page de connexion.",
    "__stack-auto-translation-304": "Votre lien d'invitation d'équipe a expiré. Veuillez demander un nouveau lien d'invitation d'équipe",
    "__stack-auto-translation-31": "Modifiez le nom d'affichage de votre équipe",
    "__stack-auto-translation-32": "Choisir un forfait",
    "__stack-auto-translation-33": "Choisissez quels e-mails vous souhaitez recevoir",
    "__stack-auto-translation-34": "Autorisation CLI réussie",
    "__stack-auto-translation-35": "cliquez ici",
    "__stack-auto-translation-36": "Cliquez sur le bouton ci-dessous pour renvoyer le lien de vérification.",
    "__stack-auto-translation-37": "Fermer",
    "__stack-auto-translation-38": "Terminer la configuration",
    "__stack-auto-translation-39": "Finalisez la configuration de votre compte",
    "__stack-auto-translation-4": "Forfaits actifs",
    "__stack-auto-translation-40": "Confirmer",
    "__stack-auto-translation-41": "Continuer",
    "__stack-auto-translation-42": "Copiez-la dans un endroit sûr. Vous ne pourrez plus la consulter ultérieurement.",
    "__stack-auto-translation-43": "Impossible de recadrer l'image.",
    "__stack-auto-translation-44": "Créer",
    "__stack-auto-translation-45": "Créer un nouveau compte",
    "__stack-auto-translation-46": "Créer une équipe",
    "__stack-auto-translation-47": "Créer une équipe",
    "__stack-auto-translation-48": "Créer une clé API",
    "__stack-auto-translation-49": "Pack de crédits",
    "__stack-auto-translation-5": "Sessions actives",
    "__stack-auto-translation-50": "Session actuelle",
    "__stack-auto-translation-51": "Équipe actuelle",
    "__stack-auto-translation-52": "Zone dangereuse",
    "__stack-auto-translation-53": "Date",
    "__stack-auto-translation-54": "Supprimer le compte",
    "__stack-auto-translation-55": "Supprimer le compte",
    "__stack-auto-translation-56": "Supprimer la clé d'accès",
    "__stack-auto-translation-57": "Description",
    "__stack-auto-translation-58": "La description est obligatoire",
    "__stack-auto-translation-59": "Désactiver",
    "__stack-auto-translation-6": "Ajouter",
    "__stack-auto-translation-60": "Désactiver MFA",
    "__stack-auto-translation-61": "Désactiver l'OTP",
    "__stack-auto-translation-62": "Nom d'affichage",
    "__stack-auto-translation-63": "Voulez-vous vous connecter ?",
    "__stack-auto-translation-64": "Voulez-vous vérifier votre e-mail ?",
    "__stack-auto-translation-65": "Vous n'avez pas de compte ?",
    "__stack-auto-translation-66": "Pas besoin de réinitialiser ?",
    "__stack-auto-translation-67": "Brouillon",
    "__stack-auto-translation-68": "ex. Développement, Production, CI/CD",
    "__stack-auto-translation-69": "Adresse e-mail",
    "__stack-auto-translation-7": "Ajoutez un moyen de paiement avant de changer de forfait.",
    "__stack-auto-translation-70": "E-mail et mot de passe",
    "__stack-auto-translation-71": "Cet email existe déjà",
    "__stack-auto-translation-72": "L'adresse e-mail est requise",
    "__stack-auto-translation-73": "La gestion des e-mails n'est pas disponible en mode démo.",
    "__stack-auto-translation-74": "E-mail envoyé !",
    "__stack-auto-translation-75": "E-mails",
    "__stack-auto-translation-76": "E-mails et authentification",
    "__stack-auto-translation-77": "Activer l'AMF",
    "__stack-auto-translation-78": "Activer l'OTP",
    "__stack-auto-translation-79": "Activer la connexion via un lien magique ou un OTP envoyé à vos e-mails de connexion.",
    "__stack-auto-translation-8": "Ajouter un e-mail",
    "__stack-auto-translation-80": "Mettre fin à votre session actuelle",
    "__stack-auto-translation-81": "Entrez un nom d'affichage pour votre nouvelle équipe",
    "__stack-auto-translation-82": "Saisir l'adresse e-mail",
    "__stack-auto-translation-83": "Saisissez le code reçu par e-mail",
    "__stack-auto-translation-84": "Saisissez le code à six chiffres de votre application d'authentification",
    "__stack-auto-translation-85": "Entrez votre e-mail",
    "__stack-auto-translation-86": "Lien magique expiré",
    "__stack-auto-translation-87": "Lien de réinitialisation expiré",
    "__stack-auto-translation-88": "Lien d'invitation d'équipe expiré",
    "__stack-auto-translation-89": "Lien de vérification expiré",
    "__stack-auto-translation-9": "Ajouter une nouvelle clé d'accès",
    "__stack-auto-translation-90": "Expire",
    "__stack-auto-translation-91": "Expire dans",
    "__stack-auto-translation-92": "Échec de l'autorisation de l'application CLI :",
    "__stack-auto-translation-93": "Échec de la connexion du compte",
    "__stack-auto-translation-94": "Échec de réinitialisation",
    "__stack-auto-translation-95": "Échec de la réinitialisation du mot de passe. Veuillez demander un nouveau lien de réinitialisation",
    "__stack-auto-translation-96": "Mot de passe oublié ?",
    "__stack-auto-translation-97": "Accueil",
    "__stack-auto-translation-98": "Accueil",
    "__stack-auto-translation-99": "Voici votre clé API."
  } as const)),
  "it-IT": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Un'applicazione a riga di comando sta richiedendo l'accesso al tuo account. Fai clic sul pulsante qui sotto per autorizzarla.",
    "__stack-auto-translation-10": "Aggiungi il tuo indirizzo email",
    "__stack-auto-translation-100": "Ho capito che non potrò visualizzare nuovamente questa chiave.",
    "__stack-auto-translation-101": "Se l'utente con questo indirizzo e-mail esiste, un'e-mail è stata inviata alla tua casella di posta. Assicurati di controllare la cartella dello spam.",
    "__stack-auto-translation-102": "Se non vieni reindirizzato automaticamente, ",
    "__stack-auto-translation-103": "Ignora",
    "__stack-auto-translation-104": "Impersonazione",
    "__stack-auto-translation-105": "Codice errato. Per favore riprova.",
    "__stack-auto-translation-106": "Password non corretta",
    "__stack-auto-translation-107": "Codice non valido",
    "__stack-auto-translation-108": "Immagine non valida",
    "__stack-auto-translation-109": "Link Magico Non Valido",
    "__stack-auto-translation-11": "Hai già un account?",
    "__stack-auto-translation-110": "Link di Reimpostazione Password Non Valido",
    "__stack-auto-translation-111": "Link di invito al team non valido",
    "__stack-auto-translation-112": "Codice TOTP non valido",
    "__stack-auto-translation-113": "Link di verifica non valido",
    "__stack-auto-translation-114": "Invita un utente al tuo team tramite email",
    "__stack-auto-translation-115": "Invita membro",
    "__stack-auto-translation-116": "Invita Utente",
    "__stack-auto-translation-117": "Fattura",
    "__stack-auto-translation-118": "Fatture",
    "__stack-auto-translation-119": "Indirizzo IP",
    "__stack-auto-translation-12": "Importo",
    "__stack-auto-translation-120": "Unisciti",
    "__stack-auto-translation-121": "Ultimo utilizzo",
    "__stack-auto-translation-122": "Abbandona",
    "__stack-auto-translation-123": "Lascia il team",
    "__stack-auto-translation-124": "Lascia il Team",
    "__stack-auto-translation-125": "lascia questa squadra e rimuovi il tuo profilo del team",
    "__stack-auto-translation-126": "Posizione",
    "__stack-auto-translation-127": "Link magico già utilizzato",
    "__stack-auto-translation-128": "Gestisci il metodo di pagamento predefinito per abbonamenti e fatture.",
    "__stack-auto-translation-129": "Membri",
    "__stack-auto-translation-13": "Si è verificato un errore sconosciuto",
    "__stack-auto-translation-130": "La gestione MFA non è disponibile in modalità demo.",
    "__stack-auto-translation-131": "Informazioni di verifica mancanti",
    "__stack-auto-translation-132": "Autenticazione a più fattori",
    "__stack-auto-translation-133": "Autenticazione a più fattori",
    "__stack-auto-translation-134": "L'autenticazione a più fattori è attualmente disabilitata.",
    "__stack-auto-translation-135": "L'autenticazione a più fattori è attualmente attiva.",
    "__stack-auto-translation-136": "Il mio profilo",
    "__stack-auto-translation-137": "Nome",
    "__stack-auto-translation-138": "Mai",
    "__stack-auto-translation-139": "La registrazione di nuovi account non è consentita",
    "__stack-auto-translation-14": "Chiave API",
    "__stack-auto-translation-140": "Nuova password",
    "__stack-auto-translation-141": "Nuova Password",
    "__stack-auto-translation-142": "Nessuna sessione attiva trovata",
    "__stack-auto-translation-143": "Nessun metodo di autenticazione abilitato.",
    "__stack-auto-translation-144": "Nessun metodo di pagamento predefinito",
    "__stack-auto-translation-145": "Nessun nome visualizzato impostato",
    "__stack-auto-translation-146": "Nessun altro piano disponibile per questo abbonamento.",
    "__stack-auto-translation-147": "Nessun invito in sospeso",
    "__stack-auto-translation-148": "Nessun team",
    "__stack-auto-translation-149": "Nessun team ancora",
    "__stack-auto-translation-15": "Chiavi API",
    "__stack-auto-translation-150": "Non hai effettuato l'accesso",
    "__stack-auto-translation-151": "Notifiche",
    "__stack-auto-translation-152": "Accesso al provider OAuth negato",
    "__stack-auto-translation-153": "Vecchia password",
    "__stack-auto-translation-154": "Password Monouso",
    "__stack-auto-translation-155": "Acquisto unico",
    "__stack-auto-translation-156": "Aperta",
    "__stack-auto-translation-157": "Oppure continua con",
    "__stack-auto-translation-158": "Altra Sessione",
    "__stack-auto-translation-159": "Altri team",
    "__stack-auto-translation-16": "Le chiavi API consentono l'accesso programmatico al tuo account.",
    "__stack-auto-translation-160": "La gestione OTP non è disponibile in modalità demo.",
    "__stack-auto-translation-161": "Accesso con OTP",
    "__stack-auto-translation-162": "L'accesso con OTP è abilitato e non può essere disattivato poiché è attualmente l'unico metodo di accesso disponibile",
    "__stack-auto-translation-163": "L'accesso tramite OTP/link magico è attualmente abilitato.",
    "__stack-auto-translation-164": "Inviti in sospeso",
    "__stack-auto-translation-165": "Sovrascrivi il tuo nome visualizzato in questo team",
    "__stack-auto-translation-166": "Pagato",
    "__stack-auto-translation-167": "Passkey",
    "__stack-auto-translation-168": "La gestione delle passkey non è disponibile in modalità demo.",
    "__stack-auto-translation-169": "Passkey registrata",
    "__stack-auto-translation-17": "Le chiavi API consentono l'accesso programmatico al tuo team.",
    "__stack-auto-translation-170": "L'accesso con Passkey è attivo e non può essere disattivato poiché è attualmente l'unico metodo di accesso",
    "__stack-auto-translation-171": "Password",
    "__stack-auto-translation-172": "La gestione delle password non è disponibile in modalità demo.",
    "__stack-auto-translation-173": "Password reimpostata con successo!",
    "__stack-auto-translation-174": "Le password non corrispondono",
    "__stack-auto-translation-175": "Metodo di pagamento",
    "__stack-auto-translation-176": "Pagamenti",
    "__stack-auto-translation-177": "Rimuovi permanentemente il tuo account e tutti i dati associati",
    "__stack-auto-translation-178": "Personale",
    "__stack-auto-translation-179": "Aggiungi un indirizzo email per completare la configurazione del tuo account. Ti invieremo un'email di verifica.",
    "__stack-auto-translation-18": "Sei sicuro di voler eliminare il tuo account? Questa azione è IRREVERSIBILE e cancellerà TUTTI i dati associati.",
    "__stack-auto-translation-180": "Verifica di avere il link corretto. Se continui ad avere problemi, contatta l'assistenza.",
    "__stack-auto-translation-181": "Controlla la tua casella email",
    "__stack-auto-translation-182": "Completa la configurazione dell'account prima di unirti ai team.",
    "__stack-auto-translation-183": "Si prega di verificare di avere il link corretto per il ripristino della password.",
    "__stack-auto-translation-184": "Verifica di avere il link di invito al team corretto.",
    "__stack-auto-translation-185": "Inserisci un nome per il team",
    "__stack-auto-translation-186": "Inserisci un indirizzo email valido",
    "__stack-auto-translation-187": "Inserisci un indirizzo email valido",
    "__stack-auto-translation-188": "Inserisci un indirizzo email",
    "__stack-auto-translation-189": "Inserisci la tua email",
    "__stack-auto-translation-19": "Sei sicuro di voler disattivare l'accesso con OTP? Non potrai più accedere solo con le email.",
    "__stack-auto-translation-190": "Inserisci la tua vecchia password",
    "__stack-auto-translation-191": "Inserisci la tua password",
    "__stack-auto-translation-192": "Per favore ripeti la tua password",
    "__stack-auto-translation-193": "Si prega di riprovare e se il problema persiste, contattare l'assistenza.",
    "__stack-auto-translation-194": "Verifica il tuo indirizzo email ",
    "__stack-auto-translation-195": "Per favore verifica prima la tua email",
    "__stack-auto-translation-196": "Principale",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Immagine del profilo",
    "__stack-auto-translation-199": "Registra una passkey",
    "__stack-auto-translation-2": "Impostazioni account",
    "__stack-auto-translation-20": "Sei sicuro di voler disattivare l'accesso con Passkey? Non potrai più accedere utilizzando la tua passkey.",
    "__stack-auto-translation-200": "Rimuovi",
    "__stack-auto-translation-201": "Si rinnova il",
    "__stack-auto-translation-202": "Ripeti nuova password",
    "__stack-auto-translation-203": "Ripeti Nuova Password",
    "__stack-auto-translation-204": "Ripeti Password",
    "__stack-auto-translation-205": "Reinvia email di verifica",
    "__stack-auto-translation-206": "Reimposta Password",
    "__stack-auto-translation-207": "Reimposta la tua password",
    "__stack-auto-translation-208": "Consulta fatture e ricevute precedenti.",
    "__stack-auto-translation-209": "Revoca",
    "__stack-auto-translation-21": "Sei sicuro di voler lasciare il team?",
    "__stack-auto-translation-210": "Revoca Tutte le Altre Sessioni",
    "__stack-auto-translation-211": "Salva",
    "__stack-auto-translation-212": "Scansiona questo codice QR con la tua app di autenticazione:",
    "__stack-auto-translation-213": "Chiave API segreta",
    "__stack-auto-translation-214": "Seleziona un nuovo piano dalla stessa linea di prodotti.",
    "__stack-auto-translation-215": "Invia email",
    "__stack-auto-translation-216": "Invia Email",
    "__stack-auto-translation-217": "Invia email di verifica",
    "__stack-auto-translation-218": "Sessione",
    "__stack-auto-translation-219": "Imposta una password per il tuo account",
    "__stack-auto-translation-22": "Autorizzazione Fallita",
    "__stack-auto-translation-220": "Imposta come principale",
    "__stack-auto-translation-221": "Imposta password",
    "__stack-auto-translation-222": "Imposta Password",
    "__stack-auto-translation-223": "Impostazioni",
    "__stack-auto-translation-224": "Accedi",
    "__stack-auto-translation-225": "Accedi",
    "__stack-auto-translation-226": "Accedi di nuovo",
    "__stack-auto-translation-227": "Accedi o crea un account per unirti al team.",
    "__stack-auto-translation-228": "Accedi al tuo account",
    "__stack-auto-translation-229": "Accedi con Passkey",
    "__stack-auto-translation-23": "Autorizza",
    "__stack-auto-translation-230": "Accedi con {provider}",
    "__stack-auto-translation-231": "Esci",
    "__stack-auto-translation-232": "Registrati",
    "__stack-auto-translation-233": "Registrati",
    "__stack-auto-translation-234": "L'iscrizione per i nuovi utenti non è attualmente abilitata.",
    "__stack-auto-translation-235": "Registrati con Passkey",
    "__stack-auto-translation-236": "Registrati con {provider}",
    "__stack-auto-translation-237": "Accesso effettuato con successo!",
    "__stack-auto-translation-238": "Accesso effettuato {time}",
    "__stack-auto-translation-239": "Qualcosa è andato storto durante l'elaborazione del callback OAuth:",
    "__stack-auto-translation-24": "Autorizza Applicazione CLI",
    "__stack-auto-translation-240": "Stato",
    "__stack-auto-translation-241": "Interrompi l'utilizzo per l'accesso",
    "__stack-auto-translation-242": "Abbonamento",
    "__stack-auto-translation-243": "Cambia piano",
    "__stack-auto-translation-244": "La creazione del team è disattivata in modalità demo",
    "__stack-auto-translation-245": "La creazione del team non è abilitata",
    "__stack-auto-translation-246": "Nome visualizzato del team",
    "__stack-auto-translation-247": "Invito di squadra",
    "__stack-auto-translation-248": "Immagine del profilo del team",
    "__stack-auto-translation-249": "Nome utente del team",
    "__stack-auto-translation-25": "Autorizzazione in corso...",
    "__stack-auto-translation-250": "Team",
    "__stack-auto-translation-251": "L'applicazione CLI è stata autorizzata con successo. Puoi chiudere questa finestra e tornare alla riga di comando.",
    "__stack-auto-translation-252": "Il link magico è già stato utilizzato. Il link può essere usato una sola volta. Si prega di richiedere un nuovo link magico se è necessario accedere nuovamente.",
    "__stack-auto-translation-253": "L'operazione di accesso è stata annullata o negata. Si prega di riprovare.",
    "__stack-auto-translation-254": "L'utente è già collegato a un altro account OAuth. Hai forse selezionato l'account sbagliato nella pagina del provider OAuth?",
    "__stack-auto-translation-255": "Quindi, inserisci il tuo codice MFA a sei cifre:",
    "__stack-auto-translation-256": "Questi sono i dispositivi in cui hai effettuato l'accesso. Puoi revocare l'accesso per terminare una sessione.",
    "__stack-auto-translation-257": "Questo account è già collegato a un altro utente. Si prega di collegare un account diverso.",
    "__stack-auto-translation-258": "Questa email è già utilizzata per l'accesso da un altro utente.",
    "__stack-auto-translation-259": "Questo è un nome visualizzato e non viene utilizzato per l'autenticazione",
    "__stack-auto-translation-26": "Annulla",
    "__stack-auto-translation-260": "Questo è molto probabilmente un errore in Stack. Si prega di segnalarlo.",
    "__stack-auto-translation-261": "Questo link per il ripristino della password è già stato utilizzato. Se devi reimpostare nuovamente la password, richiedi un nuovo link dalla pagina di accesso.",
    "__stack-auto-translation-262": "Questo link di invito al team è già stato utilizzato.",
    "__stack-auto-translation-263": "Per abilitare l'accesso con OTP, aggiungi un'email di accesso verificata.",
    "__stack-auto-translation-264": "Per abilitare l'accesso con Passkey, aggiungi un'email di accesso verificata.",
    "__stack-auto-translation-265": "Per impostare una password, aggiungi un'email di accesso.",
    "__stack-auto-translation-266": "Cambia tema",
    "__stack-auto-translation-267": "Codice QR per l'autenticazione a più fattori TOTP",
    "__stack-auto-translation-268": "Riprova",
    "__stack-auto-translation-269": "Non disponibile",
    "__stack-auto-translation-27": "Annulla abbonamento",
    "__stack-auto-translation-270": "Inesigibile",
    "__stack-auto-translation-271": "Sconosciuto",
    "__stack-auto-translation-272": "Non verificato",
    "__stack-auto-translation-273": "Aggiorna password",
    "__stack-auto-translation-274": "Aggiorna Password",
    "__stack-auto-translation-275": "Aggiorna metodo di pagamento",
    "__stack-auto-translation-276": "Aggiorna la tua password",
    "__stack-auto-translation-277": "Carica un'immagine per il tuo team",
    "__stack-auto-translation-278": "Carica la tua immagine come avatar",
    "__stack-auto-translation-279": "Usa per l'accesso",
    "__stack-auto-translation-28": "L'annullamento interromperà i rinnovi futuri di questo abbonamento.",
    "__stack-auto-translation-280": "Usato per l'accesso",
    "__stack-auto-translation-281": "Link per il ripristino della password già utilizzato",
    "__stack-auto-translation-282": "Link di invito al team già utilizzato",
    "__stack-auto-translation-283": "Utente",
    "__stack-auto-translation-284": "Nome utente",
    "__stack-auto-translation-285": "Verifica fallita",
    "__stack-auto-translation-286": "Verificato! Reindirizzamento in corso...",
    "__stack-auto-translation-287": "Verifica",
    "__stack-auto-translation-288": "Verifica in corso...",
    "__stack-auto-translation-289": "Visualizza",
    "__stack-auto-translation-29": "modifica",
    "__stack-auto-translation-290": "Visualizza i tuoi piani attivi e acquisti.",
    "__stack-auto-translation-291": "Annullata",
    "__stack-auto-translation-292": "ATTENZIONE: Assicurati di fidarti dell'applicazione da riga di comando, poiché avrà accesso al tuo account. Se non hai avviato tu questa richiesta, puoi chiudere questa pagina e ignorarla. Non ti invieremo mai questo link via email o con altri mezzi.",
    "__stack-auto-translation-293": "Hai già effettuato l'accesso",
    "__stack-auto-translation-294": "Non sei attualmente autenticato.",
    "__stack-auto-translation-295": "Non puoi rimuovere la tua ultima email di accesso",
    "__stack-auto-translation-296": "Non puoi revocare la sessione corrente",
    "__stack-auto-translation-297": "La tua email è stata verificata!",
    "__stack-auto-translation-298": "Non hai ancora completato la configurazione del tuo account. Contatta il supporto se ritieni che si tratti di un errore.",
    "__stack-auto-translation-299": "La tua email",
    "__stack-auto-translation-3": "Impostazioni Account",
    "__stack-auto-translation-30": "Cambia piano",
    "__stack-auto-translation-300": "Il tuo link di verifica dell'email è scaduto. Richiedi un nuovo link di verifica dalle impostazioni del tuo account.",
    "__stack-auto-translation-301": "Il tuo link magico è scaduto. Richiedi un nuovo link magico se hai bisogno di accedere.",
    "__stack-auto-translation-302": "La tua password è stata reimpostata. Ora puoi accedere con la tua nuova password.",
    "__stack-auto-translation-303": "Il tuo link per il reset della password è scaduto. Ti preghiamo di richiedere un nuovo link per il reset della password dalla pagina di accesso.",
    "__stack-auto-translation-304": "Il tuo link di invito al team è scaduto. Richiedi un nuovo link di invito",
    "__stack-auto-translation-31": "Modifica il nome visualizzato del tuo team",
    "__stack-auto-translation-32": "Scegli un piano",
    "__stack-auto-translation-33": "Scegli quali email desideri ricevere",
    "__stack-auto-translation-34": "Autorizzazione CLI riuscita",
    "__stack-auto-translation-35": "clicca qui",
    "__stack-auto-translation-36": "Clicca il pulsante qui sotto per reinviare il link di verifica.",
    "__stack-auto-translation-37": "Chiudi",
    "__stack-auto-translation-38": "Completa configurazione",
    "__stack-auto-translation-39": "Completa la configurazione dell'account",
    "__stack-auto-translation-4": "Piani attivi",
    "__stack-auto-translation-40": "Conferma",
    "__stack-auto-translation-41": "Continua",
    "__stack-auto-translation-42": "Copialo in un luogo sicuro. Non potrai visualizzarlo di nuovo.",
    "__stack-auto-translation-43": "Impossibile ritagliare l'immagine.",
    "__stack-auto-translation-44": "Crea",
    "__stack-auto-translation-45": "Crea un nuovo account",
    "__stack-auto-translation-46": "Crea un team",
    "__stack-auto-translation-47": "Crea un Team",
    "__stack-auto-translation-48": "Crea Chiave API",
    "__stack-auto-translation-49": "Pacchetto crediti",
    "__stack-auto-translation-5": "Sessioni Attive",
    "__stack-auto-translation-50": "Sessione Corrente",
    "__stack-auto-translation-51": "Team attuale",
    "__stack-auto-translation-52": "Zona pericolosa",
    "__stack-auto-translation-53": "Data",
    "__stack-auto-translation-54": "Elimina account",
    "__stack-auto-translation-55": "Elimina Account",
    "__stack-auto-translation-56": "Elimina Passkey",
    "__stack-auto-translation-57": "Descrizione",
    "__stack-auto-translation-58": "La descrizione è obbligatoria",
    "__stack-auto-translation-59": "Disattiva",
    "__stack-auto-translation-6": "Aggiungi",
    "__stack-auto-translation-60": "Disattiva MFA",
    "__stack-auto-translation-61": "Disattiva OTP",
    "__stack-auto-translation-62": "Nome visualizzato",
    "__stack-auto-translation-63": "Vuoi accedere?",
    "__stack-auto-translation-64": "Vuoi verificare la tua email?",
    "__stack-auto-translation-65": "Non hai un account?",
    "__stack-auto-translation-66": "Non hai bisogno di reimpostare?",
    "__stack-auto-translation-67": "Bozza",
    "__stack-auto-translation-68": "es. Sviluppo, Produzione, CI/CD",
    "__stack-auto-translation-69": "Email",
    "__stack-auto-translation-7": "Aggiungi un metodo di pagamento prima di cambiare piano.",
    "__stack-auto-translation-70": "Email e password",
    "__stack-auto-translation-71": "L'email esiste già",
    "__stack-auto-translation-72": "L'email è obbligatoria",
    "__stack-auto-translation-73": "La gestione delle email non è disponibile in modalità demo.",
    "__stack-auto-translation-74": "Email inviato!",
    "__stack-auto-translation-75": "Email",
    "__stack-auto-translation-76": "Email e Autenticazione",
    "__stack-auto-translation-77": "Abilita MFA",
    "__stack-auto-translation-78": "Abilita OTP",
    "__stack-auto-translation-79": "Abilita l'accesso tramite link magico o OTP inviato alle tue email di accesso.",
    "__stack-auto-translation-8": "Aggiungi un'email",
    "__stack-auto-translation-80": "Termina la sessione corrente",
    "__stack-auto-translation-81": "Inserisci un nome visualizzato per il tuo nuovo team",
    "__stack-auto-translation-82": "Inserisci email",
    "__stack-auto-translation-83": "Inserisci il codice ricevuto via email",
    "__stack-auto-translation-84": "Inserisci il codice a sei cifre dalla tua app di autenticazione",
    "__stack-auto-translation-85": "Inserisci la tua email",
    "__stack-auto-translation-86": "Link magico scaduto",
    "__stack-auto-translation-87": "Link per il Reset della Password Scaduto",
    "__stack-auto-translation-88": "Link di invito al team scaduto",
    "__stack-auto-translation-89": "Link di verifica scaduto",
    "__stack-auto-translation-9": "Aggiungi nuova passkey",
    "__stack-auto-translation-90": "Scade",
    "__stack-auto-translation-91": "Scade tra",
    "__stack-auto-translation-92": "Autorizzazione dell'applicazione CLI fallita:",
    "__stack-auto-translation-93": "Impossibile connettere l'account",
    "__stack-auto-translation-94": "Impossibile reimpostare la password",
    "__stack-auto-translation-95": "Impossibile reimpostare la password. Richiedi un nuovo link di reset",
    "__stack-auto-translation-96": "Password dimenticata?",
    "__stack-auto-translation-97": "Vai alla home",
    "__stack-auto-translation-98": "Vai alla home",
    "__stack-auto-translation-99": "Ecco la tua chiave API."
  } as const)),
  "ja-JP": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "コマンドラインアプリケーションがあなたのアカウントへのアクセスを要求しています。下のボタンをクリックして承認してください。",
    "__stack-auto-translation-10": "メールアドレスを追加",
    "__stack-auto-translation-100": "このキーを再度表示できないことを理解しました。",
    "__stack-auto-translation-101": "このメールアドレスのユーザーが存在する場合、メールが送信されました。迷惑メールフォルダもご確認ください。",
    "__stack-auto-translation-102": "自動的にリダイレクトされない場合は、",
    "__stack-auto-translation-103": "無視",
    "__stack-auto-translation-104": "なりすまし",
    "__stack-auto-translation-105": "不正なコードです。もう一度お試しください。",
    "__stack-auto-translation-106": "パスワードが正しくありません",
    "__stack-auto-translation-107": "無効なコード",
    "__stack-auto-translation-108": "無効な画像",
    "__stack-auto-translation-109": "無効なマジックリンク",
    "__stack-auto-translation-11": "すでにアカウントをお持ちですか？",
    "__stack-auto-translation-110": "無効なパスワードリセットリンク",
    "__stack-auto-translation-111": "無効なチーム招待リンク",
    "__stack-auto-translation-112": "無効なTOTPコード",
    "__stack-auto-translation-113": "無効な認証リンク",
    "__stack-auto-translation-114": "メールでチームにユーザーを招待",
    "__stack-auto-translation-115": "メンバーを招待",
    "__stack-auto-translation-116": "ユーザーを招待",
    "__stack-auto-translation-117": "請求書",
    "__stack-auto-translation-118": "請求書",
    "__stack-auto-translation-119": "IPアドレス",
    "__stack-auto-translation-12": "金額",
    "__stack-auto-translation-120": "参加",
    "__stack-auto-translation-121": "最終使用日時",
    "__stack-auto-translation-122": "退出",
    "__stack-auto-translation-123": "チームを退出",
    "__stack-auto-translation-124": "チームを退出",
    "__stack-auto-translation-125": "このチームを退出し、チームプロフィールを削除する",
    "__stack-auto-translation-126": "場所",
    "__stack-auto-translation-127": "マジックリンクは既に使用されています",
    "__stack-auto-translation-128": "サブスクリプションと請求書で使用するデフォルトの支払い方法を管理します。",
    "__stack-auto-translation-129": "メンバー",
    "__stack-auto-translation-13": "不明なエラーが発生しました",
    "__stack-auto-translation-130": "多要素認証（MFA）の管理はデモモードでは利用できません。",
    "__stack-auto-translation-131": "認証情報が不足しています",
    "__stack-auto-translation-132": "多要素認証",
    "__stack-auto-translation-133": "多要素認証",
    "__stack-auto-translation-134": "多要素認証は現在無効になっています。",
    "__stack-auto-translation-135": "多要素認証は現在有効です。",
    "__stack-auto-translation-136": "プロフィール",
    "__stack-auto-translation-137": "名前",
    "__stack-auto-translation-138": "なし",
    "__stack-auto-translation-139": "新規アカウント登録は許可されていません",
    "__stack-auto-translation-14": "APIキー",
    "__stack-auto-translation-140": "新しいパスワード",
    "__stack-auto-translation-141": "新しいパスワード",
    "__stack-auto-translation-142": "アクティブなセッションがありません",
    "__stack-auto-translation-143": "認証方法が有効になっていません。",
    "__stack-auto-translation-144": "デフォルトの支払い方法がありません",
    "__stack-auto-translation-145": "表示名未設定",
    "__stack-auto-translation-146": "このサブスクリプションには他のプランがありません。",
    "__stack-auto-translation-147": "保留中の招待はありません",
    "__stack-auto-translation-148": "チームなし",
    "__stack-auto-translation-149": "まだチームがありません",
    "__stack-auto-translation-15": "APIキー",
    "__stack-auto-translation-150": "サインインしていません",
    "__stack-auto-translation-151": "通知",
    "__stack-auto-translation-152": "OAuth プロバイダーのアクセスが拒否されました",
    "__stack-auto-translation-153": "以前のパスワード",
    "__stack-auto-translation-154": "ワンタイムパスワード",
    "__stack-auto-translation-155": "1回限りの購入",
    "__stack-auto-translation-156": "未払い",
    "__stack-auto-translation-157": "または、次の方法で続行",
    "__stack-auto-translation-158": "他のセッション",
    "__stack-auto-translation-159": "他のチーム",
    "__stack-auto-translation-16": "APIキーはあなたのアカウントへのプログラム的なアクセスを許可します。",
    "__stack-auto-translation-160": "デモモードではOTP管理は利用できません。",
    "__stack-auto-translation-161": "OTPサインイン",
    "__stack-auto-translation-162": "OTPサインインが有効で、現在唯一のサインイン方法のため無効化できません",
    "__stack-auto-translation-163": "OTP/マジックリンクによるサインインは現在有効です。",
    "__stack-auto-translation-164": "未処理の招待",
    "__stack-auto-translation-165": "このチームでのユーザー表示名を上書きする",
    "__stack-auto-translation-166": "支払済",
    "__stack-auto-translation-167": "パスキー",
    "__stack-auto-translation-168": "パスキー管理はデモモードでは利用できません。",
    "__stack-auto-translation-169": "パスキーが登録されました",
    "__stack-auto-translation-17": "APIキーはチームへのプログラム的アクセスを許可します。",
    "__stack-auto-translation-170": "パスキーによるサインインが有効になっており、現在唯一のサインイン方法のため無効化できません",
    "__stack-auto-translation-171": "パスワード",
    "__stack-auto-translation-172": "パスワード管理はデモモードでは利用できません。",
    "__stack-auto-translation-173": "パスワードのリセットが完了しました！",
    "__stack-auto-translation-174": "パスワードが一致しません",
    "__stack-auto-translation-175": "支払い方法",
    "__stack-auto-translation-176": "支払い",
    "__stack-auto-translation-177": "アカウントとすべての関連データを完全に削除する",
    "__stack-auto-translation-178": "個人",
    "__stack-auto-translation-179": "アカウントの設定を完了するには、メールアドレスを追加してください。確認メールをお送りします。",
    "__stack-auto-translation-18": "アカウントを削除してもよろしいですか？この操作は取り消しできず、関連するすべてのデータが削除されます。",
    "__stack-auto-translation-180": "正しいリンクかどうかご確認ください。問題が解決しない場合は、サポートにお問い合わせください。",
    "__stack-auto-translation-181": "メールの受信トレイをご確認ください",
    "__stack-auto-translation-182": "チームに参加する前にアカウント設定を完了してください。",
    "__stack-auto-translation-183": "正しいパスワードリセットリンクかどうか再確認してください。",
    "__stack-auto-translation-184": "正しいチーム招待リンクをお持ちかどうか再確認してください。",
    "__stack-auto-translation-185": "チーム名を入力してください",
    "__stack-auto-translation-186": "有効なメールアドレスを入力してください",
    "__stack-auto-translation-187": "有効なメールアドレスを入力してください",
    "__stack-auto-translation-188": "メールアドレスを入力してください",
    "__stack-auto-translation-189": "メールアドレスを入力してください",
    "__stack-auto-translation-19": "OTPログインを無効にしてもよろしいですか？メールアドレスのみでのログインができなくなります。",
    "__stack-auto-translation-190": "以前のパスワードを入力してください",
    "__stack-auto-translation-191": "パスワードを入力してください",
    "__stack-auto-translation-192": "パスワードをもう一度入力してください",
    "__stack-auto-translation-193": "もう一度お試しください。問題が解決しない場合はサポートにお問い合わせください。",
    "__stack-auto-translation-194": "メールアドレスを認証してください ",
    "__stack-auto-translation-195": "先にメールアドレスを認証してください",
    "__stack-auto-translation-196": "主要",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "プロフィール画像",
    "__stack-auto-translation-199": "パスキーを登録",
    "__stack-auto-translation-2": "アカウント設定",
    "__stack-auto-translation-20": "パスキーでのサインインを無効にしますか？今後パスキーでサインインできなくなります。",
    "__stack-auto-translation-200": "削除",
    "__stack-auto-translation-201": "更新日",
    "__stack-auto-translation-202": "新しいパスワードを再入力",
    "__stack-auto-translation-203": "新しいパスワードを再入力",
    "__stack-auto-translation-204": "パスワードを再入力",
    "__stack-auto-translation-205": "確認メールを再送信",
    "__stack-auto-translation-206": "パスワードをリセット",
    "__stack-auto-translation-207": "パスワードをリセット",
    "__stack-auto-translation-208": "過去の請求書と領収書を確認します。",
    "__stack-auto-translation-209": "取り消す",
    "__stack-auto-translation-21": "チームを退出してもよろしいですか？",
    "__stack-auto-translation-210": "他のすべてのセッションを取り消す",
    "__stack-auto-translation-211": "保存",
    "__stack-auto-translation-212": "認証アプリでこのQRコードをスキャンしてください：",
    "__stack-auto-translation-213": "シークレットAPIキー",
    "__stack-auto-translation-214": "同じ製品ラインから新しいプランを選択してください。",
    "__stack-auto-translation-215": "メールを送信",
    "__stack-auto-translation-216": "メールを送信",
    "__stack-auto-translation-217": "確認メールを送信",
    "__stack-auto-translation-218": "セッション",
    "__stack-auto-translation-219": "アカウントのパスワードを設定する",
    "__stack-auto-translation-22": "認証に失敗しました",
    "__stack-auto-translation-220": "主要に設定",
    "__stack-auto-translation-221": "パスワードを設定",
    "__stack-auto-translation-222": "パスワードを設定",
    "__stack-auto-translation-223": "設定",
    "__stack-auto-translation-224": "ログイン",
    "__stack-auto-translation-225": "ログイン",
    "__stack-auto-translation-226": "もう一度ログイン",
    "__stack-auto-translation-227": "チームに参加するにはログインするか、アカウントを作成してください。",
    "__stack-auto-translation-228": "アカウントにログイン",
    "__stack-auto-translation-229": "パスキーでログイン",
    "__stack-auto-translation-23": "認証",
    "__stack-auto-translation-230": "{provider}でログイン",
    "__stack-auto-translation-231": "サインアウト",
    "__stack-auto-translation-232": "登録",
    "__stack-auto-translation-233": "登録",
    "__stack-auto-translation-234": "現在、新規ユーザーの登録は無効になっています。",
    "__stack-auto-translation-235": "パスキーで登録",
    "__stack-auto-translation-236": "{provider}で登録",
    "__stack-auto-translation-237": "ログインに成功しました！",
    "__stack-auto-translation-238": "ログイン時間：{time}",
    "__stack-auto-translation-239": "OAuth コールバックの処理中にエラーが発生しました：",
    "__stack-auto-translation-24": "CLIアプリケーションを認証",
    "__stack-auto-translation-240": "ステータス",
    "__stack-auto-translation-241": "サインインに使用しない",
    "__stack-auto-translation-242": "サブスクリプション",
    "__stack-auto-translation-243": "プランを変更",
    "__stack-auto-translation-244": "デモモードではチーム作成が無効になっています",
    "__stack-auto-translation-245": "チーム作成が有効になっていません",
    "__stack-auto-translation-246": "チーム表示名",
    "__stack-auto-translation-247": "チーム招待",
    "__stack-auto-translation-248": "チームプロフィール画像",
    "__stack-auto-translation-249": "チーム内ユーザー名",
    "__stack-auto-translation-25": "認証中...",
    "__stack-auto-translation-250": "チーム",
    "__stack-auto-translation-251": "CLIアプリケーションの認証が完了しました。このウィンドウを閉じて、コマンドラインに戻ってください。",
    "__stack-auto-translation-252": "マジックリンクは既に使用されています。リンクは一度しか使用できません。再度サインインする必要がある場合は、新しいマジックリンクをリクエストしてください。",
    "__stack-auto-translation-253": "サインイン操作はキャンセルされたか拒否されました。もう一度お試しください。",
    "__stack-auto-translation-254": "ユーザーは既に別のOAuthアカウントに接続されています。OAuthプロバイダーのページで間違ったアカウントを選択した可能性はありませんか？",
    "__stack-auto-translation-255": "次に、6桁のMFAコードを入力してください：",
    "__stack-auto-translation-256": "現在ログインしているデバイスです。セッションを終了するにはアクセスを取り消してください。",
    "__stack-auto-translation-257": "このアカウントは既に別のユーザーに接続されています。別のアカウントを接続してください。",
    "__stack-auto-translation-258": "このメールアドレスは既に他のユーザーのサインインに使用されています。",
    "__stack-auto-translation-259": "これは表示名であり、認証には使用されません",
    "__stack-auto-translation-26": "キャンセル",
    "__stack-auto-translation-260": "これはStackのエラーである可能性が高いです。ご報告ください。",
    "__stack-auto-translation-261": "このパスワードリセットリンクは既に使用されています。再度パスワードをリセットする必要がある場合は、ログインページから新しいパスワードリセットリンクをリクエストしてください。",
    "__stack-auto-translation-262": "このチーム招待リンクは既に使用されています。",
    "__stack-auto-translation-263": "OTP ログインを有効にするには、確認済みのサインインメールを追加してください。",
    "__stack-auto-translation-264": "パスキーでのサインインを有効にするには、認証済みのサインインメールを追加してください。",
    "__stack-auto-translation-265": "パスワードを設定するには、サインイン用のメールアドレスを追加してください。",
    "__stack-auto-translation-266": "テーマ切替",
    "__stack-auto-translation-267": "TOTP多要素認証QRコード",
    "__stack-auto-translation-268": "再試行",
    "__stack-auto-translation-269": "利用不可",
    "__stack-auto-translation-27": "サブスクリプションをキャンセル",
    "__stack-auto-translation-270": "回収不能",
    "__stack-auto-translation-271": "不明",
    "__stack-auto-translation-272": "未認証",
    "__stack-auto-translation-273": "パスワードを更新",
    "__stack-auto-translation-274": "パスワードを更新",
    "__stack-auto-translation-275": "支払い方法を更新",
    "__stack-auto-translation-276": "パスワードを更新",
    "__stack-auto-translation-277": "チーム用の画像をアップロード",
    "__stack-auto-translation-278": "アバターとして独自の画像をアップロード",
    "__stack-auto-translation-279": "サインインに使用",
    "__stack-auto-translation-28": "キャンセルすると、このサブスクリプションの今後の更新が停止されます。",
    "__stack-auto-translation-280": "サインインに使用",
    "__stack-auto-translation-281": "使用済みパスワードリセットリンク",
    "__stack-auto-translation-282": "使用済みチーム招待リンク",
    "__stack-auto-translation-283": "ユーザー",
    "__stack-auto-translation-284": "ユーザー名",
    "__stack-auto-translation-285": "認証に失敗しました",
    "__stack-auto-translation-286": "認証済み！リダイレクト中...",
    "__stack-auto-translation-287": "確認",
    "__stack-auto-translation-288": "確認中...",
    "__stack-auto-translation-289": "表示",
    "__stack-auto-translation-29": "変更",
    "__stack-auto-translation-290": "有効なプランと購入内容を表示します。",
    "__stack-auto-translation-291": "無効",
    "__stack-auto-translation-292": "警告：コマンドラインアプリケーションがあなたのアカウントにアクセスするため、信頼できることを確認してください。このリクエストを開始していない場合は、このページを閉じて無視してください。当社がこのリンクをメールやその他の手段で送信することは決してありません。",
    "__stack-auto-translation-293": "すでにサインインしています",
    "__stack-auto-translation-294": "現在サインインしていません。",
    "__stack-auto-translation-295": "最後のサインインメールは削除できません",
    "__stack-auto-translation-296": "現在のセッションを取り消すことはできません",
    "__stack-auto-translation-297": "メールアドレスが認証されました！",
    "__stack-auto-translation-298": "アカウントの設定がまだ完了していません。エラーだと思われる場合は、サポートまでお問い合わせください。",
    "__stack-auto-translation-299": "あなたのメールアドレス",
    "__stack-auto-translation-3": "アカウント設定",
    "__stack-auto-translation-30": "プランを変更",
    "__stack-auto-translation-300": "メール認証リンクの有効期限が切れました。アカウント設定から新しい認証リンクをリクエストしてください。",
    "__stack-auto-translation-301": "マジックリンクの有効期限が切れました。サインインする必要がある場合は、新しいマジックリンクをリクエストしてください。",
    "__stack-auto-translation-302": "パスワードがリセットされました。新しいパスワードでログインできます。",
    "__stack-auto-translation-303": "パスワードリセットリンクの有効期限が切れました。ログインページから新しいリセットリンクをリクエストしてください。",
    "__stack-auto-translation-304": "チーム招待リンクの有効期限が切れています。新しいチーム招待リンクをリクエストしてください",
    "__stack-auto-translation-31": "チームの表示名を変更する",
    "__stack-auto-translation-32": "プランを選択",
    "__stack-auto-translation-33": "受信したいメールを選択してください",
    "__stack-auto-translation-34": "CLI認証成功",
    "__stack-auto-translation-35": "ここをクリック",
    "__stack-auto-translation-36": "下のボタンをクリックして確認リンクを再送信してください。",
    "__stack-auto-translation-37": "閉じる",
    "__stack-auto-translation-38": "セットアップを完了",
    "__stack-auto-translation-39": "アカウント設定を完了してください",
    "__stack-auto-translation-4": "有効なプラン",
    "__stack-auto-translation-40": "確認",
    "__stack-auto-translation-41": "続ける",
    "__stack-auto-translation-42": "安全な場所にコピーしてください。再度表示することはできません。",
    "__stack-auto-translation-43": "画像をトリミングできませんでした。",
    "__stack-auto-translation-44": "作成",
    "__stack-auto-translation-45": "新しいアカウントを作成",
    "__stack-auto-translation-46": "チームを作成",
    "__stack-auto-translation-47": "チームを作成",
    "__stack-auto-translation-48": "APIキーを作成",
    "__stack-auto-translation-49": "クレジットパック",
    "__stack-auto-translation-5": "アクティブなセッション",
    "__stack-auto-translation-50": "現在のセッション",
    "__stack-auto-translation-51": "現在のチーム",
    "__stack-auto-translation-52": "危険エリア",
    "__stack-auto-translation-53": "日付",
    "__stack-auto-translation-54": "アカウント削除",
    "__stack-auto-translation-55": "アカウント削除",
    "__stack-auto-translation-56": "パスキーを削除",
    "__stack-auto-translation-57": "説明",
    "__stack-auto-translation-58": "説明が必要です",
    "__stack-auto-translation-59": "無効化",
    "__stack-auto-translation-6": "追加",
    "__stack-auto-translation-60": "MFAを無効にする",
    "__stack-auto-translation-61": "OTPを無効にする",
    "__stack-auto-translation-62": "表示名",
    "__stack-auto-translation-63": "ログインしますか？",
    "__stack-auto-translation-64": "メールアドレスを認証しますか？",
    "__stack-auto-translation-65": "アカウントをお持ちでない方?",
    "__stack-auto-translation-66": "リセットの必要はありませんか？",
    "__stack-auto-translation-67": "下書き",
    "__stack-auto-translation-68": "例: 開発環境、本番環境、CI/CD",
    "__stack-auto-translation-69": "メールアドレス",
    "__stack-auto-translation-7": "プランを切り替える前に支払い方法を追加してください。",
    "__stack-auto-translation-70": "メール & パスワード",
    "__stack-auto-translation-71": "メールアドレスが既に存在します",
    "__stack-auto-translation-72": "メールアドレスは必須です",
    "__stack-auto-translation-73": "デモモードではメール管理を利用できません。",
    "__stack-auto-translation-74": "メールを送信しました！",
    "__stack-auto-translation-75": "メールアドレス",
    "__stack-auto-translation-76": "メール & 認証",
    "__stack-auto-translation-77": "MFAを有効にする",
    "__stack-auto-translation-78": "OTPを有効にする",
    "__stack-auto-translation-79": "サインインメールにマジックリンクまたはOTPを送信してサインインを有効にする",
    "__stack-auto-translation-8": "メールを追加",
    "__stack-auto-translation-80": "現在のセッションを終了",
    "__stack-auto-translation-81": "新しいチームの表示名を入力してください",
    "__stack-auto-translation-82": "メールアドレスを入力",
    "__stack-auto-translation-83": "メールに記載されたコードを入力",
    "__stack-auto-translation-84": "認証アプリから6桁のコードを入力してください",
    "__stack-auto-translation-85": "メールアドレスを入力",
    "__stack-auto-translation-86": "期限切れのマジックリンク",
    "__stack-auto-translation-87": "期限切れのパスワードリセットリンク",
    "__stack-auto-translation-88": "チーム招待リンクの期限切れ",
    "__stack-auto-translation-89": "メール認証リンクの期限切れ",
    "__stack-auto-translation-9": "新しいパスキーを追加",
    "__stack-auto-translation-90": "有効期限",
    "__stack-auto-translation-91": "有効期限",
    "__stack-auto-translation-92": "CLIアプリケーションの認証に失敗しました：",
    "__stack-auto-translation-93": "アカウントの接続に失敗しました",
    "__stack-auto-translation-94": "パスワードのリセットに失敗しました",
    "__stack-auto-translation-95": "パスワードのリセットに失敗しました。新しいパスワードリセットリンクをリクエストしてください",
    "__stack-auto-translation-96": "パスワードをお忘れですか？",
    "__stack-auto-translation-97": "ホームへ",
    "__stack-auto-translation-98": "ホームへ",
    "__stack-auto-translation-99": "こちらがあなたのAPIキーです。"
  } as const)),
  "ko-KR": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "명령줄 애플리케이션이 계정 접근 권한을 요청하고 있습니다. 아래 버튼을 클릭하여 승인하세요.",
    "__stack-auto-translation-10": "이메일 주소 추가",
    "__stack-auto-translation-100": "이 키를 다시 볼 수 없다는 것을 이해했습니다.",
    "__stack-auto-translation-101": "해당 이메일 주소의 사용자가 존재하면 받은편지함으로 이메일을 보냈습니다. 스팸 폴더도 확인해 주세요.",
    "__stack-auto-translation-102": "자동으로 리다이렉트되지 않는 경우, ",
    "__stack-auto-translation-103": "무시",
    "__stack-auto-translation-104": "대리 접속",
    "__stack-auto-translation-105": "잘못된 코드입니다. 다시 시도해 주세요.",
    "__stack-auto-translation-106": "잘못된 비밀번호",
    "__stack-auto-translation-107": "잘못된 코드",
    "__stack-auto-translation-108": "유효하지 않은 이미지",
    "__stack-auto-translation-109": "잘못된 매직 링크",
    "__stack-auto-translation-11": "이미 계정이 있으신가요?",
    "__stack-auto-translation-110": "유효하지 않은 비밀번호 재설정 링크",
    "__stack-auto-translation-111": "유효하지 않은 팀 초대 링크",
    "__stack-auto-translation-112": "유효하지 않은 TOTP 코드",
    "__stack-auto-translation-113": "유효하지 않은 인증 링크",
    "__stack-auto-translation-114": "이메일로 팀에 사용자 초대하기",
    "__stack-auto-translation-115": "멤버 초대",
    "__stack-auto-translation-116": "사용자 초대",
    "__stack-auto-translation-117": "청구서",
    "__stack-auto-translation-118": "청구서",
    "__stack-auto-translation-119": "IP 주소",
    "__stack-auto-translation-12": "금액",
    "__stack-auto-translation-120": "참여",
    "__stack-auto-translation-121": "최근 사용",
    "__stack-auto-translation-122": "나가기",
    "__stack-auto-translation-123": "팀 나가기",
    "__stack-auto-translation-124": "팀 나가기",
    "__stack-auto-translation-125": "이 팀에서 나가고 팀 프로필을 삭제합니다",
    "__stack-auto-translation-126": "위치",
    "__stack-auto-translation-127": "매직 링크 사용 완료",
    "__stack-auto-translation-128": "구독 및 청구서에 사용되는 기본 결제 수단을 관리합니다.",
    "__stack-auto-translation-129": "멤버",
    "__stack-auto-translation-13": "알 수 없는 오류가 발생했습니다",
    "__stack-auto-translation-130": "데모 모드에서는 MFA 관리가 불가능합니다.",
    "__stack-auto-translation-131": "인증 정보 누락",
    "__stack-auto-translation-132": "다중 인증",
    "__stack-auto-translation-133": "다중 인증",
    "__stack-auto-translation-134": "현재 다중 인증이 비활성화되어 있습니다.",
    "__stack-auto-translation-135": "다중 인증이 현재 활성화되어 있습니다.",
    "__stack-auto-translation-136": "내 프로필",
    "__stack-auto-translation-137": "이름",
    "__stack-auto-translation-138": "없음",
    "__stack-auto-translation-139": "새 계정 등록이 허용되지 않습니다",
    "__stack-auto-translation-14": "API 키",
    "__stack-auto-translation-140": "새 비밀번호",
    "__stack-auto-translation-141": "새 비밀번호",
    "__stack-auto-translation-142": "활성 세션 없음",
    "__stack-auto-translation-143": "인증 방법이 활성화되지 않음.",
    "__stack-auto-translation-144": "기본 결제 수단 없음",
    "__stack-auto-translation-145": "표시 이름이 설정되지 않음",
    "__stack-auto-translation-146": "이 구독에 사용 가능한 다른 플랜이 없습니다.",
    "__stack-auto-translation-147": "대기 중인 초대 없음",
    "__stack-auto-translation-148": "팀 없음",
    "__stack-auto-translation-149": "아직 팀 없음",
    "__stack-auto-translation-15": "API 키",
    "__stack-auto-translation-150": "로그인되지 않음",
    "__stack-auto-translation-151": "알림",
    "__stack-auto-translation-152": "OAuth 공급자 액세스 거부됨",
    "__stack-auto-translation-153": "이전 비밀번호",
    "__stack-auto-translation-154": "일회용 비밀번호",
    "__stack-auto-translation-155": "일회성 구매",
    "__stack-auto-translation-156": "미결",
    "__stack-auto-translation-157": "또는 다음으로 계속",
    "__stack-auto-translation-158": "다른 세션",
    "__stack-auto-translation-159": "다른 팀",
    "__stack-auto-translation-16": "API 키는 계정에 프로그래밍 방식으로 접근할 수 있는 권한을 부여합니다.",
    "__stack-auto-translation-160": "데모 모드에서는 OTP 관리를 사용할 수 없습니다.",
    "__stack-auto-translation-161": "OTP 로그인",
    "__stack-auto-translation-162": "OTP 로그인이 활성화되어 있으며 현재 유일한 로그인 방법이므로 비활성화할 수 없습니다",
    "__stack-auto-translation-163": "OTP/매직 링크 로그인이 현재 활성화되어 있습니다.",
    "__stack-auto-translation-164": "미처리된 초대",
    "__stack-auto-translation-165": "이 팀에서 사용자 표시 이름 덮어쓰기",
    "__stack-auto-translation-166": "결제 완료",
    "__stack-auto-translation-167": "패스키",
    "__stack-auto-translation-168": "데모 모드에서는 패스키 관리를 사용할 수 없습니다.",
    "__stack-auto-translation-169": "패스키 등록됨",
    "__stack-auto-translation-17": "API 키는 팀에 프로그래밍 방식의 접근 권한을 부여합니다.",
    "__stack-auto-translation-170": "패스키 로그인이 활성화되어 있으며 현재 유일한 로그인 방법이므로 비활성화할 수 없습니다",
    "__stack-auto-translation-171": "비밀번호",
    "__stack-auto-translation-172": "비밀번호 관리는 데모 모드에서 사용할 수 없습니다.",
    "__stack-auto-translation-173": "비밀번호가 성공적으로 재설정되었습니다!",
    "__stack-auto-translation-174": "비밀번호가 일치하지 않습니다",
    "__stack-auto-translation-175": "결제 수단",
    "__stack-auto-translation-176": "결제",
    "__stack-auto-translation-177": "계정과 관련된 모든 데이터를 영구적으로 삭제",
    "__stack-auto-translation-178": "개인",
    "__stack-auto-translation-179": "계정 설정을 완료하려면 이메일 주소를 추가해 주세요. 인증 이메일을 보내드립니다.",
    "__stack-auto-translation-18": "계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없으며 모든 관련 데이터가 삭제됩니다.",
    "__stack-auto-translation-180": "올바른 링크인지 확인해 주세요. 문제가 계속되면 고객 지원에 문의하세요.",
    "__stack-auto-translation-181": "이메일 받은 편지함을 확인해 주세요",
    "__stack-auto-translation-182": "팀에 참여하기 전에 계정 설정을 완료해 주세요.",
    "__stack-auto-translation-183": "올바른 비밀번호 재설정 링크인지 다시 한 번 확인해 주세요.",
    "__stack-auto-translation-184": "올바른 팀 초대 링크인지 다시 확인해 주세요.",
    "__stack-auto-translation-185": "팀 이름을 입력해 주세요",
    "__stack-auto-translation-186": "유효한 이메일을 입력해 주세요",
    "__stack-auto-translation-187": "유효한 이메일 주소를 입력해 주세요",
    "__stack-auto-translation-188": "이메일 주소를 입력해 주세요",
    "__stack-auto-translation-189": "이메일을 입력해 주세요",
    "__stack-auto-translation-19": "OTP 로그인을 비활성화하시겠습니까? 더 이상 이메일만으로 로그인할 수 없게 됩니다.",
    "__stack-auto-translation-190": "이전 비밀번호를 입력해 주세요",
    "__stack-auto-translation-191": "비밀번호를 입력해 주세요",
    "__stack-auto-translation-192": "비밀번호를 다시 입력해 주세요",
    "__stack-auto-translation-193": "다시 시도해 보시고 문제가 계속되면 지원팀에 문의하세요.",
    "__stack-auto-translation-194": "이메일 주소를 인증해 주세요 ",
    "__stack-auto-translation-195": "먼저 이메일을 인증해 주세요",
    "__stack-auto-translation-196": "주요",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "프로필 이미지",
    "__stack-auto-translation-199": "패스키 등록",
    "__stack-auto-translation-2": "계정 설정",
    "__stack-auto-translation-20": "패스키 로그인을 비활성화하시겠습니까? 더 이상 패스키로 로그인할 수 없게 됩니다.",
    "__stack-auto-translation-200": "삭제",
    "__stack-auto-translation-201": "갱신일",
    "__stack-auto-translation-202": "새 비밀번호 확인",
    "__stack-auto-translation-203": "새 비밀번호 확인",
    "__stack-auto-translation-204": "비밀번호 확인",
    "__stack-auto-translation-205": "인증 이메일 재전송",
    "__stack-auto-translation-206": "비밀번호 재설정",
    "__stack-auto-translation-207": "비밀번호 재설정",
    "__stack-auto-translation-208": "과거 청구서 및 영수증을 확인하세요.",
    "__stack-auto-translation-209": "취소",
    "__stack-auto-translation-21": "정말로 팀을 나가시겠습니까?",
    "__stack-auto-translation-210": "다른 모든 세션 취소",
    "__stack-auto-translation-211": "저장",
    "__stack-auto-translation-212": "인증 앱으로 이 QR 코드를 스캔하세요:",
    "__stack-auto-translation-213": "비밀 API 키",
    "__stack-auto-translation-214": "동일한 제품 라인에서 새 플랜을 선택하세요.",
    "__stack-auto-translation-215": "이메일 보내기",
    "__stack-auto-translation-216": "이메일 보내기",
    "__stack-auto-translation-217": "인증 이메일 보내기",
    "__stack-auto-translation-218": "세션",
    "__stack-auto-translation-219": "계정에 비밀번호 설정하기",
    "__stack-auto-translation-22": "인증 실패",
    "__stack-auto-translation-220": "주요로 설정",
    "__stack-auto-translation-221": "비밀번호 설정",
    "__stack-auto-translation-222": "비밀번호 설정",
    "__stack-auto-translation-223": "설정",
    "__stack-auto-translation-224": "로그인",
    "__stack-auto-translation-225": "로그인",
    "__stack-auto-translation-226": "다시 로그인",
    "__stack-auto-translation-227": "팀에 참여하려면 로그인하거나 계정을 생성하세요.",
    "__stack-auto-translation-228": "계정에 로그인",
    "__stack-auto-translation-229": "패스키로 로그인",
    "__stack-auto-translation-23": "승인",
    "__stack-auto-translation-230": "{provider}(으)로 로그인",
    "__stack-auto-translation-231": "로그아웃",
    "__stack-auto-translation-232": "가입하기",
    "__stack-auto-translation-233": "가입하기",
    "__stack-auto-translation-234": "현재 신규 사용자 가입이 활성화되어 있지 않습니다.",
    "__stack-auto-translation-235": "패스키로 가입하기",
    "__stack-auto-translation-236": "{provider}(으)로 가입",
    "__stack-auto-translation-237": "로그인 성공!",
    "__stack-auto-translation-238": "{time}에 로그인됨",
    "__stack-auto-translation-239": "OAuth 콜백을 처리하는 동안 문제가 발생했습니다:",
    "__stack-auto-translation-24": "CLI 애플리케이션 인증",
    "__stack-auto-translation-240": "상태",
    "__stack-auto-translation-241": "로그인에 사용 중지",
    "__stack-auto-translation-242": "구독",
    "__stack-auto-translation-243": "플랜 변경",
    "__stack-auto-translation-244": "데모 모드에서는 팀 생성이 비활성화되어 있습니다",
    "__stack-auto-translation-245": "팀 생성이 활성화되어 있지 않습니다",
    "__stack-auto-translation-246": "팀 표시 이름",
    "__stack-auto-translation-247": "팀 초대",
    "__stack-auto-translation-248": "팀 프로필 이미지",
    "__stack-auto-translation-249": "팀 사용자 이름",
    "__stack-auto-translation-25": "인증 중...",
    "__stack-auto-translation-250": "팀",
    "__stack-auto-translation-251": "CLI 애플리케이션이 성공적으로 승인되었습니다. 이 창을 닫고 명령줄로 돌아가세요.",
    "__stack-auto-translation-252": "매직 링크가 이미 사용되었습니다. 링크는 한 번만 사용할 수 있습니다. 다시 로그인해야 하는 경우 새 매직 링크를 요청하세요.",
    "__stack-auto-translation-253": "로그인 작업이 취소되었거나 거부되었습니다. 다시 시도해 주세요.",
    "__stack-auto-translation-254": "사용자는 이미 다른 OAuth 계정에 연결되어 있습니다. OAuth 제공자 페이지에서 잘못된 계정을 선택하셨나요?",
    "__stack-auto-translation-255": "그런 다음 6자리 MFA 코드를 입력하세요:",
    "__stack-auto-translation-256": "현재 로그인된 기기들입니다. 세션을 종료하려면 접근 권한을 해제할 수 있습니다.",
    "__stack-auto-translation-257": "이 계정은 이미 다른 사용자와 연결되어 있습니다. 다른 계정을 연결해 주세요.",
    "__stack-auto-translation-258": "이 이메일은 이미 다른 사용자의 로그인에 사용되고 있습니다.",
    "__stack-auto-translation-259": "이것은 표시 이름이며 인증에 사용되지 않습니다",
    "__stack-auto-translation-26": "취소",
    "__stack-auto-translation-260": "이것은 Stack의 오류일 가능성이 높습니다. 신고해 주세요.",
    "__stack-auto-translation-261": "이 비밀번호 재설정 링크는 이미 사용되었습니다. 비밀번호를 다시 재설정해야 하는 경우, 로그인 페이지에서 새 비밀번호 재설정 링크를 요청하세요.",
    "__stack-auto-translation-262": "이 팀 초대 링크는 이미 사용되었습니다.",
    "__stack-auto-translation-263": "OTP 로그인을 활성화하려면 인증된 로그인 이메일을 추가하세요.",
    "__stack-auto-translation-264": "패스키 로그인을 활성화하려면 인증된 로그인 이메일을 추가하세요.",
    "__stack-auto-translation-265": "비밀번호를 설정하려면 로그인 이메일을 추가하세요.",
    "__stack-auto-translation-266": "테마 전환",
    "__stack-auto-translation-267": "TOTP 다중 인증 QR 코드",
    "__stack-auto-translation-268": "다시 시도",
    "__stack-auto-translation-269": "사용 불가",
    "__stack-auto-translation-27": "구독 취소",
    "__stack-auto-translation-270": "회수불가",
    "__stack-auto-translation-271": "알 수 없음",
    "__stack-auto-translation-272": "미인증",
    "__stack-auto-translation-273": "비밀번호 변경",
    "__stack-auto-translation-274": "비밀번호 변경",
    "__stack-auto-translation-275": "결제 수단 변경",
    "__stack-auto-translation-276": "비밀번호 업데이트",
    "__stack-auto-translation-277": "팀을 위한 이미지 업로드",
    "__stack-auto-translation-278": "아바타로 사용할 이미지 업로드",
    "__stack-auto-translation-279": "로그인에 사용",
    "__stack-auto-translation-28": "취소하면 이 구독의 향후 갱신이 중단됩니다.",
    "__stack-auto-translation-280": "로그인에 사용됨",
    "__stack-auto-translation-281": "사용된 비밀번호 재설정 링크",
    "__stack-auto-translation-282": "사용된 팀 초대 링크",
    "__stack-auto-translation-283": "사용자",
    "__stack-auto-translation-284": "사용자 이름",
    "__stack-auto-translation-285": "인증 실패",
    "__stack-auto-translation-286": "인증됨! 리디렉션 중...",
    "__stack-auto-translation-287": "인증",
    "__stack-auto-translation-288": "인증 중...",
    "__stack-auto-translation-289": "보기",
    "__stack-auto-translation-29": "변경",
    "__stack-auto-translation-290": "활성 플랜 및 구매 내역을 확인하세요.",
    "__stack-auto-translation-291": "무효",
    "__stack-auto-translation-292": "경고: 명령줄 애플리케이션을 신뢰할 수 있는지 확인하세요. 해당 앱이 계정에 접근할 수 있게 됩니다. 이 요청을 시작하지 않았다면 이 페이지를 닫고 무시하세요. 당사는 절대 이 링크를 이메일이나 다른 방법으로 보내지 않습니다.",
    "__stack-auto-translation-293": "이미 로그인되어 있습니다",
    "__stack-auto-translation-294": "현재 로그인되어 있지 않습니다.",
    "__stack-auto-translation-295": "마지막 로그인 이메일을 삭제할 수 없습니다",
    "__stack-auto-translation-296": "현재 세션을 해제할 수 없습니다",
    "__stack-auto-translation-297": "이메일이 인증되었습니다!",
    "__stack-auto-translation-298": "아직 계정 설정을 완료하지 않았습니다. 오류라고 생각되면 지원팀에 문의해 주세요.",
    "__stack-auto-translation-299": "이메일 주소",
    "__stack-auto-translation-3": "계정 설정",
    "__stack-auto-translation-30": "플랜 변경",
    "__stack-auto-translation-300": "이메일 인증 링크가 만료되었습니다. 계정 설정에서 새 인증 링크를 요청해 주세요.",
    "__stack-auto-translation-301": "매직 링크가 만료되었습니다. 로그인이 필요하시면 새 매직 링크를 요청해 주세요.",
    "__stack-auto-translation-302": "비밀번호가 재설정되었습니다. 이제 새 비밀번호로 로그인할 수 있습니다.",
    "__stack-auto-translation-303": "비밀번호 재설정 링크가 만료되었습니다. 로그인 페이지에서 새 비밀번호 재설정 링크를 요청해 주세요.",
    "__stack-auto-translation-304": "팀 초대 링크가 만료되었습니다. 새로운 팀 초대 링크를 요청해 주세요",
    "__stack-auto-translation-31": "팀의 표시 이름 변경",
    "__stack-auto-translation-32": "플랜 선택",
    "__stack-auto-translation-33": "수신할 이메일 선택",
    "__stack-auto-translation-34": "CLI 인증 성공",
    "__stack-auto-translation-35": "여기를 클릭",
    "__stack-auto-translation-36": "아래 버튼을 클릭하여 인증 링크를 다시 보내세요.",
    "__stack-auto-translation-37": "닫기",
    "__stack-auto-translation-38": "설정 완료",
    "__stack-auto-translation-39": "계정 설정 완료하기",
    "__stack-auto-translation-4": "활성 플랜",
    "__stack-auto-translation-40": "확인",
    "__stack-auto-translation-41": "계속",
    "__stack-auto-translation-42": "안전한 곳에 복사하세요. 다시 볼 수 없습니다.",
    "__stack-auto-translation-43": "이미지를 자를 수 없습니다.",
    "__stack-auto-translation-44": "생성",
    "__stack-auto-translation-45": "새 계정 만들기",
    "__stack-auto-translation-46": "팀 만들기",
    "__stack-auto-translation-47": "팀 만들기",
    "__stack-auto-translation-48": "API 키 생성",
    "__stack-auto-translation-49": "크레딧 팩",
    "__stack-auto-translation-5": "활성 세션",
    "__stack-auto-translation-50": "현재 세션",
    "__stack-auto-translation-51": "현재 팀",
    "__stack-auto-translation-52": "위험 구역",
    "__stack-auto-translation-53": "날짜",
    "__stack-auto-translation-54": "계정 삭제",
    "__stack-auto-translation-55": "계정 삭제",
    "__stack-auto-translation-56": "패스키 삭제",
    "__stack-auto-translation-57": "설명",
    "__stack-auto-translation-58": "설명이 필요합니다",
    "__stack-auto-translation-59": "비활성화",
    "__stack-auto-translation-6": "추가",
    "__stack-auto-translation-60": "MFA 비활성화",
    "__stack-auto-translation-61": "OTP 비활성화",
    "__stack-auto-translation-62": "표시 이름",
    "__stack-auto-translation-63": "로그인하시겠습니까?",
    "__stack-auto-translation-64": "이메일을 인증하시겠습니까?",
    "__stack-auto-translation-65": "계정이 없으신가요?",
    "__stack-auto-translation-66": "재설정이 필요 없나요?",
    "__stack-auto-translation-67": "초안",
    "__stack-auto-translation-68": "예: 개발, 프로덕션, CI/CD",
    "__stack-auto-translation-69": "이메일",
    "__stack-auto-translation-7": "요금제를 변경하기 전에 결제 수단을 추가하세요.",
    "__stack-auto-translation-70": "이메일 & 비밀번호",
    "__stack-auto-translation-71": "이메일이 이미 존재합니다",
    "__stack-auto-translation-72": "이메일 필수",
    "__stack-auto-translation-73": "데모 모드에서는 이메일 관리를 사용할 수 없습니다.",
    "__stack-auto-translation-74": "이메일 전송 완료!",
    "__stack-auto-translation-75": "이메일",
    "__stack-auto-translation-76": "이메일 및 인증",
    "__stack-auto-translation-77": "MFA 활성화",
    "__stack-auto-translation-78": "OTP 활성화",
    "__stack-auto-translation-79": "로그인 이메일로 전송되는 매직 링크 또는 OTP로 로그인 활성화.",
    "__stack-auto-translation-8": "이메일 추가",
    "__stack-auto-translation-80": "현재 세션 종료",
    "__stack-auto-translation-81": "새 팀의 표시 이름을 입력하세요",
    "__stack-auto-translation-82": "이메일 입력",
    "__stack-auto-translation-83": "이메일로 받은 코드를 입력하세요",
    "__stack-auto-translation-84": "인증 앱에서 6자리 코드를 입력하세요",
    "__stack-auto-translation-85": "이메일을 입력하세요",
    "__stack-auto-translation-86": "만료된 매직 링크",
    "__stack-auto-translation-87": "만료된 비밀번호 재설정 링크",
    "__stack-auto-translation-88": "만료된 팀 초대 링크",
    "__stack-auto-translation-89": "만료된 인증 링크",
    "__stack-auto-translation-9": "새 패스키 추가",
    "__stack-auto-translation-90": "만료",
    "__stack-auto-translation-91": "만료 기간",
    "__stack-auto-translation-92": "CLI 애플리케이션 인증 실패:",
    "__stack-auto-translation-93": "계정 연결 실패",
    "__stack-auto-translation-94": "비밀번호 재설정 실패",
    "__stack-auto-translation-95": "비밀번호 재설정 실패. 새로운 비밀번호 재설정 링크를 요청해 주세요",
    "__stack-auto-translation-96": "비밀번호를 잊으셨나요?",
    "__stack-auto-translation-97": "홈으로 이동",
    "__stack-auto-translation-98": "홈으로 이동",
    "__stack-auto-translation-99": "API 키가 여기 있습니다."
  } as const)),
  "pt-BR": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Um aplicativo de linha de comando está solicitando acesso à sua conta. Clique no botão abaixo para autorizá-lo.",
    "__stack-auto-translation-10": "Adicione seu endereço de email",
    "__stack-auto-translation-100": "Entendo que não poderei visualizar esta chave novamente.",
    "__stack-auto-translation-101": "Se o usuário com este endereço de e-mail existir, um e-mail foi enviado para sua caixa de entrada. Certifique-se de verificar sua pasta de spam.",
    "__stack-auto-translation-102": "Se você não for redirecionado automaticamente, ",
    "__stack-auto-translation-103": "Ignorar",
    "__stack-auto-translation-104": "Personificação",
    "__stack-auto-translation-105": "Código incorreto. Por favor, tente novamente.",
    "__stack-auto-translation-106": "Senha incorreta",
    "__stack-auto-translation-107": "Código inválido",
    "__stack-auto-translation-108": "Imagem inválida",
    "__stack-auto-translation-109": "Link Mágico Inválido",
    "__stack-auto-translation-11": "Já tem uma conta?",
    "__stack-auto-translation-110": "Link de Redefinição de Senha Inválido",
    "__stack-auto-translation-111": "Link de Convite de Equipe Inválido",
    "__stack-auto-translation-112": "Código TOTP inválido",
    "__stack-auto-translation-113": "Link de Verificação Inválido",
    "__stack-auto-translation-114": "Convide um usuário para sua equipe por e-mail",
    "__stack-auto-translation-115": "Convidar membro",
    "__stack-auto-translation-116": "Convidar Usuário",
    "__stack-auto-translation-117": "Fatura",
    "__stack-auto-translation-118": "Faturas",
    "__stack-auto-translation-119": "Endereço IP",
    "__stack-auto-translation-12": "Valor",
    "__stack-auto-translation-120": "Entrar",
    "__stack-auto-translation-121": "Último uso",
    "__stack-auto-translation-122": "Sair",
    "__stack-auto-translation-123": "Sair da equipe",
    "__stack-auto-translation-124": "Sair da Equipe",
    "__stack-auto-translation-125": "sair desta equipe e remover seu perfil de equipe",
    "__stack-auto-translation-126": "Localização",
    "__stack-auto-translation-127": "Link Mágico Já Utilizado",
    "__stack-auto-translation-128": "Gerencie o método de pagamento padrão usado para assinaturas e faturas.",
    "__stack-auto-translation-129": "Membros",
    "__stack-auto-translation-13": "Um erro desconhecido ocorreu",
    "__stack-auto-translation-130": "O gerenciamento de MFA não está disponível no modo de demonstração.",
    "__stack-auto-translation-131": "Informações de verificação ausentes",
    "__stack-auto-translation-132": "Autenticação de múltiplos fatores",
    "__stack-auto-translation-133": "Autenticação de Múltiplos Fatores",
    "__stack-auto-translation-134": "A autenticação de múltiplos fatores está atualmente desativada.",
    "__stack-auto-translation-135": "A autenticação multifator está atualmente ativada.",
    "__stack-auto-translation-136": "Meu Perfil",
    "__stack-auto-translation-137": "Nome",
    "__stack-auto-translation-138": "Nunca",
    "__stack-auto-translation-139": "Não é permitido o registro de novas contas",
    "__stack-auto-translation-14": "Chave de API",
    "__stack-auto-translation-140": "Nova senha",
    "__stack-auto-translation-141": "Nova Senha",
    "__stack-auto-translation-142": "Nenhuma sessão ativa encontrada",
    "__stack-auto-translation-143": "Nenhum método de autenticação habilitado.",
    "__stack-auto-translation-144": "Nenhuma forma de pagamento padrão",
    "__stack-auto-translation-145": "Nome de exibição não definido",
    "__stack-auto-translation-146": "Não há outros planos disponíveis para esta assinatura.",
    "__stack-auto-translation-147": "Sem convites pendentes",
    "__stack-auto-translation-148": "Sem equipe",
    "__stack-auto-translation-149": "Ainda sem equipes",
    "__stack-auto-translation-15": "Chaves de API",
    "__stack-auto-translation-150": "Não conectado",
    "__stack-auto-translation-151": "Notificações",
    "__stack-auto-translation-152": "Acesso ao provedor OAuth negado",
    "__stack-auto-translation-153": "Senha antiga",
    "__stack-auto-translation-154": "Senha de Uso Único",
    "__stack-auto-translation-155": "Compra única",
    "__stack-auto-translation-156": "Aberta",
    "__stack-auto-translation-157": "Ou continuar com",
    "__stack-auto-translation-158": "Outra Sessão",
    "__stack-auto-translation-159": "Outras equipes",
    "__stack-auto-translation-16": "Chaves de API concedem acesso programático à sua conta.",
    "__stack-auto-translation-160": "O gerenciamento de OTP não está disponível no modo de demonstração.",
    "__stack-auto-translation-161": "Autenticação por OTP",
    "__stack-auto-translation-162": "A autenticação por OTP está habilitada e não pode ser desativada, pois atualmente é o único método de autenticação",
    "__stack-auto-translation-163": "O login por OTP/link mágico está atualmente habilitado.",
    "__stack-auto-translation-164": "Convites pendentes",
    "__stack-auto-translation-165": "Substitua seu nome de exibição de usuário nesta equipe",
    "__stack-auto-translation-166": "Pago",
    "__stack-auto-translation-167": "Chave de acesso",
    "__stack-auto-translation-168": "O gerenciamento de chaves de acesso não está disponível no modo de demonstração.",
    "__stack-auto-translation-169": "Chave de acesso registrada",
    "__stack-auto-translation-17": "Chaves de API concedem acesso programático à sua equipe.",
    "__stack-auto-translation-170": "O acesso por chave de acesso está habilitado e não pode ser desativado, pois é atualmente o único método de acesso",
    "__stack-auto-translation-171": "Senha",
    "__stack-auto-translation-172": "O gerenciamento de senha não está disponível no modo de demonstração.",
    "__stack-auto-translation-173": "Senha redefinida com sucesso!",
    "__stack-auto-translation-174": "As senhas não coincidem",
    "__stack-auto-translation-175": "Forma de pagamento",
    "__stack-auto-translation-176": "Pagamentos",
    "__stack-auto-translation-177": "Remover permanentemente sua conta e todos os dados associados",
    "__stack-auto-translation-178": "Pessoal",
    "__stack-auto-translation-179": "Por favor, adicione um endereço de e-mail para concluir a configuração da sua conta. Enviaremos um e-mail de verificação.",
    "__stack-auto-translation-18": "Tem certeza de que deseja excluir sua conta? Esta ação é IRREVERSÍVEL e excluirá TODOS os dados associados.",
    "__stack-auto-translation-180": "Verifique se você tem o link correto. Se continuar tendo problemas, entre em contato com o suporte.",
    "__stack-auto-translation-181": "Verifique sua caixa de entrada",
    "__stack-auto-translation-182": "Por favor, conclua a configuração da sua conta antes de entrar em equipes.",
    "__stack-auto-translation-183": "Verifique novamente se você tem o link correto para redefinição de senha.",
    "__stack-auto-translation-184": "Por favor, verifique se você tem o link de convite para equipe correto.",
    "__stack-auto-translation-185": "Por favor, insira um nome para a equipe",
    "__stack-auto-translation-186": "Por favor, insira um e-mail válido",
    "__stack-auto-translation-187": "Insira um endereço de e-mail válido",
    "__stack-auto-translation-188": "Por favor, insira um endereço de e-mail",
    "__stack-auto-translation-189": "Por favor, insira seu e-mail",
    "__stack-auto-translation-19": "Tem certeza de que deseja desativar a autenticação por OTP? Você não poderá mais entrar apenas com e-mails.",
    "__stack-auto-translation-190": "Por favor, digite sua senha antiga",
    "__stack-auto-translation-191": "Insira sua senha",
    "__stack-auto-translation-192": "Por favor, repita sua senha",
    "__stack-auto-translation-193": "Por favor, tente novamente e, se o problema persistir, entre em contato com o suporte.",
    "__stack-auto-translation-194": "Por favor, verifique seu endereço de email ",
    "__stack-auto-translation-195": "Por favor, verifique seu email primeiro",
    "__stack-auto-translation-196": "Primário",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Imagem de perfil",
    "__stack-auto-translation-199": "Registrar uma chave de acesso",
    "__stack-auto-translation-2": "Configurações da conta",
    "__stack-auto-translation-20": "Tem certeza que deseja desativar o login com chave de acesso? Você não poderá mais entrar com sua chave de acesso.",
    "__stack-auto-translation-200": "Remover",
    "__stack-auto-translation-201": "Renova em",
    "__stack-auto-translation-202": "Repita a nova senha",
    "__stack-auto-translation-203": "Repita a Nova Senha",
    "__stack-auto-translation-204": "Repetir Senha",
    "__stack-auto-translation-205": "Reenviar email de verificação",
    "__stack-auto-translation-206": "Redefinir Senha",
    "__stack-auto-translation-207": "Redefina Sua Senha",
    "__stack-auto-translation-208": "Revise faturas e recibos anteriores.",
    "__stack-auto-translation-209": "Revogar",
    "__stack-auto-translation-21": "Tem certeza de que deseja sair da equipe?",
    "__stack-auto-translation-210": "Revogar Todas as Outras Sessões",
    "__stack-auto-translation-211": "Salvar",
    "__stack-auto-translation-212": "Escaneie este código QR com seu aplicativo autenticador:",
    "__stack-auto-translation-213": "Chave de API Secreta",
    "__stack-auto-translation-214": "Selecione um novo plano da mesma linha de produtos.",
    "__stack-auto-translation-215": "Enviar e-mail",
    "__stack-auto-translation-216": "Enviar Email",
    "__stack-auto-translation-217": "Enviar email de verificação",
    "__stack-auto-translation-218": "Sessão",
    "__stack-auto-translation-219": "Defina uma senha para sua conta",
    "__stack-auto-translation-22": "Autorização Falhou",
    "__stack-auto-translation-220": "Definir como primário",
    "__stack-auto-translation-221": "Definir senha",
    "__stack-auto-translation-222": "Definir Senha",
    "__stack-auto-translation-223": "Configurações",
    "__stack-auto-translation-224": "Entrar",
    "__stack-auto-translation-225": "Entrar",
    "__stack-auto-translation-226": "Entrar novamente",
    "__stack-auto-translation-227": "Faça login ou crie uma conta para entrar na equipe.",
    "__stack-auto-translation-228": "Entrar na sua conta",
    "__stack-auto-translation-229": "Entrar com Chave de acesso",
    "__stack-auto-translation-23": "Autorizar",
    "__stack-auto-translation-230": "Entrar com {provider}",
    "__stack-auto-translation-231": "Sair",
    "__stack-auto-translation-232": "Cadastrar-se",
    "__stack-auto-translation-233": "Cadastrar-se",
    "__stack-auto-translation-234": "O cadastro para novos usuários não está disponível no momento.",
    "__stack-auto-translation-235": "Cadastre-se com Chave de acesso",
    "__stack-auto-translation-236": "Cadastre-se com {provider}",
    "__stack-auto-translation-237": "Login realizado com sucesso!",
    "__stack-auto-translation-238": "Conectado em {time}",
    "__stack-auto-translation-239": "Algo deu errado ao processar o retorno de chamada OAuth:",
    "__stack-auto-translation-24": "Autorizar Aplicativo de CLI",
    "__stack-auto-translation-240": "Status",
    "__stack-auto-translation-241": "Parar de usar para login",
    "__stack-auto-translation-242": "Assinatura",
    "__stack-auto-translation-243": "Mudar plano",
    "__stack-auto-translation-244": "A criação de equipes está desativada no modo de demonstração",
    "__stack-auto-translation-245": "Criação de equipe não está habilitada",
    "__stack-auto-translation-246": "Nome de exibição da equipe",
    "__stack-auto-translation-247": "Convite para equipe",
    "__stack-auto-translation-248": "Imagem de perfil da equipe",
    "__stack-auto-translation-249": "Nome de usuário na equipe",
    "__stack-auto-translation-25": "Autorizando...",
    "__stack-auto-translation-250": "Equipes",
    "__stack-auto-translation-251": "A aplicação CLI foi autorizada com sucesso. Você pode fechar esta janela e retornar à linha de comando.",
    "__stack-auto-translation-252": "O link mágico já foi utilizado. O link só pode ser usado uma vez. Por favor, solicite um novo link mágico se precisar fazer login novamente.",
    "__stack-auto-translation-253": "A operação de login foi cancelada ou negada. Tente novamente.",
    "__stack-auto-translation-254": "O usuário já está conectado a outra conta OAuth. Você selecionou a conta errada na página do provedor OAuth?",
    "__stack-auto-translation-255": "Em seguida, insira seu código MFA de seis dígitos:",
    "__stack-auto-translation-256": "Estes são os dispositivos onde você está atualmente conectado. Você pode revogar o acesso para encerrar uma sessão.",
    "__stack-auto-translation-257": "Esta conta já está conectada a outro usuário. Por favor, conecte uma conta diferente.",
    "__stack-auto-translation-258": "Este email já está sendo usado para login por outro usuário.",
    "__stack-auto-translation-259": "Este é um nome de exibição e não é usado para autenticação",
    "__stack-auto-translation-26": "Cancelar",
    "__stack-auto-translation-260": "Isto é provavelmente um erro no Stack. Por favor, reporte-o.",
    "__stack-auto-translation-261": "Este link de redefinição de senha já foi utilizado. Se precisar redefinir sua senha novamente, solicite um novo link na página de login.",
    "__stack-auto-translation-262": "Este link de convite para a equipe já foi utilizado.",
    "__stack-auto-translation-263": "Para habilitar a autenticação por OTP, adicione um email de login verificado.",
    "__stack-auto-translation-264": "Para habilitar o login por chave de acesso, adicione um email de login verificado.",
    "__stack-auto-translation-265": "Para definir uma senha, adicione um email de login.",
    "__stack-auto-translation-266": "Alternar tema",
    "__stack-auto-translation-267": "Código QR de autenticação de múltiplos fatores TOTP",
    "__stack-auto-translation-268": "Tentar novamente",
    "__stack-auto-translation-269": "Indisponível",
    "__stack-auto-translation-27": "Cancelar assinatura",
    "__stack-auto-translation-270": "Incobrável",
    "__stack-auto-translation-271": "Desconhecido",
    "__stack-auto-translation-272": "Não verificado",
    "__stack-auto-translation-273": "Atualizar senha",
    "__stack-auto-translation-274": "Atualizar Senha",
    "__stack-auto-translation-275": "Atualizar forma de pagamento",
    "__stack-auto-translation-276": "Atualize sua senha",
    "__stack-auto-translation-277": "Envie uma imagem para sua equipe",
    "__stack-auto-translation-278": "Envie sua própria imagem como seu avatar",
    "__stack-auto-translation-279": "Usar para login",
    "__stack-auto-translation-28": "Cancelar interromperá as renovações futuras desta assinatura.",
    "__stack-auto-translation-280": "Usado para login",
    "__stack-auto-translation-281": "Link de Redefinição de Senha Utilizado",
    "__stack-auto-translation-282": "Link de Convite de Equipe Usado",
    "__stack-auto-translation-283": "Usuário",
    "__stack-auto-translation-284": "Nome de usuário",
    "__stack-auto-translation-285": "Verificação falhou",
    "__stack-auto-translation-286": "Verificado! Redirecionando...",
    "__stack-auto-translation-287": "Verificar",
    "__stack-auto-translation-288": "Verificando...",
    "__stack-auto-translation-289": "Visualizar",
    "__stack-auto-translation-29": "alterar",
    "__stack-auto-translation-290": "Veja seus planos ativos e compras.",
    "__stack-auto-translation-291": "Anulada",
    "__stack-auto-translation-292": "AVISO: Certifique-se de confiar no aplicativo de linha de comando, pois ele terá acesso à sua conta. Se você não iniciou esta solicitação, você pode fechar esta página e ignorá-la. Nunca enviaremos este link por email ou qualquer outro meio.",
    "__stack-auto-translation-293": "Você já está conectado",
    "__stack-auto-translation-294": "Você não está atualmente conectado.",
    "__stack-auto-translation-295": "Você não pode remover seu último email de login",
    "__stack-auto-translation-296": "Você não pode revogar sua sessão atual",
    "__stack-auto-translation-297": "Seu email foi verificado!",
    "__stack-auto-translation-298": "Você ainda não concluiu a configuração da sua conta. Entre em contato com o suporte se acreditar que isso é um erro.",
    "__stack-auto-translation-299": "Seu E-mail",
    "__stack-auto-translation-3": "Configurações da Conta",
    "__stack-auto-translation-30": "Alterar plano",
    "__stack-auto-translation-300": "Seu link de verificação de e-mail expirou. Por favor, solicite um novo link de verificação nas configurações da sua conta.",
    "__stack-auto-translation-301": "Seu link mágico expirou. Por favor, solicite um novo link mágico se precisar fazer login.",
    "__stack-auto-translation-302": "Sua senha foi redefinida. Agora você pode entrar com sua nova senha.",
    "__stack-auto-translation-303": "Seu link de redefinição de senha expirou. Por favor, solicite um novo link de redefinição de senha na página de login.",
    "__stack-auto-translation-304": "Seu link de convite para a equipe expirou. Solicite um novo link de convite para a equipe",
    "__stack-auto-translation-31": "Alterar o nome de exibição da sua equipe",
    "__stack-auto-translation-32": "Escolher um plano",
    "__stack-auto-translation-33": "Escolha quais e-mails você deseja receber",
    "__stack-auto-translation-34": "Autorização de CLI Bem-sucedida",
    "__stack-auto-translation-35": "clique aqui",
    "__stack-auto-translation-36": "Clique no botão abaixo para reenviar o link de verificação.",
    "__stack-auto-translation-37": "Fechar",
    "__stack-auto-translation-38": "Concluir configuração",
    "__stack-auto-translation-39": "Conclua a configuração da sua conta",
    "__stack-auto-translation-4": "Planos ativos",
    "__stack-auto-translation-40": "Confirmar",
    "__stack-auto-translation-41": "Continuar",
    "__stack-auto-translation-42": "Copie para um local seguro. Você não poderá visualizá-la novamente.",
    "__stack-auto-translation-43": "Não foi possível cortar a imagem.",
    "__stack-auto-translation-44": "Criar",
    "__stack-auto-translation-45": "Criar uma nova conta",
    "__stack-auto-translation-46": "Criar uma equipe",
    "__stack-auto-translation-47": "Criar uma Equipe",
    "__stack-auto-translation-48": "Criar Chave de API",
    "__stack-auto-translation-49": "Pacote de créditos",
    "__stack-auto-translation-5": "Sessões Ativas",
    "__stack-auto-translation-50": "Sessão Atual",
    "__stack-auto-translation-51": "Equipe atual",
    "__stack-auto-translation-52": "Zona de perigo",
    "__stack-auto-translation-53": "Data",
    "__stack-auto-translation-54": "Excluir conta",
    "__stack-auto-translation-55": "Excluir Conta",
    "__stack-auto-translation-56": "Excluir Chave de acesso",
    "__stack-auto-translation-57": "Descrição",
    "__stack-auto-translation-58": "Descrição é obrigatória",
    "__stack-auto-translation-59": "Desativar",
    "__stack-auto-translation-6": "Adicionar",
    "__stack-auto-translation-60": "Desativar MFA",
    "__stack-auto-translation-61": "Desativar OTP",
    "__stack-auto-translation-62": "Nome de exibição",
    "__stack-auto-translation-63": "Deseja entrar?",
    "__stack-auto-translation-64": "Deseja verificar seu email?",
    "__stack-auto-translation-65": "Não tem uma conta?",
    "__stack-auto-translation-66": "Não precisa redefinir?",
    "__stack-auto-translation-67": "Rascunho",
    "__stack-auto-translation-68": "ex.: Desenvolvimento, Produção, CI/CD",
    "__stack-auto-translation-69": "Email",
    "__stack-auto-translation-7": "Adicione uma forma de pagamento antes de mudar de plano.",
    "__stack-auto-translation-70": "Email e Senha",
    "__stack-auto-translation-71": "E-mail já existe",
    "__stack-auto-translation-72": "E-mail é obrigatório",
    "__stack-auto-translation-73": "Gerenciamento de email não está disponível no modo de demonstração.",
    "__stack-auto-translation-74": "E-mail enviado!",
    "__stack-auto-translation-75": "E-mails",
    "__stack-auto-translation-76": "E-mails & Autenticação",
    "__stack-auto-translation-77": "Habilitar MFA",
    "__stack-auto-translation-78": "Habilitar OTP",
    "__stack-auto-translation-79": "Habilitar login via link mágico ou OTP enviado para seus e-mails de acesso.",
    "__stack-auto-translation-8": "Adicionar um e-mail",
    "__stack-auto-translation-80": "Encerre sua sessão atual",
    "__stack-auto-translation-81": "Insira um nome de exibição para sua nova equipe",
    "__stack-auto-translation-82": "Inserir email",
    "__stack-auto-translation-83": "Digite o código do seu e-mail",
    "__stack-auto-translation-84": "Digite o código de seis dígitos do seu aplicativo autenticador",
    "__stack-auto-translation-85": "Digite seu email",
    "__stack-auto-translation-86": "Link Mágico Expirado",
    "__stack-auto-translation-87": "Link de Redefinição de Senha Expirado",
    "__stack-auto-translation-88": "Link de Convite de Equipe Expirado",
    "__stack-auto-translation-89": "Link de Verificação Expirado",
    "__stack-auto-translation-9": "Adicionar nova chave de acesso",
    "__stack-auto-translation-90": "Expira",
    "__stack-auto-translation-91": "Expira em",
    "__stack-auto-translation-92": "Falha ao autorizar a aplicação CLI:",
    "__stack-auto-translation-93": "Falha ao conectar conta",
    "__stack-auto-translation-94": "Falha ao redefinir senha",
    "__stack-auto-translation-95": "Falha ao redefinir senha. Solicite um novo link de redefinição de senha",
    "__stack-auto-translation-96": "Esqueceu a senha?",
    "__stack-auto-translation-97": "Ir para início",
    "__stack-auto-translation-98": "Ir para início",
    "__stack-auto-translation-99": "Aqui está a sua chave de API."
  } as const)),
  "pt-PT": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "Uma aplicação de linha de comandos está a solicitar acesso à sua conta. Clique no botão abaixo para autorizá-la.",
    "__stack-auto-translation-10": "Adicione o seu endereço de email",
    "__stack-auto-translation-100": "Compreendo que não poderei visualizar esta chave novamente.",
    "__stack-auto-translation-101": "Se o utilizador com este endereço de e-mail existir, foi enviado um e-mail para a sua caixa de entrada. Certifique-se de verificar a sua pasta de spam.",
    "__stack-auto-translation-102": "Se não for redirecionado automaticamente, ",
    "__stack-auto-translation-103": "Ignorar",
    "__stack-auto-translation-104": "Personificação",
    "__stack-auto-translation-105": "Código incorreto. Por favor, tente novamente.",
    "__stack-auto-translation-106": "Palavra-passe incorreta",
    "__stack-auto-translation-107": "Código inválido",
    "__stack-auto-translation-108": "Imagem inválida",
    "__stack-auto-translation-109": "Link Mágico Inválido",
    "__stack-auto-translation-11": "Já tem uma conta?",
    "__stack-auto-translation-110": "Link Inválido de Redefinição de Palavra-passe",
    "__stack-auto-translation-111": "Link de Convite de Equipa Inválido",
    "__stack-auto-translation-112": "Código TOTP inválido",
    "__stack-auto-translation-113": "Link de Verificação Inválido",
    "__stack-auto-translation-114": "Convidar um utilizador para a sua equipa através de e-mail",
    "__stack-auto-translation-115": "Convidar membro",
    "__stack-auto-translation-116": "Convidar Utilizador",
    "__stack-auto-translation-117": "Fatura",
    "__stack-auto-translation-118": "Faturas",
    "__stack-auto-translation-119": "Endereço IP",
    "__stack-auto-translation-12": "Valor",
    "__stack-auto-translation-120": "Juntar",
    "__stack-auto-translation-121": "Última utilização",
    "__stack-auto-translation-122": "Sair",
    "__stack-auto-translation-123": "Sair da equipa",
    "__stack-auto-translation-124": "Sair da Equipa",
    "__stack-auto-translation-125": "abandonar esta equipa e remover o seu perfil de equipa",
    "__stack-auto-translation-126": "Localização",
    "__stack-auto-translation-127": "Link Mágico Já Utilizado",
    "__stack-auto-translation-128": "Gerir o método de pagamento predefinido para subscrições e faturas.",
    "__stack-auto-translation-129": "Membros",
    "__stack-auto-translation-13": "Ocorreu um erro desconhecido",
    "__stack-auto-translation-130": "A gestão de MFA não está disponível no modo de demonstração.",
    "__stack-auto-translation-131": "Informações de verificação em falta",
    "__stack-auto-translation-132": "Autenticação de Múltiplos Fatores",
    "__stack-auto-translation-133": "Autenticação de Múltiplos Fatores",
    "__stack-auto-translation-134": "A autenticação multifator está atualmente desativada.",
    "__stack-auto-translation-135": "A autenticação multifator está atualmente ativada.",
    "__stack-auto-translation-136": "O Meu Perfil",
    "__stack-auto-translation-137": "Nome",
    "__stack-auto-translation-138": "Nunca",
    "__stack-auto-translation-139": "Não é permitido registar novas contas",
    "__stack-auto-translation-14": "Chave de API",
    "__stack-auto-translation-140": "Nova palavra-passe",
    "__stack-auto-translation-141": "Nova Palavra-passe",
    "__stack-auto-translation-142": "Não foram encontradas sessões ativas",
    "__stack-auto-translation-143": "Nenhum método de autenticação ativado.",
    "__stack-auto-translation-144": "Sem método de pagamento padrão",
    "__stack-auto-translation-145": "Sem nome de exibição definido",
    "__stack-auto-translation-146": "Não existem outros planos disponíveis para esta subscrição.",
    "__stack-auto-translation-147": "Não há convites pendentes",
    "__stack-auto-translation-148": "Sem equipa",
    "__stack-auto-translation-149": "Ainda sem equipas",
    "__stack-auto-translation-15": "Chaves de API",
    "__stack-auto-translation-150": "Não tem sessão iniciada",
    "__stack-auto-translation-151": "Notificações",
    "__stack-auto-translation-152": "Acesso ao provedor OAuth negado",
    "__stack-auto-translation-153": "Palavra-passe antiga",
    "__stack-auto-translation-154": "Palavra-passe de Utilização Única",
    "__stack-auto-translation-155": "Compra única",
    "__stack-auto-translation-156": "Aberta",
    "__stack-auto-translation-157": "Ou continuar com",
    "__stack-auto-translation-158": "Outra Sessão",
    "__stack-auto-translation-159": "Outras equipas",
    "__stack-auto-translation-16": "As chaves de API concedem acesso programático à sua conta.",
    "__stack-auto-translation-160": "A gestão de OTP não está disponível no modo de demonstração.",
    "__stack-auto-translation-161": "Autenticação OTP",
    "__stack-auto-translation-162": "A autenticação OTP está ativada e não pode ser desativada, pois é atualmente o único método de autenticação",
    "__stack-auto-translation-163": "O início de sessão por OTP/link mágico está atualmente ativado.",
    "__stack-auto-translation-164": "Convites pendentes",
    "__stack-auto-translation-165": "Substituir o seu nome de exibição nesta equipa",
    "__stack-auto-translation-166": "Pago",
    "__stack-auto-translation-167": "Chave de acesso",
    "__stack-auto-translation-168": "A gestão de chaves de acesso não está disponível no modo de demonstração.",
    "__stack-auto-translation-169": "Chave de acesso registada",
    "__stack-auto-translation-17": "As chaves de API concedem acesso programático à sua equipa.",
    "__stack-auto-translation-170": "O início de sessão por chave de acesso está ativo e não pode ser desativado pois é atualmente o único método de autenticação",
    "__stack-auto-translation-171": "Palavra-passe",
    "__stack-auto-translation-172": "A gestão de palavra-passe não está disponível no modo de demonstração.",
    "__stack-auto-translation-173": "Palavra-passe redefinida com sucesso!",
    "__stack-auto-translation-174": "As palavras-passe não coincidem",
    "__stack-auto-translation-175": "Método de pagamento",
    "__stack-auto-translation-176": "Pagamentos",
    "__stack-auto-translation-177": "Remover permanentemente a sua conta e todos os dados associados",
    "__stack-auto-translation-178": "Pessoal",
    "__stack-auto-translation-179": "Por favor, adicione um endereço de email para concluir a configuração da sua conta. Enviaremos um email de verificação.",
    "__stack-auto-translation-18": "Tem a certeza que pretende eliminar a sua conta? Esta ação é IRREVERSÍVEL e irá apagar TODOS os dados associados.",
    "__stack-auto-translation-180": "Por favor, verifique se tem o link correto. Se continuar a ter problemas, entre em contacto com o suporte.",
    "__stack-auto-translation-181": "Por favor, verifique a sua caixa de email",
    "__stack-auto-translation-182": "Por favor, conclua a configuração da sua conta antes de se juntar a equipas.",
    "__stack-auto-translation-183": "Por favor, verifique novamente se tem o link correto para redefinição da palavra-passe.",
    "__stack-auto-translation-184": "Verifique novamente se possui o link de convite para a equipa correto.",
    "__stack-auto-translation-185": "Por favor, insira um nome para a equipa",
    "__stack-auto-translation-186": "Por favor, introduza um email válido",
    "__stack-auto-translation-187": "Introduza um endereço de email válido",
    "__stack-auto-translation-188": "Por favor, introduza um endereço de email",
    "__stack-auto-translation-189": "Introduza o seu email",
    "__stack-auto-translation-19": "Tem certeza de que deseja desativar a autenticação OTP? Já não poderá iniciar sessão apenas com e-mails.",
    "__stack-auto-translation-190": "Por favor, insira a sua palavra-passe antiga",
    "__stack-auto-translation-191": "Por favor, introduza a sua palavra-passe",
    "__stack-auto-translation-192": "Por favor, repita a sua palavra-passe",
    "__stack-auto-translation-193": "Tente novamente e, se o problema persistir, contacte o suporte.",
    "__stack-auto-translation-194": "Por favor, verifique o seu endereço de email ",
    "__stack-auto-translation-195": "Por favor, verifique o seu email primeiro",
    "__stack-auto-translation-196": "Principal",
    "__stack-auto-translation-197": "Pro",
    "__stack-auto-translation-198": "Imagem de perfil",
    "__stack-auto-translation-199": "Registar uma chave de acesso",
    "__stack-auto-translation-2": "Definições da conta",
    "__stack-auto-translation-20": "Tem a certeza de que pretende desativar o início de sessão por chave de acesso? Não poderá mais iniciar sessão com a sua chave de acesso.",
    "__stack-auto-translation-200": "Remover",
    "__stack-auto-translation-201": "Renova a",
    "__stack-auto-translation-202": "Repetir nova palavra-passe",
    "__stack-auto-translation-203": "Repetir Nova Palavra-passe",
    "__stack-auto-translation-204": "Repita a palavra-passe",
    "__stack-auto-translation-205": "Reenviar email de verificação",
    "__stack-auto-translation-206": "Redefinir Palavra-passe",
    "__stack-auto-translation-207": "Repor a Sua Palavra-passe",
    "__stack-auto-translation-208": "Rever faturas e recibos anteriores.",
    "__stack-auto-translation-209": "Revogar",
    "__stack-auto-translation-21": "Tem a certeza de que deseja sair da equipa?",
    "__stack-auto-translation-210": "Revogar Todas as Outras Sessões",
    "__stack-auto-translation-211": "Guardar",
    "__stack-auto-translation-212": "Faça scan deste código QR com a sua aplicação de autenticação:",
    "__stack-auto-translation-213": "Chave de API Secreta",
    "__stack-auto-translation-214": "Selecione um novo plano da mesma linha de produtos.",
    "__stack-auto-translation-215": "Enviar e-mail",
    "__stack-auto-translation-216": "Enviar Email",
    "__stack-auto-translation-217": "Enviar email de verificação",
    "__stack-auto-translation-218": "Sessão",
    "__stack-auto-translation-219": "Defina uma palavra-passe para a sua conta",
    "__stack-auto-translation-22": "Autorização Falhou",
    "__stack-auto-translation-220": "Definir como principal",
    "__stack-auto-translation-221": "Definir palavra-passe",
    "__stack-auto-translation-222": "Definir Palavra-passe",
    "__stack-auto-translation-223": "Definições",
    "__stack-auto-translation-224": "Iniciar sessão",
    "__stack-auto-translation-225": "Iniciar Sessão",
    "__stack-auto-translation-226": "Iniciar sessão novamente",
    "__stack-auto-translation-227": "Inicie sessão ou crie uma conta para se juntar à equipa.",
    "__stack-auto-translation-228": "Iniciar sessão na sua conta",
    "__stack-auto-translation-229": "Iniciar sessão com Chave de acesso",
    "__stack-auto-translation-23": "Autorizar",
    "__stack-auto-translation-230": "Iniciar sessão com {provider}",
    "__stack-auto-translation-231": "Terminar sessão",
    "__stack-auto-translation-232": "Inscrever-se",
    "__stack-auto-translation-233": "Inscrever-se",
    "__stack-auto-translation-234": "As inscrições para novos utilizadores não estão ativadas de momento.",
    "__stack-auto-translation-235": "Registar com chave de acesso",
    "__stack-auto-translation-236": "Registar-se com {provider}",
    "__stack-auto-translation-237": "Autenticação bem-sucedida!",
    "__stack-auto-translation-238": "Sessão iniciada {time}",
    "__stack-auto-translation-239": "Algo correu mal durante o processamento do callback OAuth:",
    "__stack-auto-translation-24": "Autorizar Aplicação CLI",
    "__stack-auto-translation-240": "Estado",
    "__stack-auto-translation-241": "Parar de utilizar para início de sessão",
    "__stack-auto-translation-242": "Subscrição",
    "__stack-auto-translation-243": "Mudar plano",
    "__stack-auto-translation-244": "A criação de equipas está desativada no modo de demonstração",
    "__stack-auto-translation-245": "A criação de equipas não está ativada",
    "__stack-auto-translation-246": "Nome de exibição da equipa",
    "__stack-auto-translation-247": "Convite para equipa",
    "__stack-auto-translation-248": "Imagem de perfil da equipa",
    "__stack-auto-translation-249": "Nome de utilizador da equipa",
    "__stack-auto-translation-25": "A autorizar...",
    "__stack-auto-translation-250": "Equipas",
    "__stack-auto-translation-251": "A aplicação CLI foi autorizada com sucesso. Pode fechar esta janela e voltar à linha de comandos.",
    "__stack-auto-translation-252": "O link mágico já foi utilizado. O link só pode ser usado uma vez. Por favor, solicite um novo link mágico se precisar de iniciar sessão novamente.",
    "__stack-auto-translation-253": "A operação de início de sessão foi cancelada ou negada. Por favor, tente novamente.",
    "__stack-auto-translation-254": "O utilizador já está conectado a outra conta OAuth. Terá selecionado a conta errada na página do provedor OAuth?",
    "__stack-auto-translation-255": "Em seguida, introduza o seu código MFA de seis dígitos:",
    "__stack-auto-translation-256": "Estes são os dispositivos onde está atualmente autenticado. Pode revogar o acesso para terminar uma sessão.",
    "__stack-auto-translation-257": "Esta conta já está associada a outro utilizador. Por favor, associe uma conta diferente.",
    "__stack-auto-translation-258": "Este email já é utilizado para iniciar sessão por outro utilizador.",
    "__stack-auto-translation-259": "Este é um nome de exibição e não é utilizado para autenticação",
    "__stack-auto-translation-26": "Cancelar",
    "__stack-auto-translation-260": "Isto é provavelmente um erro no Stack. Por favor, reporte-o.",
    "__stack-auto-translation-261": "Este link de reposição de palavra-passe já foi utilizado. Se precisar de repor a sua palavra-passe novamente, solicite um novo link de reposição na página de início de sessão.",
    "__stack-auto-translation-262": "Este link de convite para a equipa já foi utilizado.",
    "__stack-auto-translation-263": "Para ativar a autenticação OTP, adicione um email de acesso verificado.",
    "__stack-auto-translation-264": "Para ativar o início de sessão com chave de acesso, adicione um email de início de sessão verificado.",
    "__stack-auto-translation-265": "Para definir uma palavra-passe, adicione um email de acesso.",
    "__stack-auto-translation-266": "Alternar tema",
    "__stack-auto-translation-267": "Código QR de autenticação multifator TOTP",
    "__stack-auto-translation-268": "Tentar Novamente",
    "__stack-auto-translation-269": "Indisponível",
    "__stack-auto-translation-27": "Cancelar subscrição",
    "__stack-auto-translation-270": "Incobrável",
    "__stack-auto-translation-271": "Desconhecido",
    "__stack-auto-translation-272": "Não verificado",
    "__stack-auto-translation-273": "Atualizar palavra-passe",
    "__stack-auto-translation-274": "Atualizar Palavra-passe",
    "__stack-auto-translation-275": "Atualizar método de pagamento",
    "__stack-auto-translation-276": "Atualize a sua palavra-passe",
    "__stack-auto-translation-277": "Carregar uma imagem para a sua equipa",
    "__stack-auto-translation-278": "Carregue a sua própria imagem como avatar",
    "__stack-auto-translation-279": "Usar para iniciar sessão",
    "__stack-auto-translation-28": "O cancelamento irá parar as renovações futuras desta subscrição.",
    "__stack-auto-translation-280": "Utilizado para iniciar sessão",
    "__stack-auto-translation-281": "Link de Redefinição de Palavra-passe Utilizado",
    "__stack-auto-translation-282": "Link de Convite para Equipa Utilizado",
    "__stack-auto-translation-283": "Utilizador",
    "__stack-auto-translation-284": "Nome de utilizador",
    "__stack-auto-translation-285": "Falha na verificação",
    "__stack-auto-translation-286": "Verificado! A redirecionar...",
    "__stack-auto-translation-287": "Verificar",
    "__stack-auto-translation-288": "A verificar...",
    "__stack-auto-translation-289": "Ver",
    "__stack-auto-translation-29": "alterar",
    "__stack-auto-translation-290": "Ver os seus planos ativos e compras.",
    "__stack-auto-translation-291": "Anulada",
    "__stack-auto-translation-292": "AVISO: Certifique-se de que confia na aplicação de linha de comandos, pois esta terá acesso à sua conta. Se não iniciou este pedido, pode fechar esta página e ignorá-lo. Nunca enviaremos este link por email ou qualquer outro meio.",
    "__stack-auto-translation-293": "Já está autenticado",
    "__stack-auto-translation-294": "Não tem sessão iniciada de momento.",
    "__stack-auto-translation-295": "Não é possível remover o seu último email de início de sessão",
    "__stack-auto-translation-296": "Não pode revogar a sua sessão atual",
    "__stack-auto-translation-297": "O seu email foi verificado!",
    "__stack-auto-translation-298": "Ainda não concluiu a configuração da sua conta. Por favor, contacte o suporte se acreditar que isto é um erro.",
    "__stack-auto-translation-299": "O seu email",
    "__stack-auto-translation-3": "Definições da Conta",
    "__stack-auto-translation-30": "Alterar plano",
    "__stack-auto-translation-300": "O seu link de verificação de email expirou. Por favor, solicite um novo link de verificação nas definições da sua conta.",
    "__stack-auto-translation-301": "O seu link mágico expirou. Por favor, solicite um novo link mágico se precisar de iniciar sessão.",
    "__stack-auto-translation-302": "A sua palavra-passe foi redefinida. Agora pode iniciar sessão com a sua nova palavra-passe.",
    "__stack-auto-translation-303": "O seu link de redefinição de palavra-passe expirou. Por favor, solicite um novo link na página de início de sessão.",
    "__stack-auto-translation-304": "O seu link de convite para a equipa expirou. Por favor, solicite um novo link de convite",
    "__stack-auto-translation-31": "Alterar o nome de apresentação da sua equipa",
    "__stack-auto-translation-32": "Escolher um plano",
    "__stack-auto-translation-33": "Escolha quais e-mails deseja receber",
    "__stack-auto-translation-34": "Autorização da CLI bem-sucedida",
    "__stack-auto-translation-35": "clique aqui",
    "__stack-auto-translation-36": "Clique no botão abaixo para reenviar o link de verificação.",
    "__stack-auto-translation-37": "Fechar",
    "__stack-auto-translation-38": "Concluir configuração",
    "__stack-auto-translation-39": "Conclua a configuração da sua conta",
    "__stack-auto-translation-4": "Planos ativos",
    "__stack-auto-translation-40": "Confirmar",
    "__stack-auto-translation-41": "Continuar",
    "__stack-auto-translation-42": "Copie-a para um local seguro. Não poderá visualizá-la novamente.",
    "__stack-auto-translation-43": "Não foi possível cortar a imagem.",
    "__stack-auto-translation-44": "Criar",
    "__stack-auto-translation-45": "Criar uma nova conta",
    "__stack-auto-translation-46": "Criar uma equipa",
    "__stack-auto-translation-47": "Criar uma Equipa",
    "__stack-auto-translation-48": "Criar Chave API",
    "__stack-auto-translation-49": "Pacote de créditos",
    "__stack-auto-translation-5": "Sessões Ativas",
    "__stack-auto-translation-50": "Sessão Atual",
    "__stack-auto-translation-51": "Equipa atual",
    "__stack-auto-translation-52": "Zona de perigo",
    "__stack-auto-translation-53": "Data",
    "__stack-auto-translation-54": "Eliminar conta",
    "__stack-auto-translation-55": "Eliminar Conta",
    "__stack-auto-translation-56": "Eliminar Chave de Acesso",
    "__stack-auto-translation-57": "Descrição",
    "__stack-auto-translation-58": "A descrição é obrigatória",
    "__stack-auto-translation-59": "Desativar",
    "__stack-auto-translation-6": "Adicionar",
    "__stack-auto-translation-60": "Desativar MFA",
    "__stack-auto-translation-61": "Desativar OTP",
    "__stack-auto-translation-62": "Nome de exibição",
    "__stack-auto-translation-63": "Quer iniciar sessão?",
    "__stack-auto-translation-64": "Pretende verificar o seu email?",
    "__stack-auto-translation-65": "Não tem uma conta?",
    "__stack-auto-translation-66": "Não precisa redefinir?",
    "__stack-auto-translation-67": "Rascunho",
    "__stack-auto-translation-68": "ex.: Desenvolvimento, Produção, CI/CD",
    "__stack-auto-translation-69": "Email",
    "__stack-auto-translation-7": "Adicione um método de pagamento antes de mudar de plano.",
    "__stack-auto-translation-70": "Email e Palavra-passe",
    "__stack-auto-translation-71": "O email já existe",
    "__stack-auto-translation-72": "O email é obrigatório",
    "__stack-auto-translation-73": "A gestão de emails não está disponível no modo de demonstração.",
    "__stack-auto-translation-74": "Email enviado!",
    "__stack-auto-translation-75": "E-mails",
    "__stack-auto-translation-76": "E-mails e autenticação",
    "__stack-auto-translation-77": "Ativar MFA",
    "__stack-auto-translation-78": "Ativar OTP",
    "__stack-auto-translation-79": "Ativar autenticação via link mágico ou OTP enviado para os seus e-mails de início de sessão.",
    "__stack-auto-translation-8": "Adicionar um email",
    "__stack-auto-translation-80": "Terminar a sua sessão atual",
    "__stack-auto-translation-81": "Insira um nome de exibição para a sua nova equipa",
    "__stack-auto-translation-82": "Introduza o email",
    "__stack-auto-translation-83": "Insira o código do seu email",
    "__stack-auto-translation-84": "Introduza o código de seis dígitos da sua aplicação de autenticação",
    "__stack-auto-translation-85": "Insira o seu email",
    "__stack-auto-translation-86": "Link Mágica Expirada",
    "__stack-auto-translation-87": "Link de Redefinição de Palavra-passe Expirado",
    "__stack-auto-translation-88": "Link de Convite para Equipa Expirado",
    "__stack-auto-translation-89": "Link de Verificação Expirado",
    "__stack-auto-translation-9": "Adicionar nova chave de acesso",
    "__stack-auto-translation-90": "Expira",
    "__stack-auto-translation-91": "Expira Em",
    "__stack-auto-translation-92": "Falha ao autorizar a aplicação CLI:",
    "__stack-auto-translation-93": "Falha ao conectar conta",
    "__stack-auto-translation-94": "Falha ao redefinir a palavra-passe",
    "__stack-auto-translation-95": "Falha ao redefinir a palavra-passe. Por favor, solicite um novo link de redefinição",
    "__stack-auto-translation-96": "Esqueceu-se da palavra-passe?",
    "__stack-auto-translation-97": "Ir para início",
    "__stack-auto-translation-98": "Ir para início",
    "__stack-auto-translation-99": "Aqui está a sua chave API."
  } as const)),
  "zh-CN": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "命令行应用程序正在请求访问您的帐户。点击下方按钮以授权。",
    "__stack-auto-translation-10": "添加您的邮箱地址",
    "__stack-auto-translation-100": "我理解我将无法再次查看此密钥。",
    "__stack-auto-translation-101": "如果存在使用此电子邮件地址的用户，一封电子邮件已发送到您的收件箱。请务必检查您的垃圾邮件文件夹。",
    "__stack-auto-translation-102": "如果您没有被自动重定向，",
    "__stack-auto-translation-103": "忽略",
    "__stack-auto-translation-104": "模拟身份",
    "__stack-auto-translation-105": "代码不正确。请重试。",
    "__stack-auto-translation-106": "密码不正确",
    "__stack-auto-translation-107": "无效代码",
    "__stack-auto-translation-108": "无效图片",
    "__stack-auto-translation-109": "无效的魔法链接",
    "__stack-auto-translation-11": "已有账户？",
    "__stack-auto-translation-110": "无效的密码重置链接",
    "__stack-auto-translation-111": "无效的团队邀请链接",
    "__stack-auto-translation-112": "无效的 TOTP 代码",
    "__stack-auto-translation-113": "无效的验证链接",
    "__stack-auto-translation-114": "通过电子邮件邀请用户加入您的团队",
    "__stack-auto-translation-115": "邀请成员",
    "__stack-auto-translation-116": "邀请用户",
    "__stack-auto-translation-117": "发票",
    "__stack-auto-translation-118": "发票",
    "__stack-auto-translation-119": "IP 地址",
    "__stack-auto-translation-12": "金额",
    "__stack-auto-translation-120": "加入",
    "__stack-auto-translation-121": "上次使用",
    "__stack-auto-translation-122": "离开",
    "__stack-auto-translation-123": "退出团队",
    "__stack-auto-translation-124": "离开团队",
    "__stack-auto-translation-125": "离开此团队并删除您的团队资料",
    "__stack-auto-translation-126": "位置",
    "__stack-auto-translation-127": "魔法链接已使用",
    "__stack-auto-translation-128": "管理用于订阅和发票的默认付款方式。",
    "__stack-auto-translation-129": "成员",
    "__stack-auto-translation-13": "发生未知错误",
    "__stack-auto-translation-130": "演示模式下无法使用多因素认证管理。",
    "__stack-auto-translation-131": "缺少验证信息",
    "__stack-auto-translation-132": "多重身份认证",
    "__stack-auto-translation-133": "多重身份认证",
    "__stack-auto-translation-134": "多重身份认证目前已禁用。",
    "__stack-auto-translation-135": "多重身份验证目前已启用。",
    "__stack-auto-translation-136": "我的个人资料",
    "__stack-auto-translation-137": "姓名",
    "__stack-auto-translation-138": "从未",
    "__stack-auto-translation-139": "不允许注册新账户",
    "__stack-auto-translation-14": "API 密钥",
    "__stack-auto-translation-140": "新密码",
    "__stack-auto-translation-141": "新密码",
    "__stack-auto-translation-142": "未找到活动会话",
    "__stack-auto-translation-143": "未启用任何身份验证方法。",
    "__stack-auto-translation-144": "无默认支付方式",
    "__stack-auto-translation-145": "未设置显示名称",
    "__stack-auto-translation-146": "此订阅暂无其他可用套餐。",
    "__stack-auto-translation-147": "没有待处理邀请",
    "__stack-auto-translation-148": "无团队",
    "__stack-auto-translation-149": "尚无团队",
    "__stack-auto-translation-15": "API 密钥",
    "__stack-auto-translation-150": "未登录",
    "__stack-auto-translation-151": "通知",
    "__stack-auto-translation-152": "OAuth 提供商访问被拒绝",
    "__stack-auto-translation-153": "旧密码",
    "__stack-auto-translation-154": "一次性密码",
    "__stack-auto-translation-155": "一次性购买",
    "__stack-auto-translation-156": "待付款",
    "__stack-auto-translation-157": "或继续使用",
    "__stack-auto-translation-158": "其他会话",
    "__stack-auto-translation-159": "其他团队",
    "__stack-auto-translation-16": "API 密钥授予对您账户的程序化访问权限。",
    "__stack-auto-translation-160": "演示模式下无法管理一次性密码。",
    "__stack-auto-translation-161": "OTP 登录",
    "__stack-auto-translation-162": "已启用 OTP 登录，且无法禁用，因为它目前是唯一的登录方式",
    "__stack-auto-translation-163": "OTP/魔法链接登录目前已启用。",
    "__stack-auto-translation-164": "待处理邀请",
    "__stack-auto-translation-165": "在这个团队中覆盖你的用户显示名称",
    "__stack-auto-translation-166": "已支付",
    "__stack-auto-translation-167": "密钥",
    "__stack-auto-translation-168": "密钥管理在演示模式下不可用。",
    "__stack-auto-translation-169": "密钥已注册",
    "__stack-auto-translation-17": "API 密钥授予对您团队的编程访问权限。",
    "__stack-auto-translation-170": "密钥登录已启用，且无法禁用，因为它目前是唯一的登录方式",
    "__stack-auto-translation-171": "密码",
    "__stack-auto-translation-172": "演示模式下无法管理密码。",
    "__stack-auto-translation-173": "密码重置成功！",
    "__stack-auto-translation-174": "密码不匹配",
    "__stack-auto-translation-175": "支付方式",
    "__stack-auto-translation-176": "支付",
    "__stack-auto-translation-177": "永久删除您的账户和所有相关数据",
    "__stack-auto-translation-178": "个人",
    "__stack-auto-translation-179": "请添加电子邮件地址以完成账户设置。我们将向您发送验证邮件。",
    "__stack-auto-translation-18": "您确定要删除您的账户吗？此操作不可逆，将删除所有相关数据。",
    "__stack-auto-translation-180": "请检查您是否有正确的链接。如果继续遇到问题，请联系支持人员。",
    "__stack-auto-translation-181": "请查看您的邮箱收件箱",
    "__stack-auto-translation-182": "请先完成账户设置，然后再加入团队。",
    "__stack-auto-translation-183": "请再次确认您是否有正确的密码重置链接。",
    "__stack-auto-translation-184": "请再次确认您是否拥有正确的团队邀请链接。",
    "__stack-auto-translation-185": "请输入团队名称",
    "__stack-auto-translation-186": "请输入有效的邮箱",
    "__stack-auto-translation-187": "请输入有效的电子邮件地址",
    "__stack-auto-translation-188": "请输入电子邮件地址",
    "__stack-auto-translation-189": "请输入您的邮箱",
    "__stack-auto-translation-19": "您确定要禁用 OTP 登录吗？禁用后，您将无法仅使用电子邮箱登录。",
    "__stack-auto-translation-190": "请输入您的旧密码",
    "__stack-auto-translation-191": "请输入您的密码",
    "__stack-auto-translation-192": "请重复输入密码",
    "__stack-auto-translation-193": "请重试，如果问题仍然存在，请联系客服。",
    "__stack-auto-translation-194": "请验证您的邮箱地址",
    "__stack-auto-translation-195": "请先验证您的电子邮箱",
    "__stack-auto-translation-196": "主要",
    "__stack-auto-translation-197": "专业版",
    "__stack-auto-translation-198": "头像",
    "__stack-auto-translation-199": "注册密钥",
    "__stack-auto-translation-2": "账户设置",
    "__stack-auto-translation-20": "您确定要禁用密钥登录吗？禁用后，您将无法再使用密钥登录。",
    "__stack-auto-translation-200": "删除",
    "__stack-auto-translation-201": "续订日期",
    "__stack-auto-translation-202": "重复新密码",
    "__stack-auto-translation-203": "重复新密码",
    "__stack-auto-translation-204": "重复密码",
    "__stack-auto-translation-205": "重新发送验证邮件",
    "__stack-auto-translation-206": "重置密码",
    "__stack-auto-translation-207": "重置您的密码",
    "__stack-auto-translation-208": "查看历史发票和收据。",
    "__stack-auto-translation-209": "撤销",
    "__stack-auto-translation-21": "您确定要离开团队吗？",
    "__stack-auto-translation-210": "撤销所有其他会话",
    "__stack-auto-translation-211": "保存",
    "__stack-auto-translation-212": "使用您的身份验证器应用扫描此二维码：",
    "__stack-auto-translation-213": "密钥 API 密钥",
    "__stack-auto-translation-214": "从同一产品线中选择新的套餐。",
    "__stack-auto-translation-215": "发送邮件",
    "__stack-auto-translation-216": "发送邮件",
    "__stack-auto-translation-217": "发送验证邮件",
    "__stack-auto-translation-218": "会话",
    "__stack-auto-translation-219": "为您的账户设置密码",
    "__stack-auto-translation-22": "授权失败",
    "__stack-auto-translation-220": "设置为主要",
    "__stack-auto-translation-221": "设置密码",
    "__stack-auto-translation-222": "设置密码",
    "__stack-auto-translation-223": "设置",
    "__stack-auto-translation-224": "登录",
    "__stack-auto-translation-225": "登录",
    "__stack-auto-translation-226": "再次登录",
    "__stack-auto-translation-227": "登录或创建账户以加入团队。",
    "__stack-auto-translation-228": "登录您的帐户",
    "__stack-auto-translation-229": "使用密钥登录",
    "__stack-auto-translation-23": "授权",
    "__stack-auto-translation-230": "使用{provider}登录",
    "__stack-auto-translation-231": "退出登录",
    "__stack-auto-translation-232": "注册",
    "__stack-auto-translation-233": "注册",
    "__stack-auto-translation-234": "目前不允许新用户注册。",
    "__stack-auto-translation-235": "使用通行密钥注册",
    "__stack-auto-translation-236": "用 {provider} 注册",
    "__stack-auto-translation-237": "登录成功！",
    "__stack-auto-translation-238": "登录于 {time}",
    "__stack-auto-translation-239": "处理 OAuth 回调时出现错误：",
    "__stack-auto-translation-24": "授权命令行应用程序",
    "__stack-auto-translation-240": "状态",
    "__stack-auto-translation-241": "停止使用登录",
    "__stack-auto-translation-242": "订阅",
    "__stack-auto-translation-243": "切换套餐",
    "__stack-auto-translation-244": "演示模式下已禁用团队创建",
    "__stack-auto-translation-245": "团队创建未启用",
    "__stack-auto-translation-246": "团队显示名称",
    "__stack-auto-translation-247": "团队邀请",
    "__stack-auto-translation-248": "团队头像",
    "__stack-auto-translation-249": "团队用户名",
    "__stack-auto-translation-25": "正在授权...",
    "__stack-auto-translation-250": "团队",
    "__stack-auto-translation-251": "CLI 应用已成功授权。您可以关闭此窗口并返回命令行。",
    "__stack-auto-translation-252": "魔法链接已被使用。该链接只能使用一次。如果需要再次登录，请重新申请一个新的魔法链接。",
    "__stack-auto-translation-253": "登录操作已被取消或拒绝。请重试。",
    "__stack-auto-translation-254": "用户已连接到另一个 OAuth 账户。您是否在 OAuth 提供商页面上选择了错误的账户？",
    "__stack-auto-translation-255": "然后，输入您的六位数 MFA 码：",
    "__stack-auto-translation-256": "这些是您当前已登录的设备。您可以撤销访问权限以结束会话。",
    "__stack-auto-translation-257": "此帐户已与另一用户关联。请连接其他帐户。",
    "__stack-auto-translation-258": "此电子邮箱已被另一用户用于登录。",
    "__stack-auto-translation-259": "这是显示名称，不用于身份验证",
    "__stack-auto-translation-26": "取消",
    "__stack-auto-translation-260": "这很可能是 Stack 中的错误。请报告此问题。",
    "__stack-auto-translation-261": "此密码重置链接已被使用。如果您需要再次重置密码，请从登录页面请求新的密码重置链接。",
    "__stack-auto-translation-262": "此团队邀请链接已被使用。",
    "__stack-auto-translation-263": "要启用 OTP 登录，请添加已验证的登录邮箱。",
    "__stack-auto-translation-264": "要启用通行密钥登录，请添加已验证的登录邮箱。",
    "__stack-auto-translation-265": "要设置密码，请先添加登录邮箱。",
    "__stack-auto-translation-266": "切换主题",
    "__stack-auto-translation-267": "TOTP 多重身份认证二维码",
    "__stack-auto-translation-268": "重试",
    "__stack-auto-translation-269": "不可用",
    "__stack-auto-translation-27": "取消订阅",
    "__stack-auto-translation-270": "无法收款",
    "__stack-auto-translation-271": "未知",
    "__stack-auto-translation-272": "未验证",
    "__stack-auto-translation-273": "更新密码",
    "__stack-auto-translation-274": "更新密码",
    "__stack-auto-translation-275": "更新付款方式",
    "__stack-auto-translation-276": "更新您的密码",
    "__stack-auto-translation-277": "为团队上传图片",
    "__stack-auto-translation-278": "上传您自己的图像作为头像",
    "__stack-auto-translation-279": "用于登录",
    "__stack-auto-translation-28": "取消后将停止此订阅的后续续费。",
    "__stack-auto-translation-280": "用于登录",
    "__stack-auto-translation-281": "已使用的密码重置链接",
    "__stack-auto-translation-282": "已使用的团队邀请链接",
    "__stack-auto-translation-283": "用户",
    "__stack-auto-translation-284": "用户名",
    "__stack-auto-translation-285": "验证失败",
    "__stack-auto-translation-286": "已验证！正在重定向...",
    "__stack-auto-translation-287": "验证",
    "__stack-auto-translation-288": "验证中...",
    "__stack-auto-translation-289": "查看",
    "__stack-auto-translation-29": "更改",
    "__stack-auto-translation-290": "查看您的活动套餐和购买记录。",
    "__stack-auto-translation-291": "作废",
    "__stack-auto-translation-292": "警告：请确保您信任该命令行应用程序，因为它将获得您账户的访问权限。如果您未发起此请求，可以关闭此页面并忽略它。我们绝不会通过电子邮箱或其他方式向您发送此链接。",
    "__stack-auto-translation-293": "您已经登录",
    "__stack-auto-translation-294": "您当前未登录。",
    "__stack-auto-translation-295": "你不能删除最后一个用于登录的电子邮箱",
    "__stack-auto-translation-296": "你不能撤销当前会话",
    "__stack-auto-translation-297": "您的邮箱已验证！",
    "__stack-auto-translation-298": "您尚未完成账户设置。如果您认为这是错误，请联系支持团队。",
    "__stack-auto-translation-299": "您的邮箱",
    "__stack-auto-translation-3": "账户设置",
    "__stack-auto-translation-30": "更改套餐",
    "__stack-auto-translation-300": "您的邮箱验证链接已过期。请从您的账户设置中重新请求一个新的验证链接。",
    "__stack-auto-translation-301": "您的魔法链接已过期。如果您需要登录，请申请一个新的魔法链接。",
    "__stack-auto-translation-302": "您的密码已重置。您现在可以使用新密码登录。",
    "__stack-auto-translation-303": "您的密码重置链接已过期。请从登录页面申请新的密码重置链接。",
    "__stack-auto-translation-304": "您的团队邀请链接已过期。请申请新的团队邀请链接",
    "__stack-auto-translation-31": "更改团队显示名称",
    "__stack-auto-translation-32": "选择套餐",
    "__stack-auto-translation-33": "选择您想要接收的电子邮件",
    "__stack-auto-translation-34": "CLI 授权成功",
    "__stack-auto-translation-35": "点击此处",
    "__stack-auto-translation-36": "点击下方按钮重新发送验证链接。",
    "__stack-auto-translation-37": "关闭",
    "__stack-auto-translation-38": "完成设置",
    "__stack-auto-translation-39": "完成账户设置",
    "__stack-auto-translation-4": "活跃套餐",
    "__stack-auto-translation-40": "确认",
    "__stack-auto-translation-41": "继续",
    "__stack-auto-translation-42": "将其复制到安全的地方。您将无法再次查看它。",
    "__stack-auto-translation-43": "无法裁剪图片。",
    "__stack-auto-translation-44": "创建",
    "__stack-auto-translation-45": "创建新账户",
    "__stack-auto-translation-46": "创建团队",
    "__stack-auto-translation-47": "创建团队",
    "__stack-auto-translation-48": "创建 API 密钥",
    "__stack-auto-translation-49": "积分包",
    "__stack-auto-translation-5": "活动会话",
    "__stack-auto-translation-50": "当前会话",
    "__stack-auto-translation-51": "当前团队",
    "__stack-auto-translation-52": "危险区域",
    "__stack-auto-translation-53": "日期",
    "__stack-auto-translation-54": "删除账户",
    "__stack-auto-translation-55": "删除账户",
    "__stack-auto-translation-56": "删除密钥",
    "__stack-auto-translation-57": "描述",
    "__stack-auto-translation-58": "描述是必需的",
    "__stack-auto-translation-59": "禁用",
    "__stack-auto-translation-6": "添加",
    "__stack-auto-translation-60": "禁用 MFA",
    "__stack-auto-translation-61": "禁用 OTP",
    "__stack-auto-translation-62": "显示名称",
    "__stack-auto-translation-63": "您要登录吗？",
    "__stack-auto-translation-64": "您想验证您的邮箱吗？",
    "__stack-auto-translation-65": "还没有账号？",
    "__stack-auto-translation-66": "不需要重置？",
    "__stack-auto-translation-67": "草稿",
    "__stack-auto-translation-68": "例如：开发环境、生产环境、CI/CD",
    "__stack-auto-translation-69": "邮箱",
    "__stack-auto-translation-7": "切换套餐前请先添加支付方式。",
    "__stack-auto-translation-70": "邮箱和密码",
    "__stack-auto-translation-71": "电子邮箱已存在",
    "__stack-auto-translation-72": "邮箱必填",
    "__stack-auto-translation-73": "邮箱管理在演示模式下不可用。",
    "__stack-auto-translation-74": "邮件已发送！",
    "__stack-auto-translation-75": "电子邮件",
    "__stack-auto-translation-76": "电子邮件和身份验证",
    "__stack-auto-translation-77": "启用 MFA",
    "__stack-auto-translation-78": "启用 OTP",
    "__stack-auto-translation-79": "启用通过魔法链接或发送到您的登录邮箱的一次性密码进行登录。",
    "__stack-auto-translation-8": "添加电子邮件",
    "__stack-auto-translation-80": "结束您的当前会话",
    "__stack-auto-translation-81": "为您的新团队输入显示名称",
    "__stack-auto-translation-82": "输入邮箱",
    "__stack-auto-translation-83": "输入您邮箱中的验证码",
    "__stack-auto-translation-84": "输入您身份验证应用中的六位数代码",
    "__stack-auto-translation-85": "输入您的邮箱",
    "__stack-auto-translation-86": "过期的魔法链接",
    "__stack-auto-translation-87": "密码重置链接已过期",
    "__stack-auto-translation-88": "过期的团队邀请链接",
    "__stack-auto-translation-89": "验证链接已过期",
    "__stack-auto-translation-9": "添加新密钥",
    "__stack-auto-translation-90": "到期",
    "__stack-auto-translation-91": "到期时间",
    "__stack-auto-translation-92": "无法授权 CLI 应用程序：",
    "__stack-auto-translation-93": "无法连接帐户",
    "__stack-auto-translation-94": "重置密码失败",
    "__stack-auto-translation-95": "密码重置失败。请重新申请密码重置链接",
    "__stack-auto-translation-96": "忘记密码？",
    "__stack-auto-translation-97": "返回主页",
    "__stack-auto-translation-98": "返回主页",
    "__stack-auto-translation-99": "这是您的 API 密钥。"
  } as const)),
  "zh-TW": new Map(typedEntries({
    "__stack-auto-translation-0": "-",
    "__stack-auto-translation-1": "命令列應用程序正在請求訪問您的帳戶。點擊下方按鈕以授權。",
    "__stack-auto-translation-10": "新增您的電子郵件地址",
    "__stack-auto-translation-100": "我了解我將無法再次查看此金鑰。",
    "__stack-auto-translation-101": "如果此電子郵件地址的使用者存在，一封電子郵件已發送到您的收件箱。請務必檢查您的垃圾郵件資料夾。",
    "__stack-auto-translation-102": "如果您沒有自動重新導向，",
    "__stack-auto-translation-103": "忽略",
    "__stack-auto-translation-104": "模擬身份",
    "__stack-auto-translation-105": "代碼不正確。請再試一次。",
    "__stack-auto-translation-106": "密碼不正確",
    "__stack-auto-translation-107": "驗證碼無效",
    "__stack-auto-translation-108": "無效的圖片",
    "__stack-auto-translation-109": "無效的魔法連結",
    "__stack-auto-translation-11": "已經有帳號了嗎？",
    "__stack-auto-translation-110": "無效的密碼重設連結",
    "__stack-auto-translation-111": "無效的團隊邀請連結",
    "__stack-auto-translation-112": "無效的 TOTP 代碼",
    "__stack-auto-translation-113": "無效的驗證連結",
    "__stack-auto-translation-114": "透過電子郵件邀請使用者加入您的團隊",
    "__stack-auto-translation-115": "邀請成員",
    "__stack-auto-translation-116": "邀請用戶",
    "__stack-auto-translation-117": "發票",
    "__stack-auto-translation-118": "發票",
    "__stack-auto-translation-119": "IP 位址",
    "__stack-auto-translation-12": "金額",
    "__stack-auto-translation-120": "加入",
    "__stack-auto-translation-121": "最後使用",
    "__stack-auto-translation-122": "離開",
    "__stack-auto-translation-123": "離開團隊",
    "__stack-auto-translation-124": "離開團隊",
    "__stack-auto-translation-125": "離開此團隊並移除您的團隊檔案",
    "__stack-auto-translation-126": "位置",
    "__stack-auto-translation-127": "魔法連結已被使用",
    "__stack-auto-translation-128": "管理訂閱和帳單使用的預設付款方式。",
    "__stack-auto-translation-129": "成員",
    "__stack-auto-translation-13": "發生未知錯誤",
    "__stack-auto-translation-130": "多重因素認證管理在演示模式下不可用。",
    "__stack-auto-translation-131": "缺少驗證資訊",
    "__stack-auto-translation-132": "多重要素驗證",
    "__stack-auto-translation-133": "多重要素驗證",
    "__stack-auto-translation-134": "目前已停用多重要素驗證。",
    "__stack-auto-translation-135": "目前已啟用多重要素驗證。",
    "__stack-auto-translation-136": "我的個人資料",
    "__stack-auto-translation-137": "名稱",
    "__stack-auto-translation-138": "從未",
    "__stack-auto-translation-139": "不允許註冊新帳戶",
    "__stack-auto-translation-14": "API 金鑰",
    "__stack-auto-translation-140": "新密碼",
    "__stack-auto-translation-141": "新密碼",
    "__stack-auto-translation-142": "未找到活動會話",
    "__stack-auto-translation-143": "未啟用任何身份驗證方法。",
    "__stack-auto-translation-144": "無預設付款方式",
    "__stack-auto-translation-145": "未設置顯示名稱",
    "__stack-auto-translation-146": "此訂閱沒有其他可用方案。",
    "__stack-auto-translation-147": "無待處理邀請",
    "__stack-auto-translation-148": "無團隊",
    "__stack-auto-translation-149": "尚無團隊",
    "__stack-auto-translation-15": "API 金鑰",
    "__stack-auto-translation-150": "未登入",
    "__stack-auto-translation-151": "通知",
    "__stack-auto-translation-152": "OAuth 提供者存取遭拒",
    "__stack-auto-translation-153": "舊密碼",
    "__stack-auto-translation-154": "一次性密碼",
    "__stack-auto-translation-155": "一次性購買",
    "__stack-auto-translation-156": "待付款",
    "__stack-auto-translation-157": "或繼續使用",
    "__stack-auto-translation-158": "其他工作階段",
    "__stack-auto-translation-159": "其他團隊",
    "__stack-auto-translation-16": "API 金鑰授予您帳戶的程式化存取權限。",
    "__stack-auto-translation-160": "一次性密碼管理在演示模式下不可用。",
    "__stack-auto-translation-161": "OTP 登入",
    "__stack-auto-translation-162": "已啟用 OTP 登入，目前無法停用，因為這是唯一的登入方式",
    "__stack-auto-translation-163": "目前已啟用 OTP/魔法連結登入。",
    "__stack-auto-translation-164": "待處理邀請",
    "__stack-auto-translation-165": "覆寫您在此團隊中的使用者顯示名稱",
    "__stack-auto-translation-166": "已付款",
    "__stack-auto-translation-167": "通行金鑰",
    "__stack-auto-translation-168": "通行金鑰管理在演示模式下不可用。",
    "__stack-auto-translation-169": "通行金鑰已註冊",
    "__stack-auto-translation-17": "API 金鑰提供對您團隊的程式化存取權限。",
    "__stack-auto-translation-170": "通行金鑰登入已啟用，目前無法停用，因為這是唯一的登入方式",
    "__stack-auto-translation-171": "密碼",
    "__stack-auto-translation-172": "密碼管理在演示模式下不可用。",
    "__stack-auto-translation-173": "密碼重設成功！",
    "__stack-auto-translation-174": "密碼不符合",
    "__stack-auto-translation-175": "付款方式",
    "__stack-auto-translation-176": "付款",
    "__stack-auto-translation-177": "永久刪除您的帳戶和所有相關資料",
    "__stack-auto-translation-178": "個人",
    "__stack-auto-translation-179": "請新增電子郵件地址以完成帳號設定。我們會寄送驗證郵件給您。",
    "__stack-auto-translation-18": "您確定要刪除您的帳戶嗎？此操作是不可逆的，並將刪除所有相關資料。",
    "__stack-auto-translation-180": "請檢查您的連結是否正確。如果您繼續遇到問題，請聯絡客戶支援。",
    "__stack-auto-translation-181": "請檢查您的電子郵件收件箱",
    "__stack-auto-translation-182": "請先完成帳號設定再加入團隊。",
    "__stack-auto-translation-183": "請再次確認您是否擁有正確的密碼重設連結。",
    "__stack-auto-translation-184": "請再次確認您是否有正確的團隊邀請連結。",
    "__stack-auto-translation-185": "請輸入團隊名稱",
    "__stack-auto-translation-186": "請輸入有效的電子郵件地址",
    "__stack-auto-translation-187": "請輸入有效的電子郵件地址",
    "__stack-auto-translation-188": "請輸入電子郵件地址",
    "__stack-auto-translation-189": "請輸入您的電子郵件",
    "__stack-auto-translation-19": "您確定要停用 OTP 登入嗎？您將無法再僅使用電子郵件進行登入。",
    "__stack-auto-translation-190": "請輸入您的舊密碼",
    "__stack-auto-translation-191": "請輸入您的密碼",
    "__stack-auto-translation-192": "請重複輸入您的密碼",
    "__stack-auto-translation-193": "請再試一次，如果問題仍然存在，請聯絡客戶支援。",
    "__stack-auto-translation-194": "請驗證您的電子郵件地址",
    "__stack-auto-translation-195": "請先驗證您的電子郵件",
    "__stack-auto-translation-196": "主要",
    "__stack-auto-translation-197": "專業版",
    "__stack-auto-translation-198": "個人頭像",
    "__stack-auto-translation-199": "註冊通行金鑰",
    "__stack-auto-translation-2": "帳戶設定",
    "__stack-auto-translation-20": "您確定要停用通行金鑰登入嗎？停用後您將無法再使用通行金鑰登入。",
    "__stack-auto-translation-200": "移除",
    "__stack-auto-translation-201": "續訂日期",
    "__stack-auto-translation-202": "重複新密碼",
    "__stack-auto-translation-203": "重複新密碼",
    "__stack-auto-translation-204": "重複密碼",
    "__stack-auto-translation-205": "重新發送驗證電子郵件",
    "__stack-auto-translation-206": "重設密碼",
    "__stack-auto-translation-207": "重設您的密碼",
    "__stack-auto-translation-208": "查看過往發票與收據。",
    "__stack-auto-translation-209": "撤銷",
    "__stack-auto-translation-21": "您確定要離開團隊嗎？",
    "__stack-auto-translation-210": "撤銷所有其他工作階段",
    "__stack-auto-translation-211": "儲存",
    "__stack-auto-translation-212": "請使用您的身份驗證器應用程式掃描此 QR 碼：",
    "__stack-auto-translation-213": "密鑰 API 金鑰",
    "__stack-auto-translation-214": "選擇同一產品線中的新方案。",
    "__stack-auto-translation-215": "發送電子郵件",
    "__stack-auto-translation-216": "發送電子郵件",
    "__stack-auto-translation-217": "發送驗證電子郵件",
    "__stack-auto-translation-218": "工作階段",
    "__stack-auto-translation-219": "為您的帳戶設定密碼",
    "__stack-auto-translation-22": "授權失敗",
    "__stack-auto-translation-220": "設為主要",
    "__stack-auto-translation-221": "設定密碼",
    "__stack-auto-translation-222": "設定密碼",
    "__stack-auto-translation-223": "設定",
    "__stack-auto-translation-224": "登入",
    "__stack-auto-translation-225": "登入",
    "__stack-auto-translation-226": "再次登入",
    "__stack-auto-translation-227": "登入或建立帳戶以加入團隊。",
    "__stack-auto-translation-228": "登入您的帳戶",
    "__stack-auto-translation-229": "使用通行金鑰登入",
    "__stack-auto-translation-23": "授權",
    "__stack-auto-translation-230": "以 {provider} 登入",
    "__stack-auto-translation-231": "登出",
    "__stack-auto-translation-232": "註冊",
    "__stack-auto-translation-233": "註冊",
    "__stack-auto-translation-234": "目前不開放新使用者註冊。",
    "__stack-auto-translation-235": "使用通行金鑰註冊",
    "__stack-auto-translation-236": "使用 {provider} 註冊",
    "__stack-auto-translation-237": "登入成功！",
    "__stack-auto-translation-238": "登入於 {time}",
    "__stack-auto-translation-239": "處理 OAuth 回調時出現錯誤：",
    "__stack-auto-translation-24": "授權命令列應用程式",
    "__stack-auto-translation-240": "狀態",
    "__stack-auto-translation-241": "停止使用於登入",
    "__stack-auto-translation-242": "訂閱",
    "__stack-auto-translation-243": "切換方案",
    "__stack-auto-translation-244": "團隊創建在演示模式下已停用",
    "__stack-auto-translation-245": "團隊創建功能未啟用",
    "__stack-auto-translation-246": "團隊顯示名稱",
    "__stack-auto-translation-247": "團隊邀請",
    "__stack-auto-translation-248": "團隊頭像",
    "__stack-auto-translation-249": "團隊使用者名稱",
    "__stack-auto-translation-25": "授權中...",
    "__stack-auto-translation-250": "團隊",
    "__stack-auto-translation-251": "CLI 應用程式已成功授權。您可以關閉此視窗並返回命令列。",
    "__stack-auto-translation-252": "該魔法連結已被使用過。此連結僅能使用一次。如果您需要再次登入，請重新申請一個新的魔法連結。",
    "__stack-auto-translation-253": "登入操作已被取消或拒絕。請重試。",
    "__stack-auto-translation-254": "使用者已經連接到另一個 OAuth 帳戶。您可能在 OAuth 提供者頁面上選擇了錯誤的帳戶嗎？",
    "__stack-auto-translation-255": "然後，輸入您的六位數MFA驗證碼：",
    "__stack-auto-translation-256": "這些是您目前登入的裝置。您可以撤銷存取權以結束工作階段。",
    "__stack-auto-translation-257": "此帳號已與其他使用者連結。請連結不同的帳號。",
    "__stack-auto-translation-258": "此電子郵件已被另一位使用者用於登入。",
    "__stack-auto-translation-259": "這是一個顯示名稱，不用於身份驗證",
    "__stack-auto-translation-26": "取消",
    "__stack-auto-translation-260": "這很可能是 Stack 的錯誤。請回報此問題。",
    "__stack-auto-translation-261": "此密碼重置連結已被使用。如果您需要再次重置密碼，請從登入頁面重新申請新的密碼重置連結。",
    "__stack-auto-translation-262": "此團隊邀請連結已被使用。",
    "__stack-auto-translation-263": "請新增已驗證的登入電子郵件以啟用 OTP 登入。",
    "__stack-auto-translation-264": "若要啟用通行金鑰登入，請新增已驗證的登入電子郵件。",
    "__stack-auto-translation-265": "請新增登入電子郵件以設定密碼。",
    "__stack-auto-translation-266": "切換主題",
    "__stack-auto-translation-267": "TOTP 多重要素驗證 QR 碼",
    "__stack-auto-translation-268": "重試",
    "__stack-auto-translation-269": "無法使用",
    "__stack-auto-translation-27": "取消訂閱",
    "__stack-auto-translation-270": "無法收款",
    "__stack-auto-translation-271": "未知",
    "__stack-auto-translation-272": "未驗證",
    "__stack-auto-translation-273": "更新密碼",
    "__stack-auto-translation-274": "更新密碼",
    "__stack-auto-translation-275": "更新付款方式",
    "__stack-auto-translation-276": "更新您的密碼",
    "__stack-auto-translation-277": "上傳您團隊的圖像",
    "__stack-auto-translation-278": "上傳您自己的圖像作為頭像",
    "__stack-auto-translation-279": "用於登入",
    "__stack-auto-translation-28": "取消後將停止此訂閱的未來續訂。",
    "__stack-auto-translation-280": "用於登入",
    "__stack-auto-translation-281": "已使用的密碼重設連結",
    "__stack-auto-translation-282": "已使用的團隊邀請連結",
    "__stack-auto-translation-283": "使用者",
    "__stack-auto-translation-284": "使用者名稱",
    "__stack-auto-translation-285": "驗證失敗",
    "__stack-auto-translation-286": "已驗證！正在重定向...",
    "__stack-auto-translation-287": "驗證",
    "__stack-auto-translation-288": "驗證中...",
    "__stack-auto-translation-289": "檢視",
    "__stack-auto-translation-29": "變更",
    "__stack-auto-translation-290": "檢視您的有效方案與購買項目。",
    "__stack-auto-translation-291": "作廢",
    "__stack-auto-translation-292": "警告：請確保您信任該命令行應用程式，因為它將獲取您帳戶的訪問權限。如果您沒有發起此請求，您可以關閉此頁面並忽略它。我們絕不會通過電子郵件或其他方式向您發送此連結。",
    "__stack-auto-translation-293": "您已經登入",
    "__stack-auto-translation-294": "您目前尚未登入。",
    "__stack-auto-translation-295": "您無法移除最後一個用於登入的電子郵件",
    "__stack-auto-translation-296": "您無法撤銷目前工作階段",
    "__stack-auto-translation-297": "您的電子郵件已驗證！",
    "__stack-auto-translation-298": "您尚未完成帳戶設置。如果您認為這是錯誤，請聯繫支援團隊。",
    "__stack-auto-translation-299": "您的電子郵件",
    "__stack-auto-translation-3": "帳戶設定",
    "__stack-auto-translation-30": "變更方案",
    "__stack-auto-translation-300": "您的電子郵件驗證連結已過期。請從您的帳戶設定中請求新的驗證連結。",
    "__stack-auto-translation-301": "您的魔法連結已過期。如果您需要登入，請重新申請新的魔法連結。",
    "__stack-auto-translation-302": "您的密碼已重設。您現在可以使用新密碼登入。",
    "__stack-auto-translation-303": "您的密碼重設連結已過期。請從登入頁面重新申請新的密碼重設連結。",
    "__stack-auto-translation-304": "您的團隊邀請連結已過期。請重新申請新的團隊邀請連結",
    "__stack-auto-translation-31": "更改團隊的顯示名稱",
    "__stack-auto-translation-32": "選擇方案",
    "__stack-auto-translation-33": "選擇您想接收的電子郵件",
    "__stack-auto-translation-34": "CLI 授權成功",
    "__stack-auto-translation-35": "點擊這裡",
    "__stack-auto-translation-36": "點擊下方按鈕重新發送驗證連結。",
    "__stack-auto-translation-37": "關閉",
    "__stack-auto-translation-38": "完成設定",
    "__stack-auto-translation-39": "完成帳號設定",
    "__stack-auto-translation-4": "有效方案",
    "__stack-auto-translation-40": "確認",
    "__stack-auto-translation-41": "繼續",
    "__stack-auto-translation-42": "將其複製到安全的地方。你將無法再次查看它。",
    "__stack-auto-translation-43": "無法裁剪圖片。",
    "__stack-auto-translation-44": "建立",
    "__stack-auto-translation-45": "建立新帳戶",
    "__stack-auto-translation-46": "建立團隊",
    "__stack-auto-translation-47": "建立團隊",
    "__stack-auto-translation-48": "建立 API 金鑰",
    "__stack-auto-translation-49": "點數包",
    "__stack-auto-translation-5": "活動會話",
    "__stack-auto-translation-50": "目前工作階段",
    "__stack-auto-translation-51": "目前團隊",
    "__stack-auto-translation-52": "危險區域",
    "__stack-auto-translation-53": "日期",
    "__stack-auto-translation-54": "刪除帳號",
    "__stack-auto-translation-55": "刪除帳戶",
    "__stack-auto-translation-56": "刪除通行金鑰",
    "__stack-auto-translation-57": "描述",
    "__stack-auto-translation-58": "必須填寫描述",
    "__stack-auto-translation-59": "停用",
    "__stack-auto-translation-6": "新增",
    "__stack-auto-translation-60": "停用 MFA",
    "__stack-auto-translation-61": "停用 OTP",
    "__stack-auto-translation-62": "顯示名稱",
    "__stack-auto-translation-63": "您要登入嗎？",
    "__stack-auto-translation-64": "您要驗證您的電子郵件嗎？",
    "__stack-auto-translation-65": "還沒有帳戶嗎？",
    "__stack-auto-translation-66": "不需要重設密碼嗎？",
    "__stack-auto-translation-67": "草稿",
    "__stack-auto-translation-68": "例如：開發、生產、CI/CD",
    "__stack-auto-translation-69": "電子郵件",
    "__stack-auto-translation-7": "切換方案前請先新增付款方式。",
    "__stack-auto-translation-70": "電郵與密碼",
    "__stack-auto-translation-71": "電子郵件已存在",
    "__stack-auto-translation-72": "電子郵件為必填",
    "__stack-auto-translation-73": "電子郵件管理在演示模式下不可用。",
    "__stack-auto-translation-74": "電子郵件已發送！",
    "__stack-auto-translation-75": "電子郵件",
    "__stack-auto-translation-76": "電子郵件與驗證",
    "__stack-auto-translation-77": "啟用多重要素身份驗證",
    "__stack-auto-translation-78": "啟用 OTP",
    "__stack-auto-translation-79": "啟用透過魔法連結或發送到您的登入電子郵件的一次性密碼進行登入。",
    "__stack-auto-translation-8": "新增電子郵件",
    "__stack-auto-translation-80": "結束您的目前工作階段",
    "__stack-auto-translation-81": "輸入您新團隊的顯示名稱",
    "__stack-auto-translation-82": "輸入電子郵件",
    "__stack-auto-translation-83": "輸入您電子郵件中的驗證碼",
    "__stack-auto-translation-84": "請輸入您身份驗證應用程式中的六位數代碼",
    "__stack-auto-translation-85": "輸入您的電子郵件",
    "__stack-auto-translation-86": "已過期的魔法連結",
    "__stack-auto-translation-87": "密碼重設連結已過期",
    "__stack-auto-translation-88": "已過期的團隊邀請連結",
    "__stack-auto-translation-89": "驗證連結已過期",
    "__stack-auto-translation-9": "新增通行金鑰",
    "__stack-auto-translation-90": "到期",
    "__stack-auto-translation-91": "到期時間",
    "__stack-auto-translation-92": "無法授權命令列應用程式：",
    "__stack-auto-translation-93": "帳戶連接失敗",
    "__stack-auto-translation-94": "重設密碼失敗",
    "__stack-auto-translation-95": "重設密碼失敗。請重新申請密碼重設連結",
    "__stack-auto-translation-96": "忘記密碼？",
    "__stack-auto-translation-97": "回首頁",
    "__stack-auto-translation-98": "回首頁",
    "__stack-auto-translation-99": "這是您的 API 金鑰。"
  } as const)),
} as const));
